/*
export const error = [
  {
    "dep_seq": "",
    "entities": [],
    "id": 0,
    "label_seq": "O O O O O O O O O O O O O O",
    "pos_seq": "DT JJ JJ NN VBZ IN DT CD NNS MD VB IN NNP .",
    "status": "false",
    "text": "The entire international community recognizes that the four islands should belong to Russia ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 1,
    "label_seq": "O O O O O O O O O O O O O O O",
    "pos_seq": "DT NNP HYPH NNP NN VBZ RB VBN CC DT JJ NNS RB VBN .",
    "status": "false",
    "text": "The Hart - Scott filing is then reviewed and any antitrust concerns usually met ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 2,
    "label_seq": "O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NFP DT NN MD VB IN NN , IN DT RBS JJ NNS VBP VBG VBN RB NNP .",
    "status": "false",
    "text": "-LRB- The average should drop over time , since the most expensive claims are being settled first -RRB- ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 3,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN DT NN POS NNS , JJ JJ JJ NNS IN NN CC JJ NN VBP VBN RP IN DT JJ NN IN NNS , VBG DT JJ NNS IN JJ NNS IN DT JJ , JJ NN IN JJ HYPH NN JJ",
    "status": "false",
    "text": "In the enclave 's restaurants , such classic Macanese dishes as curry and Portuguese chicken are served up with a wide variety of seasonings , blending the sweet flavors of Cantonese dishes with the rich , tangy taste of old-style Indian fare ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 4,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "PRP VBZ RB JJ TO VB DT IN DT JJ NNS WP RB VBP DT RB VBN JJ NN RP IN PRP$ NN NN NNP VBZ RB IN DT NN POS RBS JJ .",
    "status": "false",
    "text": "It 's almost humorous to hear some of the same people who regularly mock the so called elite point out that her law school SMU is not among the nation 's most respected /."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 5,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "RBR RB , PRP VBD VBD JJ IN NNP NNP DT NNP CC DT NNP HYPH CD NNP , DT NN IN NNP NNP IN DT NN IN JJ NN . PRP$ JJS NN , NNPS IN DT NNP , DT NN IN NNP JJ NNS CC NN IN DT NNP NNP CC NNP NNP IN DT JJ JJ HYPH NN , MD VB VBN IN CD IN",
    "status": "false",
    "text": "More recently , he co-authored with Sally Denton The Money and the Power -LSB- 4 -RSB- , a history of Las Vegas as the paradigm of national corruption . His latest work , Shadows of the Eagle , a history of U.S. covert interventions and policy in the Middle East and South Asia over the past half - century , will be published in 2007 by Knopf ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 6,
    "label_seq": "O O O O O O O O O O O O O",
    "pos_seq": "CC PRP MD RB VB CD NNS CC CD NNS , RB .",
    "status": "false",
    "text": "But they could not exceed five shares and ten shares , respectively ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 7,
    "label_seq": "O O O O O O O O O O O",
    "pos_seq": "NNP HYPH NNP VBZ VBN IN NNP NNP , NNP .",
    "status": "false",
    "text": "Hewlett - Packard is based in Palo Alto , Calif ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 8,
    "label_seq": "O O O O O O O O O O O",
    "pos_seq": "IN VBN DT NN , NNP NNS VBD DT NN .",
    "status": "false",
    "text": "Though provided no evidence , Fatah officials denied the link ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 9,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT RB JJ NN IN NNP , WP$ NNS VBP NN NNS HYPH NN NNS , VBD IN IN CD CC CD '' '' NN CC NN '' IN JJ NNS VBD CD NNS $ CD CD",
    "status": "false",
    "text": "An admittedly limited survey by NASAA , whose members are state securities - law regulators , found that between 1986 and 1988 `` fraud and abuse '' by financial planners cost 22,000 investors $ 400 million ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 10,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP NNP VBD DT RBS JJ NN TO VB RP NN HYPH NN NN NN IN PRP$ JJ NN , CC NNP NNP JJ NN VBD DT JJ NN IN VBG DT NN NN RB IN PRP$ NNS .",
    "status": "false",
    "text": "Kidder Peabody became the most recent firm to swear off stock - index arbitrage trading for its own account , and Merrill Lynch late yesterday took the major step of renouncing the trading strategy even for its clients ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 11,
    "label_seq": "O O O O",
    "pos_seq": "VBP PRP NNP .",
    "status": "false",
    "text": "Thank you Larry /."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 12,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NN NN RB MD VB NNS TO VB DT NN IN CD NN IN DT NN IN NNP NNP , NNP CC NNP NNP POS NN NN .",
    "status": "false",
    "text": "The equity arrangement apparently would allow bondholders to buy a total of 10 % of the stock of CNW Corp. , Chicago & North Western 's parent company ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 13,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP VBZ VBN JJ NNS , NNS CC NNS IN PRP$ NNS IN JJ NNS , CC DT NN VBZ RB VBN IN DT RB HYPH JJ NN NN CC VBD PRP$ JJ NNS IN NNS .",
    "status": "false",
    "text": "Turner has made several movies , docudramas and documentaries for its networks in recent years , but the company has never acted as a full - fledged movie studio and released its own pictures to theaters ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 14,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN NN , DT NNP NNP NNP , WDT VBZ DT NN IN DT NN , VBZ RB VBN DT NN NN IN CD CD NNS IN NN , WDT VBZ JJ NN IN RB VBG DT NNP NNP NN .",
    "status": "false",
    "text": "At present , the Pu Kang Company , which produces the vaccine in this zone , has already formed a production scale of 5 million doses per year , which has great significance in effectively controlling the hepatitis A epidemic ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 15,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NN VBD RP IN CD IN NNS IN NNP POS NNP NNP VBD DT JJ , JJ NN IN NN NN .",
    "status": "false",
    "text": "The field took off in 1985 after scientists at Britain 's Sheffield University developed a handy , compact magnet for brain stimulation ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 16,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "PRP VBD , DT NN CC NN IN NNP VBD JJ IN NN NN CC NN , CC IN DT NN CC NN IN NNP VBD DT JJ NN IN DT NN CC NN IN NNP .",
    "status": "false",
    "text": "He said , the stability and development of China was beneficial to world peace and development , and that the prosperity and stability of China was the basic guarantee for the prosperity and stability of Macao ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 17,
    "label_seq": "O O O O O O O O O O O O O O O O O O",
    "pos_seq": "UH IN JJ NN PRP VBD VBN IN DT NN IN VBG NNP NNP IN DT NN .",
    "status": "false",
    "text": "Well in middle school he got suspended for a year for stabbing Mr. Steele with a pencil /."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 18,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "RB NNP VBZ TO VB IN DT NN IN JJ NN , CC PRP MD RB VB DT NN RB .",
    "status": "false",
    "text": "Currently Russia seems to be in a period of low tide , but it wo n't stay this way forever ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 19,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "RB NNS VBP VBN VBG IN JJ NNPS IN NNP NNP : CC IN JJ IN NNP CC NNP , VBP VBG RP DT NN IN DT JJ NN NN .",
    "status": "false",
    "text": "Now people have started wondering if overseas Chinese from Southeast Asia - and in particular from Singapore and Malaysia - are taking over the mainstream of the Taiwanese music industry ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 20,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN NNP , CC RB NNP NNP , NNP NNP VBZ VBN IN PRP$ NN IN JJ JJ NN IN DT NNS VBZ RB DT NN IN '' '' VB PRP JJ .",
    "status": "false",
    "text": "Like Brecht , and indeed Ezra Pound , Ms. Bogart has said that her intent in such manipulative staging of the classics is simply an attempt to `` make it new . ''"
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 21,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "PRP CC PRP , PRP VBZ JJ IN PRP VBD IN DT NN IN IN PRP$ NN PRP VBZ DT RBS JJ NN WDT VBD IN DT NN IN DT NNS IN DT JJ NN NN .",
    "status": "false",
    "text": "Me or you , it is good that you started with this question because in my opinion it is the most important thing that appeared in the newspaper in the headlines in the Hebrew press today ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 22,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NNP NN NN VBD VBN IN DT NN IN NN CC NN , VBN RB IN DT VBG NNS CC VBG NNS .",
    "status": "false",
    "text": "The May 20th inaugural was accompanied by an air of excitement and rejoicing , accented nicely by the flying pennants and milling crowds ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 23,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NN , WDT VBD JJ NN CC VBZ IN NNP CD , IN NNS VBN IN CC DT NN CC NNP , '' '' VBD NNP POS NN , '' DT NN VBZ",
    "status": "false",
    "text": "The campaign , which started last week and runs through Nov. 23 , with funds earmarked for both the quake and Hugo , `` was Barry 's idea , '' a spokeswoman says ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 24,
    "label_seq": "O O O O O O O",
    "pos_seq": "NNP NNP IN NNP NNP NNP .",
    "status": "false",
    "text": "Jeff Morris in Socrates New York /."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 25,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT VBZ DT NN : JJ NNS IN CD JJ NNS VBP VBG VBN RB IN JJ NN TO VB DT NNP VB PRP$ NNS IN NN , NN NN , CC NN IN NNS .",
    "status": "false",
    "text": "This is the year : Unsuspecting filers of 1988 personal returns are being picked randomly for thorough audits to help the IRS update its criteria for enforcement , audit selection , and use of resources ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 26,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NNS TO VB IN DT NNS WP VBP VBN , VB TO VB PRP : IN PRP MD RB VB VBN , IN JJS TO VB PRP : TO VB NNS , TO RB VB NN IN NNS IN NNS WP VBP JJ NNS CC JJ NNS , TO VB DT NN IN DT JJ : DT IN DT NNS PRP VBP VBP RB JJ .",
    "status": "false",
    "text": "The efforts to get to the people who are addicted , try to rehabilitate them ; if they can not be rehabilitated , at least to contain them ; to educate people , to strongly discourage use of drugs by people who are casual users and first users , to stop this process among the young -- all of these things I think are extremely important ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 27,
    "label_seq": "O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP VBZ DT NN IN NNP WDT MD VB RP IN NN NNS IN NNP VBD VBN .",
    "status": "false",
    "text": "ARCO maintains an office in Dallas that would take over if payroll operations in Pasadena were disrupted ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 28,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP NNP NNP NNP VBD PRP VBZ TO VB RB JJ IN CD JJ NNS IN PRP$ CD NN HYPH VBN NNP NNP NNP NN IN JJ , JJ HYPH NN NNS .",
    "status": "false",
    "text": "National Patent Development Corp. said it plans to purchase as many as 200,000 common shares of its 81 % - controlled Interferon Sciences Inc. unit in periodic , open - market purchases ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 29,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "CC JJ HYPH NN , JJ HYPH NN NNS VBD CD TO CD NN IN DT NN NN RB IN DT NN CC RB VBD .",
    "status": "false",
    "text": "But high - yield , high - risk bonds fell 1/4 to 1/2 point with the stock market early in the session and never recovered ."
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 30,
    "label_seq": "O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "PRP VBZ IN `` '' PRP VBD JJ IN DT NN IN NNS CC DT NNP NNP NNP .",
    "status": "false",
    "text": "He adds that `` they were aware of the propensity for earthquakes and the San Andreas Fault . ''"
  },
  {
    "dep_seq": "",
    "entities": [],
    "id": 31,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NN IN DT NN HYPH IN HYPH VBN HYPH NN HYPH NN MD VB VBG PRP , IN DT JJ NN IN PRP$ NNS VBP VBN TO VB JJ NNS , IN NN IN NN CD .",
    "status": "false",
    "text": "The idea of a child - as - required - yuppie - possession must be motivating them , since the wealthy offspring of their friends are shown to be rude brats , in therapy by age five ."
  }
]
*/

export const relationExtractionData = [
  {
    "sentence": "Barack Obama is the President of USA.",
    "sets": [
      {
        id: 'dummy2',
        "entity_1": {
          "word": "Barack Obama",
          "position": [
            0,
            11
          ]
        },
        "entity_2": {
          "word": "USA",
          "position": [
            33,
            35
          ]
        },
        "relation": {
          "word": "President",
          "position": [
            20,
            28
          ]
        }
      }
    ]
  },
  {
    "sentence": "Narendra Modi, a member of BJP is the Prime Minister of India",
    "sets": [
      {
        id: 'dummy',
        "entity_1": {
          "word": "Narendra Modi",
          "position": [
            0,
            12
          ]
        },
        "entity_2": {
          "word": "BJP",
          "position": [
            27,
            29
          ]
        },
        "relation": {
          "word": "member",
          "position": [
            17,
            22
          ]
        }
      },
      {
        id: 'poporo',
        "entity_1": {
          "word": "Narendra Modi",
          "position": [
            0,
            12
          ]
        },
        "entity_2": {
          "word": "India",
          "position": [
            56,
            60
          ]
        },
        "relation": {
          "word": "Prime Minister",
          "position": [
            38,
            51
          ]
        }
      }
    ]
  },
  {
    "sentence": "Bill Gates is the founder of Microsoft.",
    "sets": [
      {
        id: 'asdad234',
        "entity_1": {
          "word": "Bill Gates",
          "position": [
            0,
            9
          ]
        },
        "entity_2": {
          "word": "Microsoft",
          "position": [
            29,
            37
          ]
        },
        "relation": {
          "word": "founder",
          "position": [
            18,
            24
          ]
        }
      }
    ]
  }
];

export const realCoRefData = [
  {
    "sentences": [
      [
        "Barack",
        "Hussein",
        "Obama",
        "II",
        "(",
        "born",
        "August",
        "4",
        ",",
        "1961",
        ")",
        "is",
        "an",
        "American",
        "attorney",
        "and",
        "politician",
        "who",
        "served",
        "as",
        "the",
        "44th",
        "president",
        "of",
        "the",
        "United",
        "States",
        "from",
        "2009",
        "to",
        "2017",
        "."
      ],
      [
        "A",
        "member",
        "of",
        "the",
        "Democratic",
        "Party",
        ",",
        "he",
        "was",
        "the",
        "first",
        "African",
        "American",
        "to",
        "be",
        "elected",
        "to",
        "the",
        "presidency",
        "."
      ],
      [
        "He",
        "previously",
        "served",
        "as",
        "a",
        "U.S.",
        "senator",
        "from",
        "Illinois",
        "from",
        "2005",
        "to",
        "2008",
        "and",
        "an",
        "Illinois",
        "state",
        "senator",
        "from",
        "1997",
        "to",
        "2004",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            10
          ],
          [
            39,
            39
          ],
          [
            52,
            52
          ]
        ],
        "sequences": [
          [
            "Barack",
            "Hussein",
            "Obama",
            "II",
            "(",
            "born",
            "August",
            "4",
            ",",
            "1961",
            ")"
          ],
          [
            "he"
          ],
          [
            "He"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON",
            "I-PERSON",
            "I-PERSON",
            "O",
            "O",
            "B-DATE",
            "I-DATE",
            "I-DATE",
            "I-DATE",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279793.126679B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279793.126666A",
            "sequences": [
              "Barack",
              "Hussein",
              "Obama",
              "II",
              "(",
              "born",
              "August",
              "4",
              ",",
              "1961",
              ")"
            ],
            "positions": [
              0,
              10
            ]
          },
          {
            "id": "1571279793.126675A",
            "sequences": [
              "he"
            ],
            "positions": [
              39,
              39
            ]
          },
          {
            "id": "1571279793.126677A",
            "sequences": [
              "He"
            ],
            "positions": [
              52,
              52
            ]
          }
        ]
      },
      {
        "positions": [
          [
            60,
            60
          ],
          [
            67,
            67
          ]
        ],
        "sequences": [
          [
            "Illinois"
          ],
          [
            "Illinois"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279793.12669B",
        "main_words": [
          "Illinois"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            60,
            60
          ],
          [
            67,
            67
          ]
        ],
        "words": [
          {
            "id": "1571279793.126687A",
            "sequences": [
              "Illinois"
            ],
            "positions": [
              60,
              60
            ]
          },
          {
            "id": "1571279793.126689A",
            "sequences": [
              "Illinois"
            ],
            "positions": [
              67,
              67
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "I-GPE",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "B-NORP",
      "I-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O"
    ],
    "doc_tokens": [
      "Barack",
      "Hussein",
      "Obama",
      "II",
      "(",
      "born",
      "August",
      "4",
      ",",
      "1961",
      ")",
      "is",
      "an",
      "American",
      "attorney",
      "and",
      "politician",
      "who",
      "served",
      "as",
      "the",
      "44th",
      "president",
      "of",
      "the",
      "United",
      "States",
      "from",
      "2009",
      "to",
      "2017",
      ".",
      "A",
      "member",
      "of",
      "the",
      "Democratic",
      "Party",
      ",",
      "he",
      "was",
      "the",
      "first",
      "African",
      "American",
      "to",
      "be",
      "elected",
      "to",
      "the",
      "presidency",
      ".",
      "He",
      "previously",
      "served",
      "as",
      "a",
      "U.S.",
      "senator",
      "from",
      "Illinois",
      "from",
      "2005",
      "to",
      "2008",
      "and",
      "an",
      "Illinois",
      "state",
      "senator",
      "from",
      "1997",
      "to",
      "2004",
      "."
    ],
    "complete_sentence": "Barack Hussein Obama II ( born August 4 , 1961 ) is an American attorney and politician who served as the 44th president of the United States from 2009 to 2017 . A member of the Democratic Party , he was the first African American to be elected to the presidency . He previously served as a U.S. senator from Illinois from 2005 to 2008 and an Illinois state senator from 1997 to 2004 ."
  },
  {
    "sentences": [
      [
        "Obama",
        "was",
        "born",
        "in",
        "Honolulu",
        ",",
        "Hawaii",
        "."
      ],
      [
        "After",
        "graduating",
        "from",
        "Columbia",
        "University",
        "in",
        "1983",
        ",",
        "he",
        "worked",
        "as",
        "a",
        "community",
        "organizer",
        "in",
        "Chicago",
        "."
      ],
      [
        "In",
        "1988",
        ",",
        "he",
        "enrolled",
        "in",
        "Harvard",
        "Law",
        "School",
        ",",
        "where",
        "he",
        "was",
        "the",
        "first",
        "black",
        "president",
        "of",
        "the",
        "Harvard",
        "Law",
        "Review",
        "."
      ],
      [
        "After",
        "graduating",
        ",",
        "he",
        "became",
        "a",
        "civil",
        "rights",
        "attorney",
        "and",
        "an",
        "academic",
        ",",
        "teaching",
        "constitutional",
        "law",
        "at",
        "the",
        "University",
        "of",
        "Chicago",
        "Law",
        "School",
        "from",
        "1992",
        "to",
        "2004",
        "."
      ],
      [
        "He",
        "represented",
        "the",
        "13th",
        "district",
        "for",
        "three",
        "terms",
        "in",
        "the",
        "Illinois",
        "Senate",
        "from",
        "1997",
        "until",
        "2004",
        ",",
        "when",
        "he",
        "ran",
        "for",
        "the",
        "U.S.",
        "Senate",
        "."
      ],
      [
        "He",
        "received",
        "national",
        "attention",
        "in",
        "2004",
        "with",
        "his",
        "March",
        "primary",
        "win",
        ",",
        "his",
        "well",
        "-",
        "received",
        "July",
        "Democratic",
        "National",
        "Convention",
        "keynote",
        "address",
        ",",
        "and",
        "his",
        "landslide",
        "November",
        "election",
        "to",
        "the",
        "Senate",
        "."
      ],
      [
        "In",
        "2008",
        ",",
        "he",
        "was",
        "nominated",
        "for",
        "president",
        "a",
        "year",
        "after",
        "his",
        "campaign",
        "began",
        ",",
        "after",
        "a",
        "close",
        "primary",
        "campaign",
        "against",
        "Hillary",
        "Clinton",
        "."
      ],
      [
        "He",
        "was",
        "elected",
        "over",
        "Republican",
        "John",
        "McCain",
        "and",
        "was",
        "inaugurated",
        "on",
        "January",
        "20",
        ",",
        "2009",
        "."
      ],
      [
        "Nine",
        "months",
        "later",
        ",",
        "he",
        "was",
        "named",
        "the",
        "2009",
        "Nobel",
        "Peace",
        "Prize",
        "laureate",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            16,
            16
          ],
          [
            28,
            28
          ],
          [
            36,
            36
          ],
          [
            51,
            51
          ],
          [
            76,
            76
          ],
          [
            94,
            94
          ],
          [
            101,
            101
          ],
          [
            108,
            108
          ],
          [
            113,
            113
          ],
          [
            125,
            125
          ],
          [
            136,
            136
          ],
          [
            144,
            144
          ],
          [
            157,
            157
          ],
          [
            177,
            177
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "He"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279794.786592B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            0
          ]
        ],
        "words": [
          {
            "id": "1571279794.78657A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279794.786576A",
            "sequences": [
              "he"
            ],
            "positions": [
              16,
              16
            ]
          },
          {
            "id": "1571279794.786578A",
            "sequences": [
              "he"
            ],
            "positions": [
              28,
              28
            ]
          },
          {
            "id": "1571279794.786579A",
            "sequences": [
              "he"
            ],
            "positions": [
              36,
              36
            ]
          },
          {
            "id": "1571279794.78658A",
            "sequences": [
              "he"
            ],
            "positions": [
              51,
              51
            ]
          },
          {
            "id": "1571279794.786581A",
            "sequences": [
              "He"
            ],
            "positions": [
              76,
              76
            ]
          },
          {
            "id": "1571279794.786582A",
            "sequences": [
              "he"
            ],
            "positions": [
              94,
              94
            ]
          },
          {
            "id": "1571279794.786583A",
            "sequences": [
              "He"
            ],
            "positions": [
              101,
              101
            ]
          },
          {
            "id": "1571279794.786584A",
            "sequences": [
              "his"
            ],
            "positions": [
              108,
              108
            ]
          },
          {
            "id": "1571279794.786586A",
            "sequences": [
              "his"
            ],
            "positions": [
              113,
              113
            ]
          },
          {
            "id": "1571279794.786587A",
            "sequences": [
              "his"
            ],
            "positions": [
              125,
              125
            ]
          },
          {
            "id": "1571279794.786588A",
            "sequences": [
              "he"
            ],
            "positions": [
              136,
              136
            ]
          },
          {
            "id": "1571279794.786589A",
            "sequences": [
              "his"
            ],
            "positions": [
              144,
              144
            ]
          },
          {
            "id": "1571279794.78659A",
            "sequences": [
              "He"
            ],
            "positions": [
              157,
              157
            ]
          },
          {
            "id": "1571279794.786591A",
            "sequences": [
              "he"
            ],
            "positions": [
              177,
              177
            ]
          }
        ]
      },
      {
        "positions": [
          [
            74,
            74
          ],
          [
            91,
            91
          ],
          [
            106,
            106
          ],
          [
            134,
            134
          ],
          [
            171,
            171
          ]
        ],
        "sequences": [
          [
            "2004"
          ],
          [
            "2004"
          ],
          [
            "2004"
          ],
          [
            "2008"
          ],
          [
            "2009"
          ]
        ],
        "ner_sequences": [
          [
            "I-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "I-DATE"
          ]
        ],
        "flags": -1,
        "id": "1571279794.786609B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279794.786603A",
            "sequences": [
              "2004"
            ],
            "positions": [
              74,
              74
            ]
          },
          {
            "id": "1571279794.786604A",
            "sequences": [
              "2004"
            ],
            "positions": [
              91,
              91
            ]
          },
          {
            "id": "1571279794.786606A",
            "sequences": [
              "2004"
            ],
            "positions": [
              106,
              106
            ]
          },
          {
            "id": "1571279794.786607A",
            "sequences": [
              "2008"
            ],
            "positions": [
              134,
              134
            ]
          },
          {
            "id": "1571279794.786608A",
            "sequences": [
              "2009"
            ],
            "positions": [
              171,
              171
            ]
          }
        ]
      },
      {
        "main_words": [
          "the U.S. Senate"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              97,
              99
            ]
          ]
        ],
        "positions": [
          [
            97,
            99
          ],
          [
            130,
            131
          ]
        ],
        "sequences": [
          [
            "the",
            "U.S.",
            "Senate"
          ],
          [
            "the",
            "Senate"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "O",
            "B-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279795.03768B",
        "words": [
          {
            "id": "1571279795.037729A",
            "sequences": [
              "the",
              "U.S.",
              "Senate"
            ],
            "positions": [
              97,
              99
            ]
          },
          {
            "id": "1571279795.037739A",
            "sequences": [
              "the",
              "Senate"
            ],
            "positions": [
              130,
              131
            ]
          }
        ]
      },
      {
        "main_words": [
          "the Illinois Senate"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              85,
              87
            ]
          ]
        ],
        "positions": [
          [
            85,
            87
          ]
        ],
        "sequences": [
          [
            "the",
            "Illinois",
            "Senate"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279795.037708B",
        "words": [
          {
            "id": "1571279795.037748A",
            "sequences": [
              "the",
              "Illinois",
              "Senate"
            ],
            "positions": [
              85,
              87
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "B-ORG",
      "I-EVENT",
      "I-EVENT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "B-WORK_OF_ART",
      "I-WORK_OF_ART",
      "I-WORK_OF_ART",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "was",
      "born",
      "in",
      "Honolulu",
      ",",
      "Hawaii",
      ".",
      "After",
      "graduating",
      "from",
      "Columbia",
      "University",
      "in",
      "1983",
      ",",
      "he",
      "worked",
      "as",
      "a",
      "community",
      "organizer",
      "in",
      "Chicago",
      ".",
      "In",
      "1988",
      ",",
      "he",
      "enrolled",
      "in",
      "Harvard",
      "Law",
      "School",
      ",",
      "where",
      "he",
      "was",
      "the",
      "first",
      "black",
      "president",
      "of",
      "the",
      "Harvard",
      "Law",
      "Review",
      ".",
      "After",
      "graduating",
      ",",
      "he",
      "became",
      "a",
      "civil",
      "rights",
      "attorney",
      "and",
      "an",
      "academic",
      ",",
      "teaching",
      "constitutional",
      "law",
      "at",
      "the",
      "University",
      "of",
      "Chicago",
      "Law",
      "School",
      "from",
      "1992",
      "to",
      "2004",
      ".",
      "He",
      "represented",
      "the",
      "13th",
      "district",
      "for",
      "three",
      "terms",
      "in",
      "the",
      "Illinois",
      "Senate",
      "from",
      "1997",
      "until",
      "2004",
      ",",
      "when",
      "he",
      "ran",
      "for",
      "the",
      "U.S.",
      "Senate",
      ".",
      "He",
      "received",
      "national",
      "attention",
      "in",
      "2004",
      "with",
      "his",
      "March",
      "primary",
      "win",
      ",",
      "his",
      "well",
      "-",
      "received",
      "July",
      "Democratic",
      "National",
      "Convention",
      "keynote",
      "address",
      ",",
      "and",
      "his",
      "landslide",
      "November",
      "election",
      "to",
      "the",
      "Senate",
      ".",
      "In",
      "2008",
      ",",
      "he",
      "was",
      "nominated",
      "for",
      "president",
      "a",
      "year",
      "after",
      "his",
      "campaign",
      "began",
      ",",
      "after",
      "a",
      "close",
      "primary",
      "campaign",
      "against",
      "Hillary",
      "Clinton",
      ".",
      "He",
      "was",
      "elected",
      "over",
      "Republican",
      "John",
      "McCain",
      "and",
      "was",
      "inaugurated",
      "on",
      "January",
      "20",
      ",",
      "2009",
      ".",
      "Nine",
      "months",
      "later",
      ",",
      "he",
      "was",
      "named",
      "the",
      "2009",
      "Nobel",
      "Peace",
      "Prize",
      "laureate",
      "."
    ],
    "complete_sentence": "Obama was born in Honolulu , Hawaii . After graduating from Columbia University in 1983 , he worked as a community organizer in Chicago . In 1988 , he enrolled in Harvard Law School , where he was the first black president of the Harvard Law Review . After graduating , he became a civil rights attorney and an academic , teaching constitutional law at the University of Chicago Law School from 1992 to 2004 . He represented the 13th district for three terms in the Illinois Senate from 1997 until 2004 , when he ran for the U.S. Senate . He received national attention in 2004 with his March primary win , his well - received July Democratic National Convention keynote address , and his landslide November election to the Senate . In 2008 , he was nominated for president a year after his campaign began , after a close primary campaign against Hillary Clinton . He was elected over Republican John McCain and was inaugurated on January 20 , 2009 . Nine months later , he was named the 2009 Nobel Peace Prize laureate ."
  },
  {
    "sentences": [
      [
        "Regarded",
        "as",
        "a",
        "centrist",
        "New",
        "Democrat",
        ",",
        "Obama",
        "signed",
        "many",
        "landmark",
        "bills",
        "into",
        "law",
        "during",
        "his",
        "first",
        "two",
        "years",
        "in",
        "office",
        "."
      ],
      [
        "The",
        "main",
        "reforms",
        "that",
        "were",
        "passed",
        "include",
        "the",
        "Patient",
        "Protection",
        "and",
        "Affordable",
        "Care",
        "Act",
        "(",
        "commonly",
        "referred",
        "to",
        "as",
        "the",
        "\"",
        "Affordable",
        "Care",
        "Act",
        "\"",
        "or",
        "\"",
        "Obamacare",
        "\"",
        ")",
        ",",
        "the",
        "Dodd",
        "-",
        "Frank",
        "Wall",
        "Street",
        "Reform",
        "and",
        "Consumer",
        "Protection",
        "Act",
        ",",
        "and",
        "the",
        "Do",
        "n't",
        "Ask",
        ","
      ],
      [
        "Do",
        "n't",
        "Tell",
        "Repeal",
        "Act",
        "of",
        "2010",
        "."
      ],
      [
        "The",
        "American",
        "Recovery",
        "and",
        "Reinvestment",
        "Act",
        "of",
        "2009",
        "and",
        "Tax",
        "Relief",
        ",",
        "Unemployment",
        "Insurance",
        "Reauthorization",
        ",",
        "and"
      ],
      [
        "Job",
        "Creation",
        "Act",
        "of",
        "2010",
        "served",
        "as",
        "economic",
        "stimulus",
        "amidst",
        "the",
        "Great",
        "Recession",
        "."
      ],
      [
        "After",
        "a",
        "lengthy",
        "debate",
        "over",
        "the",
        "national",
        "debt",
        "limit",
        ",",
        "he",
        "signed",
        "the",
        "Budget",
        "Control",
        "and",
        "the",
        "American",
        "Taxpayer",
        "Relief",
        "Acts",
        "."
      ],
      [
        "In",
        "foreign",
        "policy",
        ",",
        "he",
        "increased",
        "U.S.",
        "troop",
        "levels",
        "in",
        "Afghanistan",
        ",",
        "reduced",
        "nuclear",
        "weapons",
        "with",
        "the",
        "United",
        "States",
        "-",
        "Russia",
        "New",
        "START",
        "treaty",
        ",",
        "and",
        "ended",
        "military",
        "involvement",
        "in",
        "the",
        "Iraq",
        "War",
        "."
      ],
      [
        "He",
        "ordered",
        "military",
        "involvement",
        "in",
        "Libya",
        ",",
        "contributing",
        "to",
        "the",
        "overthrow",
        "of",
        "Muammar",
        "Gaddafi",
        "."
      ],
      [
        "He",
        "also",
        "ordered",
        "the",
        "military",
        "operations",
        "that",
        "resulted",
        "in",
        "the",
        "deaths",
        "of",
        "Osama",
        "bin",
        "Laden",
        "and",
        "suspected",
        "Yemeni",
        "Al",
        "-",
        "Qaeda",
        "operative",
        "Anwar",
        "al",
        "-",
        "Awlaki",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            7,
            7
          ],
          [
            15,
            15
          ],
          [
            120,
            120
          ],
          [
            136,
            136
          ],
          [
            166,
            166
          ],
          [
            181,
            181
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "He"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "B-DATE"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279797.638803B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            7,
            7
          ]
        ],
        "words": [
          {
            "id": "1571279797.638789A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              7,
              7
            ]
          },
          {
            "id": "1571279797.638796A",
            "sequences": [
              "his"
            ],
            "positions": [
              15,
              15
            ]
          },
          {
            "id": "1571279797.638798A",
            "sequences": [
              "he"
            ],
            "positions": [
              120,
              120
            ]
          },
          {
            "id": "1571279797.638799A",
            "sequences": [
              "he"
            ],
            "positions": [
              136,
              136
            ]
          },
          {
            "id": "1571279797.6388A",
            "sequences": [
              "He"
            ],
            "positions": [
              166,
              166
            ]
          },
          {
            "id": "1571279797.638802A",
            "sequences": [
              "He"
            ],
            "positions": [
              181,
              181
            ]
          }
        ]
      },
      {
        "positions": [
          [
            77,
            77
          ],
          [
            100,
            100
          ]
        ],
        "sequences": [
          [
            "2010"
          ],
          [
            "2010"
          ]
        ],
        "ner_sequences": [
          [
            "I-LAW"
          ],
          [
            "I-LAW"
          ]
        ],
        "flags": 0,
        "id": "1571279797.638814B",
        "main_words": [
          "2010"
        ],
        "ner_tags": [
          "LAW"
        ],
        "position_main_word": [
          [
            77,
            77
          ],
          [
            100,
            100
          ]
        ],
        "words": [
          {
            "id": "1571279797.638811A",
            "sequences": [
              "2010"
            ],
            "positions": [
              77,
              77
            ]
          },
          {
            "id": "1571279797.638813A",
            "sequences": [
              "2010"
            ],
            "positions": [
              100,
              100
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "B-NORP",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "B-LAW",
      "O",
      "O",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LAW",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LAW",
      "I-GPE",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-EVENT",
      "I-EVENT",
      "I-EVENT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O"
    ],
    "doc_tokens": [
      "Regarded",
      "as",
      "a",
      "centrist",
      "New",
      "Democrat",
      ",",
      "Obama",
      "signed",
      "many",
      "landmark",
      "bills",
      "into",
      "law",
      "during",
      "his",
      "first",
      "two",
      "years",
      "in",
      "office",
      ".",
      "The",
      "main",
      "reforms",
      "that",
      "were",
      "passed",
      "include",
      "the",
      "Patient",
      "Protection",
      "and",
      "Affordable",
      "Care",
      "Act",
      "(",
      "commonly",
      "referred",
      "to",
      "as",
      "the",
      "\"",
      "Affordable",
      "Care",
      "Act",
      "\"",
      "or",
      "\"",
      "Obamacare",
      "\"",
      ")",
      ",",
      "the",
      "Dodd",
      "-",
      "Frank",
      "Wall",
      "Street",
      "Reform",
      "and",
      "Consumer",
      "Protection",
      "Act",
      ",",
      "and",
      "the",
      "Do",
      "n't",
      "Ask",
      ",",
      "Do",
      "n't",
      "Tell",
      "Repeal",
      "Act",
      "of",
      "2010",
      ".",
      "The",
      "American",
      "Recovery",
      "and",
      "Reinvestment",
      "Act",
      "of",
      "2009",
      "and",
      "Tax",
      "Relief",
      ",",
      "Unemployment",
      "Insurance",
      "Reauthorization",
      ",",
      "and",
      "Job",
      "Creation",
      "Act",
      "of",
      "2010",
      "served",
      "as",
      "economic",
      "stimulus",
      "amidst",
      "the",
      "Great",
      "Recession",
      ".",
      "After",
      "a",
      "lengthy",
      "debate",
      "over",
      "the",
      "national",
      "debt",
      "limit",
      ",",
      "he",
      "signed",
      "the",
      "Budget",
      "Control",
      "and",
      "the",
      "American",
      "Taxpayer",
      "Relief",
      "Acts",
      ".",
      "In",
      "foreign",
      "policy",
      ",",
      "he",
      "increased",
      "U.S.",
      "troop",
      "levels",
      "in",
      "Afghanistan",
      ",",
      "reduced",
      "nuclear",
      "weapons",
      "with",
      "the",
      "United",
      "States",
      "-",
      "Russia",
      "New",
      "START",
      "treaty",
      ",",
      "and",
      "ended",
      "military",
      "involvement",
      "in",
      "the",
      "Iraq",
      "War",
      ".",
      "He",
      "ordered",
      "military",
      "involvement",
      "in",
      "Libya",
      ",",
      "contributing",
      "to",
      "the",
      "overthrow",
      "of",
      "Muammar",
      "Gaddafi",
      ".",
      "He",
      "also",
      "ordered",
      "the",
      "military",
      "operations",
      "that",
      "resulted",
      "in",
      "the",
      "deaths",
      "of",
      "Osama",
      "bin",
      "Laden",
      "and",
      "suspected",
      "Yemeni",
      "Al",
      "-",
      "Qaeda",
      "operative",
      "Anwar",
      "al",
      "-",
      "Awlaki",
      "."
    ],
    "complete_sentence": "Regarded as a centrist New Democrat , Obama signed many landmark bills into law during his first two years in office . The main reforms that were passed include the Patient Protection and Affordable Care Act ( commonly referred to as the \" Affordable Care Act \" or \" Obamacare \" ) , the Dodd - Frank Wall Street Reform and Consumer Protection Act , and the Do n't Ask , Do n't Tell Repeal Act of 2010 . The American Recovery and Reinvestment Act of 2009 and Tax Relief , Unemployment Insurance Reauthorization , and Job Creation Act of 2010 served as economic stimulus amidst the Great Recession . After a lengthy debate over the national debt limit , he signed the Budget Control and the American Taxpayer Relief Acts . In foreign policy , he increased U.S. troop levels in Afghanistan , reduced nuclear weapons with the United States - Russia New START treaty , and ended military involvement in the Iraq War . He ordered military involvement in Libya , contributing to the overthrow of Muammar Gaddafi . He also ordered the military operations that resulted in the deaths of Osama bin Laden and suspected Yemeni Al - Qaeda operative Anwar al - Awlaki ."
  },
  {
    "sentences": [
      [
        "After",
        "winning",
        "re",
        "-",
        "election",
        "by",
        "defeating",
        "Republican",
        "opponent",
        "Mitt",
        "Romney",
        ",",
        "Obama",
        "was",
        "sworn",
        "in",
        "for",
        "a",
        "second",
        "term",
        "in",
        "2013",
        "."
      ],
      [
        "During",
        "this",
        "term",
        ",",
        "he",
        "promoted",
        "inclusiveness",
        "for",
        "LGBT",
        "Americans",
        "."
      ],
      [
        "His",
        "administration",
        "filed",
        "briefs",
        "that",
        "urged",
        "the",
        "Supreme",
        "Court",
        "to",
        "strike",
        "down",
        "same",
        "-",
        "sex",
        "marriage",
        "bans",
        "as",
        "unconstitutional",
        "(",
        "United",
        "States",
        "v.",
        "Windsor",
        "and",
        "Obergefell",
        "v.",
        "Hodges",
        ")",
        ";",
        "same",
        "-",
        "sex",
        "marriage",
        "was",
        "fully",
        "legalized",
        "in",
        "2015",
        "after",
        "the",
        "Court",
        "ruled",
        "that",
        "a",
        "same",
        "-",
        "sex",
        "marriage",
        "ban",
        "was",
        "unconstitutional",
        "in",
        "Obergefell",
        "."
      ],
      [
        "He",
        "advocated",
        "for",
        "gun",
        "control",
        "in",
        "response",
        "to",
        "the",
        "Sandy",
        "Hook",
        "Elementary",
        "School",
        "shooting",
        ",",
        "indicating",
        "support",
        "for",
        "a",
        "ban",
        "on",
        "assault",
        "weapons",
        ",",
        "and",
        "issued",
        "wide",
        "-",
        "ranging",
        "executive",
        "actions",
        "concerning",
        "global",
        "warming",
        "and",
        "immigration",
        "."
      ],
      [
        "In",
        "foreign",
        "policy",
        ",",
        "he",
        "ordered",
        "military",
        "intervention",
        "in",
        "Iraq",
        "in",
        "response",
        "to",
        "gains",
        "made",
        "by",
        "ISIL",
        "after",
        "the",
        "2011",
        "withdrawal",
        "from",
        "Iraq",
        ",",
        "continued",
        "the",
        "process",
        "of",
        "ending",
        "U.S.",
        "combat",
        "operations",
        "in",
        "Afghanistan",
        "in",
        "2016",
        ",",
        "promoted",
        "discussions",
        "that",
        "led",
        "to",
        "the",
        "2015",
        "Paris",
        "Agreement",
        "on",
        "global",
        "climate",
        "change",
        ",",
        "initiated",
        "sanctions",
        "against",
        "Russia",
        "following",
        "the",
        "invasion",
        "in",
        "Ukraine",
        "and",
        "again",
        "after",
        "Russian",
        "interference",
        "in",
        "the",
        "2016",
        "United",
        "States",
        "elections",
        ",",
        "brokered",
        "a",
        "nuclear",
        "deal",
        "with",
        "Iran",
        ",",
        "and",
        "normalized",
        "U.S.",
        "relations",
        "with",
        "Cuba",
        "."
      ],
      [
        "Obama",
        "nominated",
        "three",
        "justices",
        "to",
        "the",
        "Supreme",
        "Court",
        ":"
      ],
      [
        "Sonia",
        "Sotomayor",
        "and",
        "Elena",
        "Kagan",
        "were",
        "confirmed",
        "as",
        "justices",
        ",",
        "while",
        "Merrick",
        "Garland",
        "faced",
        "unprecedented",
        "partisan",
        "obstruction",
        "and",
        "was",
        "ultimately",
        "not",
        "confirmed",
        "."
      ],
      [
        "During",
        "his",
        "term",
        "in",
        "office",
        ",",
        "America",
        "'s",
        "soft",
        "power",
        "and",
        "reputation",
        "abroad",
        "significantly",
        "improved",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            7,
            10
          ],
          [
            12,
            12
          ],
          [
            27,
            27
          ],
          [
            34,
            34
          ],
          [
            89,
            89
          ],
          [
            130,
            130
          ],
          [
            212,
            212
          ]
        ],
        "sequences": [
          [
            "Republican",
            "opponent",
            "Mitt",
            "Romney"
          ],
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "His"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-NORP",
            "O",
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279801.935099B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            12,
            12
          ],
          [
            212,
            212
          ]
        ],
        "words": [
          {
            "id": "1571279801.935083A",
            "sequences": [
              "Republican",
              "opponent",
              "Mitt",
              "Romney"
            ],
            "positions": [
              7,
              10
            ]
          },
          {
            "id": "1571279801.93509A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              12,
              12
            ]
          },
          {
            "id": "1571279801.935092A",
            "sequences": [
              "he"
            ],
            "positions": [
              27,
              27
            ]
          },
          {
            "id": "1571279801.935093A",
            "sequences": [
              "His"
            ],
            "positions": [
              34,
              34
            ]
          },
          {
            "id": "1571279801.935095A",
            "sequences": [
              "He"
            ],
            "positions": [
              89,
              89
            ]
          },
          {
            "id": "1571279801.935096A",
            "sequences": [
              "he"
            ],
            "positions": [
              130,
              130
            ]
          },
          {
            "id": "1571279801.935097A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              212,
              212
            ]
          }
        ]
      },
      {
        "positions": [
          [
            17,
            19
          ],
          [
            24,
            25
          ]
        ],
        "sequences": [
          [
            "a",
            "second",
            "term"
          ],
          [
            "this",
            "term"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "B-ORDINAL",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279801.935109B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279801.935106A",
            "sequences": [
              "a",
              "second",
              "term"
            ],
            "positions": [
              17,
              19
            ]
          },
          {
            "id": "1571279801.935107A",
            "sequences": [
              "this",
              "term"
            ],
            "positions": [
              24,
              25
            ]
          }
        ]
      },
      {
        "positions": [
          [
            40,
            42
          ],
          [
            74,
            75
          ],
          [
            217,
            219
          ]
        ],
        "sequences": [
          [
            "the",
            "Supreme",
            "Court"
          ],
          [
            "the",
            "Court"
          ],
          [
            "the",
            "Supreme",
            "Court"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "O",
            "B-ORG"
          ],
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 0,
        "id": "1571279801.935126B",
        "main_words": [
          "the Supreme Court"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            40,
            42
          ],
          [
            217,
            219
          ]
        ],
        "words": [
          {
            "id": "1571279801.935122A",
            "sequences": [
              "the",
              "Supreme",
              "Court"
            ],
            "positions": [
              40,
              42
            ]
          },
          {
            "id": "1571279801.935124A",
            "sequences": [
              "the",
              "Court"
            ],
            "positions": [
              74,
              75
            ]
          },
          {
            "id": "1571279801.935125A",
            "sequences": [
              "the",
              "Supreme",
              "Court"
            ],
            "positions": [
              217,
              219
            ]
          }
        ]
      },
      {
        "main_words": [
          "Obergefell"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              59,
              59
            ]
          ]
        ],
        "positions": [
          [
            59,
            59
          ]
        ],
        "sequences": [
          [
            "Obergefell"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ]
        ],
        "flags": 1,
        "id": "1571279801.938942B",
        "words": [
          {
            "id": "1571279801.938951A",
            "sequences": [
              "Obergefell"
            ],
            "positions": [
              59,
              59
            ]
          }
        ]
      },
      {
        "main_words": [
          "Obergefell"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            [
              87,
              87
            ]
          ]
        ],
        "positions": [
          [
            87,
            87
          ]
        ],
        "sequences": [
          [
            "Obergefell"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ]
        ],
        "flags": 1,
        "id": "1571279801.938947B",
        "words": [
          {
            "id": "1571279801.938954A",
            "sequences": [
              "Obergefell"
            ],
            "positions": [
              87,
              87
            ]
          }
        ]
      },
      {
        "positions": [
          [
            135,
            135
          ],
          [
            148,
            148
          ]
        ],
        "sequences": [
          [
            "Iraq"
          ],
          [
            "Iraq"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279801.938973B",
        "main_words": [
          "Iraq"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            135,
            135
          ],
          [
            148,
            148
          ]
        ],
        "words": [
          {
            "id": "1571279801.93897A",
            "sequences": [
              "Iraq"
            ],
            "positions": [
              135,
              135
            ]
          },
          {
            "id": "1571279801.938972A",
            "sequences": [
              "Iraq"
            ],
            "positions": [
              148,
              148
            ]
          }
        ]
      },
      {
        "positions": [
          [
            54,
            55
          ],
          [
            194,
            195
          ]
        ],
        "sequences": [
          [
            "United",
            "States"
          ],
          [
            "United",
            "States"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE",
            "I-GPE"
          ],
          [
            "B-GPE",
            "I-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279801.938985B",
        "main_words": [
          "United States"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            54,
            55
          ],
          [
            194,
            195
          ]
        ],
        "words": [
          {
            "id": "1571279801.938982A",
            "sequences": [
              "United",
              "States"
            ],
            "positions": [
              54,
              55
            ]
          },
          {
            "id": "1571279801.938984A",
            "sequences": [
              "United",
              "States"
            ],
            "positions": [
              194,
              195
            ]
          }
        ]
      },
      {
        "positions": [
          [
            232,
            233
          ],
          [
            245,
            245
          ]
        ],
        "sequences": [
          [
            "Merrick",
            "Garland"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279801.938995B",
        "main_words": [
          "Merrick Garland"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            232,
            233
          ]
        ],
        "words": [
          {
            "id": "1571279801.938992A",
            "sequences": [
              "Merrick",
              "Garland"
            ],
            "positions": [
              232,
              233
            ]
          },
          {
            "id": "1571279801.938994A",
            "sequences": [
              "his"
            ],
            "positions": [
              245,
              245
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "I-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "O",
      "B-PERSON",
      "O",
      "B-PERSON",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-FAC",
      "I-FAC",
      "I-FAC",
      "I-FAC",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "B-EVENT",
      "I-EVENT",
      "O",
      "I-EVENT",
      "I-EVENT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "B-DATE",
      "B-GPE",
      "I-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-PERSON",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "After",
      "winning",
      "re",
      "-",
      "election",
      "by",
      "defeating",
      "Republican",
      "opponent",
      "Mitt",
      "Romney",
      ",",
      "Obama",
      "was",
      "sworn",
      "in",
      "for",
      "a",
      "second",
      "term",
      "in",
      "2013",
      ".",
      "During",
      "this",
      "term",
      ",",
      "he",
      "promoted",
      "inclusiveness",
      "for",
      "LGBT",
      "Americans",
      ".",
      "His",
      "administration",
      "filed",
      "briefs",
      "that",
      "urged",
      "the",
      "Supreme",
      "Court",
      "to",
      "strike",
      "down",
      "same",
      "-",
      "sex",
      "marriage",
      "bans",
      "as",
      "unconstitutional",
      "(",
      "United",
      "States",
      "v.",
      "Windsor",
      "and",
      "Obergefell",
      "v.",
      "Hodges",
      ")",
      ";",
      "same",
      "-",
      "sex",
      "marriage",
      "was",
      "fully",
      "legalized",
      "in",
      "2015",
      "after",
      "the",
      "Court",
      "ruled",
      "that",
      "a",
      "same",
      "-",
      "sex",
      "marriage",
      "ban",
      "was",
      "unconstitutional",
      "in",
      "Obergefell",
      ".",
      "He",
      "advocated",
      "for",
      "gun",
      "control",
      "in",
      "response",
      "to",
      "the",
      "Sandy",
      "Hook",
      "Elementary",
      "School",
      "shooting",
      ",",
      "indicating",
      "support",
      "for",
      "a",
      "ban",
      "on",
      "assault",
      "weapons",
      ",",
      "and",
      "issued",
      "wide",
      "-",
      "ranging",
      "executive",
      "actions",
      "concerning",
      "global",
      "warming",
      "and",
      "immigration",
      ".",
      "In",
      "foreign",
      "policy",
      ",",
      "he",
      "ordered",
      "military",
      "intervention",
      "in",
      "Iraq",
      "in",
      "response",
      "to",
      "gains",
      "made",
      "by",
      "ISIL",
      "after",
      "the",
      "2011",
      "withdrawal",
      "from",
      "Iraq",
      ",",
      "continued",
      "the",
      "process",
      "of",
      "ending",
      "U.S.",
      "combat",
      "operations",
      "in",
      "Afghanistan",
      "in",
      "2016",
      ",",
      "promoted",
      "discussions",
      "that",
      "led",
      "to",
      "the",
      "2015",
      "Paris",
      "Agreement",
      "on",
      "global",
      "climate",
      "change",
      ",",
      "initiated",
      "sanctions",
      "against",
      "Russia",
      "following",
      "the",
      "invasion",
      "in",
      "Ukraine",
      "and",
      "again",
      "after",
      "Russian",
      "interference",
      "in",
      "the",
      "2016",
      "United",
      "States",
      "elections",
      ",",
      "brokered",
      "a",
      "nuclear",
      "deal",
      "with",
      "Iran",
      ",",
      "and",
      "normalized",
      "U.S.",
      "relations",
      "with",
      "Cuba",
      ".",
      "Obama",
      "nominated",
      "three",
      "justices",
      "to",
      "the",
      "Supreme",
      "Court",
      ":",
      "Sonia",
      "Sotomayor",
      "and",
      "Elena",
      "Kagan",
      "were",
      "confirmed",
      "as",
      "justices",
      ",",
      "while",
      "Merrick",
      "Garland",
      "faced",
      "unprecedented",
      "partisan",
      "obstruction",
      "and",
      "was",
      "ultimately",
      "not",
      "confirmed",
      ".",
      "During",
      "his",
      "term",
      "in",
      "office",
      ",",
      "America",
      "'s",
      "soft",
      "power",
      "and",
      "reputation",
      "abroad",
      "significantly",
      "improved",
      "."
    ],
    "complete_sentence": "After winning re - election by defeating Republican opponent Mitt Romney , Obama was sworn in for a second term in 2013 . During this term , he promoted inclusiveness for LGBT Americans . His administration filed briefs that urged the Supreme Court to strike down same - sex marriage bans as unconstitutional ( United States v. Windsor and Obergefell v. Hodges ) ; same - sex marriage was fully legalized in 2015 after the Court ruled that a same - sex marriage ban was unconstitutional in Obergefell . He advocated for gun control in response to the Sandy Hook Elementary School shooting , indicating support for a ban on assault weapons , and issued wide - ranging executive actions concerning global warming and immigration . In foreign policy , he ordered military intervention in Iraq in response to gains made by ISIL after the 2011 withdrawal from Iraq , continued the process of ending U.S. combat operations in Afghanistan in 2016 , promoted discussions that led to the 2015 Paris Agreement on global climate change , initiated sanctions against Russia following the invasion in Ukraine and again after Russian interference in the 2016 United States elections , brokered a nuclear deal with Iran , and normalized U.S. relations with Cuba . Obama nominated three justices to the Supreme Court : Sonia Sotomayor and Elena Kagan were confirmed as justices , while Merrick Garland faced unprecedented partisan obstruction and was ultimately not confirmed . During his term in office , America 's soft power and reputation abroad significantly improved ."
  },
  {
    "sentences": [
      [
        "Obama",
        "'s",
        "presidency",
        "has",
        "generally",
        "been",
        "regarded",
        "favorably",
        ",",
        "and",
        "evaluations",
        "of",
        "his",
        "presidency",
        "among",
        "historians",
        ",",
        "political",
        "scientists",
        ",",
        "and",
        "the",
        "general",
        "public",
        "place",
        "him",
        "among",
        "the",
        "upper",
        "tier",
        "of",
        "American",
        "presidents",
        "."
      ],
      [
        "Obama",
        "left",
        "office",
        "and",
        "retired",
        "in",
        "January",
        "2017",
        "and",
        "currently",
        "resides",
        "in",
        "Washington",
        ","
      ],
      [
        "D.C.",
        "A",
        "December",
        "2018"
      ],
      [
        "Gallup",
        "poll",
        "found",
        "Obama",
        "to",
        "be",
        "the",
        "most",
        "admired",
        "man",
        "in",
        "America",
        "for",
        "an",
        "unprecedented",
        "11th",
        "consecutive",
        "year",
        ",",
        "although",
        "Dwight",
        "D.",
        "Eisenhower",
        "was",
        "selected",
        "most",
        "admired",
        "in",
        "twelve",
        "non",
        "-",
        "consecutive",
        "years",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            1
          ],
          [
            12,
            12
          ],
          [
            25,
            25
          ],
          [
            34,
            34
          ],
          [
            55,
            55
          ]
        ],
        "sequences": [
          [
            "Obama",
            "'s"
          ],
          [
            "his"
          ],
          [
            "him"
          ],
          [
            "Obama"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279802.886408B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            34,
            34
          ],
          [
            55,
            55
          ]
        ],
        "words": [
          {
            "id": "1571279802.886396A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              0,
              1
            ]
          },
          {
            "id": "1571279802.886403A",
            "sequences": [
              "his"
            ],
            "positions": [
              12,
              12
            ]
          },
          {
            "id": "1571279802.886404A",
            "sequences": [
              "him"
            ],
            "positions": [
              25,
              25
            ]
          },
          {
            "id": "1571279802.886405A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              34,
              34
            ]
          },
          {
            "id": "1571279802.886407A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              55,
              55
            ]
          }
        ]
      },
      {
        "positions": [
          [
            0,
            2
          ],
          [
            12,
            13
          ]
        ],
        "sequences": [
          [
            "Obama",
            "'s",
            "presidency"
          ],
          [
            "his",
            "presidency"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "O",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279802.886417B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279802.886414A",
            "sequences": [
              "Obama",
              "'s",
              "presidency"
            ],
            "positions": [
              0,
              2
            ]
          },
          {
            "id": "1571279802.886415A",
            "sequences": [
              "his",
              "presidency"
            ],
            "positions": [
              12,
              13
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "I-DATE",
      "B-ORG",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "'s",
      "presidency",
      "has",
      "generally",
      "been",
      "regarded",
      "favorably",
      ",",
      "and",
      "evaluations",
      "of",
      "his",
      "presidency",
      "among",
      "historians",
      ",",
      "political",
      "scientists",
      ",",
      "and",
      "the",
      "general",
      "public",
      "place",
      "him",
      "among",
      "the",
      "upper",
      "tier",
      "of",
      "American",
      "presidents",
      ".",
      "Obama",
      "left",
      "office",
      "and",
      "retired",
      "in",
      "January",
      "2017",
      "and",
      "currently",
      "resides",
      "in",
      "Washington",
      ",",
      "D.C.",
      "A",
      "December",
      "2018",
      "Gallup",
      "poll",
      "found",
      "Obama",
      "to",
      "be",
      "the",
      "most",
      "admired",
      "man",
      "in",
      "America",
      "for",
      "an",
      "unprecedented",
      "11th",
      "consecutive",
      "year",
      ",",
      "although",
      "Dwight",
      "D.",
      "Eisenhower",
      "was",
      "selected",
      "most",
      "admired",
      "in",
      "twelve",
      "non",
      "-",
      "consecutive",
      "years",
      "."
    ],
    "complete_sentence": "Obama 's presidency has generally been regarded favorably , and evaluations of his presidency among historians , political scientists , and the general public place him among the upper tier of American presidents . Obama left office and retired in January 2017 and currently resides in Washington , D.C. A December 2018 Gallup poll found Obama to be the most admired man in America for an unprecedented 11th consecutive year , although Dwight D. Eisenhower was selected most admired in twelve non - consecutive years ."
  },
  {
    "sentences": [
      [
        "Obama",
        "was",
        "born",
        "on",
        "August",
        "4",
        ",",
        "1961",
        ",",
        "at",
        "Kapiolani",
        "Medical",
        "Center",
        "for",
        "Women",
        "and",
        "Children",
        "in",
        "Honolulu",
        ",",
        "Hawaii",
        "."
      ],
      [
        "He",
        "is",
        "the",
        "only",
        "president",
        "born",
        "outside",
        "the",
        "contiguous",
        "48",
        "states",
        "."
      ],
      [
        "He",
        "was",
        "born",
        "to",
        "a",
        "white",
        "mother",
        "and",
        "a",
        "black",
        "father",
        "."
      ],
      [
        "His",
        "mother",
        ",",
        "Ann",
        "Dunham",
        "(",
        "1942",
        "-",
        "1995",
        ")",
        ",",
        "was",
        "born",
        "in",
        "Wichita",
        ",",
        "Kansas",
        ";",
        "she",
        "was",
        "mostly",
        "of",
        "English",
        "descent",
        ",",
        "with",
        "some",
        "German",
        ",",
        "Irish",
        "(",
        "3.13",
        "%",
        ")",
        ",",
        "Scottish",
        ",",
        "Swiss",
        ",",
        "and",
        "Welsh",
        "ancestry",
        "."
      ],
      [
        "His",
        "father",
        ",",
        "Barack",
        "Obama",
        "Sr",
        "."
      ],
      [
        "(",
        "1936",
        "-",
        "1982",
        ")",
        ",",
        "was",
        "a",
        "Luo",
        "Kenyan",
        "from",
        "Nyang'oma",
        "Kogelo",
        "."
      ],
      [
        "Obama",
        "'s",
        "parents",
        "met",
        "in",
        "1960",
        "in",
        "a",
        "Russian",
        "language",
        "class",
        "at",
        "the",
        "University",
        "of",
        "Hawaii",
        "at",
        "Manoa",
        ",",
        "where",
        "his",
        "father",
        "was",
        "a",
        "foreign",
        "student",
        "on",
        "a",
        "scholarship",
        "."
      ],
      [
        "The",
        "couple",
        "married",
        "in",
        "Wailuku",
        ",",
        "Hawaii",
        ",",
        "on",
        "February",
        "2",
        ",",
        "1961",
        ",",
        "six",
        "months",
        "before",
        "Obama",
        "was",
        "born",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            22,
            22
          ],
          [
            34,
            34
          ],
          [
            46,
            46
          ],
          [
            89,
            89
          ],
          [
            89,
            95
          ],
          [
            110,
            111
          ],
          [
            130,
            130
          ],
          [
            157,
            157
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "He"
          ],
          [
            "He"
          ],
          [
            "His"
          ],
          [
            "His"
          ],
          [
            "His",
            "father",
            ",",
            "Barack",
            "Obama",
            "Sr",
            "."
          ],
          [
            "Obama",
            "'s"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O",
            "O",
            "O",
            "B-PERSON",
            "I-PERSON",
            "I-PERSON",
            "O"
          ],
          [
            "B-PERSON",
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279805.071256B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            0
          ],
          [
            157,
            157
          ]
        ],
        "words": [
          {
            "id": "1571279805.07124A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279805.071247A",
            "sequences": [
              "He"
            ],
            "positions": [
              22,
              22
            ]
          },
          {
            "id": "1571279805.071248A",
            "sequences": [
              "He"
            ],
            "positions": [
              34,
              34
            ]
          },
          {
            "id": "1571279805.071249A",
            "sequences": [
              "His"
            ],
            "positions": [
              46,
              46
            ]
          },
          {
            "id": "1571279805.071251A",
            "sequences": [
              "His"
            ],
            "positions": [
              89,
              89
            ]
          },
          {
            "id": "1571279805.071252A",
            "sequences": [
              "His",
              "father",
              ",",
              "Barack",
              "Obama",
              "Sr",
              "."
            ],
            "positions": [
              89,
              95
            ]
          },
          {
            "id": "1571279805.071253A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              110,
              111
            ]
          },
          {
            "id": "1571279805.071254A",
            "sequences": [
              "his"
            ],
            "positions": [
              130,
              130
            ]
          },
          {
            "id": "1571279805.071255A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              157,
              157
            ]
          }
        ]
      },
      {
        "positions": [
          [
            46,
            55
          ],
          [
            64,
            64
          ]
        ],
        "sequences": [
          [
            "His",
            "mother",
            ",",
            "Ann",
            "Dunham",
            "(",
            "1942",
            "-",
            "1995",
            ")"
          ],
          [
            "she"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O",
            "O",
            "B-PERSON",
            "I-PERSON",
            "O",
            "B-DATE",
            "I-DATE",
            "I-DATE",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279805.071267B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279805.071264A",
            "sequences": [
              "His",
              "mother",
              ",",
              "Ann",
              "Dunham",
              "(",
              "1942",
              "-",
              "1995",
              ")"
            ],
            "positions": [
              46,
              55
            ]
          },
          {
            "id": "1571279805.071266A",
            "sequences": [
              "she"
            ],
            "positions": [
              64,
              64
            ]
          }
        ]
      },
      {
        "positions": [
          [
            110,
            112
          ],
          [
            140,
            141
          ]
        ],
        "sequences": [
          [
            "Obama",
            "'s",
            "parents"
          ],
          [
            "The",
            "couple"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "O",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279805.071277B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279805.071275A",
            "sequences": [
              "Obama",
              "'s",
              "parents"
            ],
            "positions": [
              110,
              112
            ]
          },
          {
            "id": "1571279805.071276A",
            "sequences": [
              "The",
              "couple"
            ],
            "positions": [
              140,
              141
            ]
          }
        ]
      },
      {
        "positions": [
          [
            20,
            20
          ],
          [
            146,
            146
          ]
        ],
        "sequences": [
          [
            "Hawaii"
          ],
          [
            "Hawaii"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279805.071287B",
        "main_words": [
          "Hawaii"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            20,
            20
          ],
          [
            146,
            146
          ]
        ],
        "words": [
          {
            "id": "1571279805.071285A",
            "sequences": [
              "Hawaii"
            ],
            "positions": [
              20,
              20
            ]
          },
          {
            "id": "1571279805.071286A",
            "sequences": [
              "Hawaii"
            ],
            "positions": [
              146,
              146
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "B-NORP",
      "O",
      "B-PERCENT",
      "I-PERCENT",
      "O",
      "O",
      "B-NORP",
      "O",
      "B-NORP",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-LANGUAGE",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "was",
      "born",
      "on",
      "August",
      "4",
      ",",
      "1961",
      ",",
      "at",
      "Kapiolani",
      "Medical",
      "Center",
      "for",
      "Women",
      "and",
      "Children",
      "in",
      "Honolulu",
      ",",
      "Hawaii",
      ".",
      "He",
      "is",
      "the",
      "only",
      "president",
      "born",
      "outside",
      "the",
      "contiguous",
      "48",
      "states",
      ".",
      "He",
      "was",
      "born",
      "to",
      "a",
      "white",
      "mother",
      "and",
      "a",
      "black",
      "father",
      ".",
      "His",
      "mother",
      ",",
      "Ann",
      "Dunham",
      "(",
      "1942",
      "-",
      "1995",
      ")",
      ",",
      "was",
      "born",
      "in",
      "Wichita",
      ",",
      "Kansas",
      ";",
      "she",
      "was",
      "mostly",
      "of",
      "English",
      "descent",
      ",",
      "with",
      "some",
      "German",
      ",",
      "Irish",
      "(",
      "3.13",
      "%",
      ")",
      ",",
      "Scottish",
      ",",
      "Swiss",
      ",",
      "and",
      "Welsh",
      "ancestry",
      ".",
      "His",
      "father",
      ",",
      "Barack",
      "Obama",
      "Sr",
      ".",
      "(",
      "1936",
      "-",
      "1982",
      ")",
      ",",
      "was",
      "a",
      "Luo",
      "Kenyan",
      "from",
      "Nyang'oma",
      "Kogelo",
      ".",
      "Obama",
      "'s",
      "parents",
      "met",
      "in",
      "1960",
      "in",
      "a",
      "Russian",
      "language",
      "class",
      "at",
      "the",
      "University",
      "of",
      "Hawaii",
      "at",
      "Manoa",
      ",",
      "where",
      "his",
      "father",
      "was",
      "a",
      "foreign",
      "student",
      "on",
      "a",
      "scholarship",
      ".",
      "The",
      "couple",
      "married",
      "in",
      "Wailuku",
      ",",
      "Hawaii",
      ",",
      "on",
      "February",
      "2",
      ",",
      "1961",
      ",",
      "six",
      "months",
      "before",
      "Obama",
      "was",
      "born",
      "."
    ],
    "complete_sentence": "Obama was born on August 4 , 1961 , at Kapiolani Medical Center for Women and Children in Honolulu , Hawaii . He is the only president born outside the contiguous 48 states . He was born to a white mother and a black father . His mother , Ann Dunham ( 1942 - 1995 ) , was born in Wichita , Kansas ; she was mostly of English descent , with some German , Irish ( 3.13 % ) , Scottish , Swiss , and Welsh ancestry . His father , Barack Obama Sr . ( 1936 - 1982 ) , was a Luo Kenyan from Nyang'oma Kogelo . Obama 's parents met in 1960 in a Russian language class at the University of Hawaii at Manoa , where his father was a foreign student on a scholarship . The couple married in Wailuku , Hawaii , on February 2 , 1961 , six months before Obama was born ."
  },
  {
    "sentences": [
      [
        "In",
        "late",
        "August",
        "1961",
        ",",
        "a",
        "few",
        "weeks",
        "after",
        "he",
        "was",
        "born",
        ",",
        "Barack",
        "and",
        "his",
        "mother",
        "moved",
        "to",
        "the",
        "University",
        "of",
        "Washington",
        "in",
        "Seattle",
        ",",
        "where",
        "they",
        "lived",
        "for",
        "a",
        "year",
        "."
      ],
      [
        "During",
        "that",
        "time",
        ",",
        "the",
        "elder",
        "Obama",
        "completed",
        "his",
        "undergraduate",
        "degree",
        "in",
        "economics",
        "in",
        "Hawaii",
        ",",
        "graduating",
        "in",
        "June",
        "1962",
        "."
      ],
      [
        "He",
        "left",
        "to",
        "attend",
        "graduate",
        "school",
        "on",
        "a",
        "scholarship",
        "at",
        "Harvard",
        "University",
        ",",
        "where",
        "he",
        "earned",
        "an",
        "M.A.",
        "in",
        "economics",
        "."
      ],
      [
        "Obama",
        "'s",
        "parents",
        "divorced",
        "in",
        "March",
        "1964",
        "."
      ],
      [
        "Obama",
        "Sr",
        ".",
        "returned",
        "to",
        "Kenya",
        "in",
        "1964",
        ",",
        "where",
        "he",
        "married",
        "for",
        "a",
        "third",
        "time",
        "and",
        "worked",
        "for",
        "the",
        "Kenyan",
        "government",
        "as",
        "the",
        "Senior",
        "Economic",
        "Analyst",
        "in",
        "the",
        "Ministry",
        "of",
        "Finance",
        "."
      ],
      [
        "He",
        "visited",
        "his",
        "son",
        "in",
        "Hawaii",
        "only",
        "once",
        ",",
        "at",
        "Christmas",
        "1971",
        ",",
        "before",
        "he",
        "was",
        "killed",
        "in",
        "an",
        "automobile",
        "accident",
        "in",
        "1982",
        ",",
        "when",
        "Obama",
        "was",
        "21",
        "years",
        "old",
        "."
      ],
      [
        "Recalling",
        "his",
        "early",
        "childhood",
        ",",
        "Obama",
        "said",
        ",",
        "\"",
        "That",
        "my",
        "father",
        "looked",
        "nothing",
        "like",
        "the",
        "people",
        "around",
        "me",
        "-",
        "that",
        "he",
        "was",
        "black",
        "as",
        "pitch",
        ",",
        "my",
        "mother",
        "white",
        "as",
        "milk",
        "-",
        "barely",
        "registered",
        "in",
        "my",
        "mind",
        "."
      ],
      [
        "\""
      ],
      [
        "He",
        "described",
        "his",
        "struggles",
        "as",
        "a",
        "young",
        "adult",
        "to",
        "reconcile",
        "social",
        "perceptions",
        "of",
        "his",
        "multiracial",
        "heritage",
        "."
      ]
    ],
    "elements": [
      {
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              141,
              141
            ],
            [
              152,
              152
            ]
          ]
        ],
        "positions": [
          [
            141,
            141
          ],
          [
            148,
            148
          ],
          [
            152,
            152
          ],
          [
            157,
            157
          ],
          [
            165,
            165
          ],
          [
            174,
            174
          ],
          [
            183,
            183
          ],
          [
            187,
            187
          ],
          [
            189,
            189
          ],
          [
            200,
            200
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "my"
          ],
          [
            "me"
          ],
          [
            "my"
          ],
          [
            "my"
          ],
          [
            "He"
          ],
          [
            "his"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 1,
        "id": "1571279807.101765B",
        "words": [
          {
            "id": "1571279807.101781A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              141,
              141
            ]
          },
          {
            "id": "1571279807.101782A",
            "sequences": [
              "his"
            ],
            "positions": [
              148,
              148
            ]
          },
          {
            "id": "1571279807.101783A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              152,
              152
            ]
          },
          {
            "id": "1571279807.101785A",
            "sequences": [
              "my"
            ],
            "positions": [
              157,
              157
            ]
          },
          {
            "id": "1571279807.101786A",
            "sequences": [
              "me"
            ],
            "positions": [
              165,
              165
            ]
          },
          {
            "id": "1571279807.101787A",
            "sequences": [
              "my"
            ],
            "positions": [
              174,
              174
            ]
          },
          {
            "id": "1571279807.101788A",
            "sequences": [
              "my"
            ],
            "positions": [
              183,
              183
            ]
          },
          {
            "id": "1571279807.101789A",
            "sequences": [
              "He"
            ],
            "positions": [
              187,
              187
            ]
          },
          {
            "id": "1571279807.10179A",
            "sequences": [
              "his"
            ],
            "positions": [
              189,
              189
            ]
          },
          {
            "id": "1571279807.101791A",
            "sequences": [
              "his"
            ],
            "positions": [
              200,
              200
            ]
          }
        ]
      },
      {
        "main_words": [
          "Barack"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              13,
              13
            ]
          ]
        ],
        "positions": [
          [
            9,
            9
          ],
          [
            13,
            13
          ],
          [
            15,
            15
          ],
          [
            37,
            39
          ],
          [
            41,
            41
          ],
          [
            54,
            54
          ],
          [
            68,
            68
          ],
          [
            75,
            76
          ]
        ],
        "sequences": [
          [
            "he"
          ],
          [
            "Barack"
          ],
          [
            "his"
          ],
          [
            "the",
            "elder",
            "Obama"
          ],
          [
            "his"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "Obama",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O",
            "O",
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON",
            "O"
          ]
        ],
        "flags": 1,
        "id": "1571279807.101772B",
        "words": [
          {
            "id": "1571279807.101793A",
            "sequences": [
              "he"
            ],
            "positions": [
              9,
              9
            ]
          },
          {
            "id": "1571279807.101794A",
            "sequences": [
              "Barack"
            ],
            "positions": [
              13,
              13
            ]
          },
          {
            "id": "1571279807.101795A",
            "sequences": [
              "his"
            ],
            "positions": [
              15,
              15
            ]
          },
          {
            "id": "1571279807.101797A",
            "sequences": [
              "the",
              "elder",
              "Obama"
            ],
            "positions": [
              37,
              39
            ]
          },
          {
            "id": "1571279807.101798A",
            "sequences": [
              "his"
            ],
            "positions": [
              41,
              41
            ]
          },
          {
            "id": "1571279807.101799A",
            "sequences": [
              "He"
            ],
            "positions": [
              54,
              54
            ]
          },
          {
            "id": "1571279807.1018A",
            "sequences": [
              "he"
            ],
            "positions": [
              68,
              68
            ]
          },
          {
            "id": "1571279807.101801A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              75,
              76
            ]
          }
        ]
      },
      {
        "positions": [
          [
            13,
            16
          ],
          [
            27,
            27
          ]
        ],
        "sequences": [
          [
            "Barack",
            "and",
            "his",
            "mother"
          ],
          [
            "they"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "O",
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279807.101815B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279807.101812A",
            "sequences": [
              "Barack",
              "and",
              "his",
              "mother"
            ],
            "positions": [
              13,
              16
            ]
          },
          {
            "id": "1571279807.101814A",
            "sequences": [
              "they"
            ],
            "positions": [
              27,
              27
            ]
          }
        ]
      },
      {
        "positions": [
          [
            83,
            85
          ],
          [
            93,
            93
          ],
          [
            116,
            116
          ],
          [
            118,
            118
          ]
        ],
        "sequences": [
          [
            "Obama",
            "Sr",
            "."
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279807.101827B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279807.101822A",
            "sequences": [
              "Obama",
              "Sr",
              "."
            ],
            "positions": [
              83,
              85
            ]
          },
          {
            "id": "1571279807.101824A",
            "sequences": [
              "he"
            ],
            "positions": [
              93,
              93
            ]
          },
          {
            "id": "1571279807.101825A",
            "sequences": [
              "He"
            ],
            "positions": [
              116,
              116
            ]
          },
          {
            "id": "1571279807.101826A",
            "sequences": [
              "his"
            ],
            "positions": [
              118,
              118
            ]
          }
        ]
      },
      {
        "positions": [
          [
            47,
            47
          ],
          [
            121,
            121
          ]
        ],
        "sequences": [
          [
            "Hawaii"
          ],
          [
            "Hawaii"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279807.101836B",
        "main_words": [
          "Hawaii"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            47,
            47
          ],
          [
            121,
            121
          ]
        ],
        "words": [
          {
            "id": "1571279807.101834A",
            "sequences": [
              "Hawaii"
            ],
            "positions": [
              47,
              47
            ]
          },
          {
            "id": "1571279807.101835A",
            "sequences": [
              "Hawaii"
            ],
            "positions": [
              121,
              121
            ]
          }
        ]
      },
      {
        "positions": [
          [
            118,
            119
          ],
          [
            130,
            130
          ]
        ],
        "sequences": [
          [
            "his",
            "son"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279807.101843B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279807.101841A",
            "sequences": [
              "his",
              "son"
            ],
            "positions": [
              118,
              119
            ]
          },
          {
            "id": "1571279807.101842A",
            "sequences": [
              "he"
            ],
            "positions": [
              130,
              130
            ]
          }
        ]
      },
      {
        "positions": [
          [
            157,
            158
          ],
          [
            168,
            168
          ]
        ],
        "sequences": [
          [
            "my",
            "father"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279807.101851B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279807.101847A",
            "sequences": [
              "my",
              "father"
            ],
            "positions": [
              157,
              158
            ]
          },
          {
            "id": "1571279807.101849A",
            "sequences": [
              "he"
            ],
            "positions": [
              168,
              168
            ]
          }
        ]
      },
      {
        "positions": [
          [
            15,
            16
          ],
          [
            174,
            175
          ]
        ],
        "sequences": [
          [
            "his",
            "mother"
          ],
          [
            "my",
            "mother"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279807.101858B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279807.101856A",
            "sequences": [
              "his",
              "mother"
            ],
            "positions": [
              15,
              16
            ]
          },
          {
            "id": "1571279807.101857A",
            "sequences": [
              "my",
              "mother"
            ],
            "positions": [
              174,
              175
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-WORK_OF_ART",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-PERSON",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "In",
      "late",
      "August",
      "1961",
      ",",
      "a",
      "few",
      "weeks",
      "after",
      "he",
      "was",
      "born",
      ",",
      "Barack",
      "and",
      "his",
      "mother",
      "moved",
      "to",
      "the",
      "University",
      "of",
      "Washington",
      "in",
      "Seattle",
      ",",
      "where",
      "they",
      "lived",
      "for",
      "a",
      "year",
      ".",
      "During",
      "that",
      "time",
      ",",
      "the",
      "elder",
      "Obama",
      "completed",
      "his",
      "undergraduate",
      "degree",
      "in",
      "economics",
      "in",
      "Hawaii",
      ",",
      "graduating",
      "in",
      "June",
      "1962",
      ".",
      "He",
      "left",
      "to",
      "attend",
      "graduate",
      "school",
      "on",
      "a",
      "scholarship",
      "at",
      "Harvard",
      "University",
      ",",
      "where",
      "he",
      "earned",
      "an",
      "M.A.",
      "in",
      "economics",
      ".",
      "Obama",
      "'s",
      "parents",
      "divorced",
      "in",
      "March",
      "1964",
      ".",
      "Obama",
      "Sr",
      ".",
      "returned",
      "to",
      "Kenya",
      "in",
      "1964",
      ",",
      "where",
      "he",
      "married",
      "for",
      "a",
      "third",
      "time",
      "and",
      "worked",
      "for",
      "the",
      "Kenyan",
      "government",
      "as",
      "the",
      "Senior",
      "Economic",
      "Analyst",
      "in",
      "the",
      "Ministry",
      "of",
      "Finance",
      ".",
      "He",
      "visited",
      "his",
      "son",
      "in",
      "Hawaii",
      "only",
      "once",
      ",",
      "at",
      "Christmas",
      "1971",
      ",",
      "before",
      "he",
      "was",
      "killed",
      "in",
      "an",
      "automobile",
      "accident",
      "in",
      "1982",
      ",",
      "when",
      "Obama",
      "was",
      "21",
      "years",
      "old",
      ".",
      "Recalling",
      "his",
      "early",
      "childhood",
      ",",
      "Obama",
      "said",
      ",",
      "\"",
      "That",
      "my",
      "father",
      "looked",
      "nothing",
      "like",
      "the",
      "people",
      "around",
      "me",
      "-",
      "that",
      "he",
      "was",
      "black",
      "as",
      "pitch",
      ",",
      "my",
      "mother",
      "white",
      "as",
      "milk",
      "-",
      "barely",
      "registered",
      "in",
      "my",
      "mind",
      ".",
      "\"",
      "He",
      "described",
      "his",
      "struggles",
      "as",
      "a",
      "young",
      "adult",
      "to",
      "reconcile",
      "social",
      "perceptions",
      "of",
      "his",
      "multiracial",
      "heritage",
      "."
    ],
    "complete_sentence": "In late August 1961 , a few weeks after he was born , Barack and his mother moved to the University of Washington in Seattle , where they lived for a year . During that time , the elder Obama completed his undergraduate degree in economics in Hawaii , graduating in June 1962 . He left to attend graduate school on a scholarship at Harvard University , where he earned an M.A. in economics . Obama 's parents divorced in March 1964 . Obama Sr . returned to Kenya in 1964 , where he married for a third time and worked for the Kenyan government as the Senior Economic Analyst in the Ministry of Finance . He visited his son in Hawaii only once , at Christmas 1971 , before he was killed in an automobile accident in 1982 , when Obama was 21 years old . Recalling his early childhood , Obama said , \" That my father looked nothing like the people around me - that he was black as pitch , my mother white as milk - barely registered in my mind . \" He described his struggles as a young adult to reconcile social perceptions of his multiracial heritage ."
  },
  {
    "sentences": [
      [
        "In",
        "1963",
        ",",
        "Dunham",
        "met",
        "Lolo",
        "Soetoro",
        "at",
        "the",
        "University",
        "of",
        "Hawaii",
        ";",
        "he",
        "was",
        "an",
        "Indonesian",
        "East",
        "-",
        "West",
        "Center",
        "graduate",
        "student",
        "in",
        "geography",
        "."
      ],
      [
        "The",
        "couple",
        "married",
        "on",
        "Molokai",
        "on",
        "March",
        "15",
        ",",
        "1965",
        "."
      ],
      [
        "After",
        "two",
        "one",
        "-",
        "year",
        "extensions",
        "of",
        "his",
        "J-1",
        "visa",
        ",",
        "Lolo",
        "returned",
        "to",
        "Indonesia",
        "in",
        "1966",
        "."
      ],
      [
        "His",
        "wife",
        "and",
        "stepson",
        "followed",
        "sixteen",
        "months",
        "later",
        "in",
        "1967",
        "."
      ],
      [
        "The",
        "family",
        "initially",
        "lived",
        "in",
        "the",
        "Menteng",
        "Dalam",
        "neighborhood",
        "in",
        "the",
        "Tebet",
        "sub",
        "district",
        "of",
        "south",
        "Jakarta",
        "."
      ],
      [
        "From",
        "1970",
        ",",
        "they",
        "lived",
        "in",
        "a",
        "wealthier",
        "neighborhood",
        "in",
        "the",
        "Menteng",
        "sub",
        "district",
        "of",
        "central",
        "Jakarta",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            3,
            3
          ],
          [
            13,
            13
          ],
          [
            44,
            44
          ]
        ],
        "sequences": [
          [
            "Dunham"
          ],
          [
            "he"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279807.848507B",
        "main_words": [
          "Dunham"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            3,
            3
          ]
        ],
        "words": [
          {
            "id": "1571279807.848498A",
            "sequences": [
              "Dunham"
            ],
            "positions": [
              3,
              3
            ]
          },
          {
            "id": "1571279807.848504A",
            "sequences": [
              "he"
            ],
            "positions": [
              13,
              13
            ]
          },
          {
            "id": "1571279807.848506A",
            "sequences": [
              "his"
            ],
            "positions": [
              44,
              44
            ]
          }
        ]
      },
      {
        "main_words": [
          "Lolo Soetoro"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              5,
              6
            ]
          ]
        ],
        "positions": [
          [
            5,
            6
          ]
        ],
        "sequences": [
          [
            "Lolo",
            "Soetoro"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON"
          ]
        ],
        "flags": 1,
        "id": "1571279807.85296B",
        "words": [
          {
            "id": "1571279807.852969A",
            "sequences": [
              "Lolo",
              "Soetoro"
            ],
            "positions": [
              5,
              6
            ]
          }
        ]
      },
      {
        "main_words": [
          "Lolo"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              48,
              48
            ]
          ]
        ],
        "positions": [
          [
            48,
            48
          ],
          [
            55,
            55
          ]
        ],
        "sequences": [
          [
            "Lolo"
          ],
          [
            "His"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ]
        ],
        "flags": 1,
        "id": "1571279807.852965B",
        "words": [
          {
            "id": "1571279807.852971A",
            "sequences": [
              "Lolo"
            ],
            "positions": [
              48,
              48
            ]
          },
          {
            "id": "1571279807.852972A",
            "sequences": [
              "His"
            ],
            "positions": [
              55,
              55
            ]
          }
        ]
      },
      {
        "positions": [
          [
            26,
            27
          ],
          [
            66,
            67
          ],
          [
            87,
            87
          ]
        ],
        "sequences": [
          [
            "The",
            "couple"
          ],
          [
            "The",
            "family"
          ],
          [
            "they"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O"
          ],
          [
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279807.853014B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279807.853007A",
            "sequences": [
              "The",
              "couple"
            ],
            "positions": [
              26,
              27
            ]
          },
          {
            "id": "1571279807.85301A",
            "sequences": [
              "The",
              "family"
            ],
            "positions": [
              66,
              67
            ]
          },
          {
            "id": "1571279807.853012A",
            "sequences": [
              "they"
            ],
            "positions": [
              87,
              87
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "B-LOC",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LOC",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "B-CARDINAL",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-FAC",
      "I-FAC",
      "I-FAC",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O"
    ],
    "doc_tokens": [
      "In",
      "1963",
      ",",
      "Dunham",
      "met",
      "Lolo",
      "Soetoro",
      "at",
      "the",
      "University",
      "of",
      "Hawaii",
      ";",
      "he",
      "was",
      "an",
      "Indonesian",
      "East",
      "-",
      "West",
      "Center",
      "graduate",
      "student",
      "in",
      "geography",
      ".",
      "The",
      "couple",
      "married",
      "on",
      "Molokai",
      "on",
      "March",
      "15",
      ",",
      "1965",
      ".",
      "After",
      "two",
      "one",
      "-",
      "year",
      "extensions",
      "of",
      "his",
      "J-1",
      "visa",
      ",",
      "Lolo",
      "returned",
      "to",
      "Indonesia",
      "in",
      "1966",
      ".",
      "His",
      "wife",
      "and",
      "stepson",
      "followed",
      "sixteen",
      "months",
      "later",
      "in",
      "1967",
      ".",
      "The",
      "family",
      "initially",
      "lived",
      "in",
      "the",
      "Menteng",
      "Dalam",
      "neighborhood",
      "in",
      "the",
      "Tebet",
      "sub",
      "district",
      "of",
      "south",
      "Jakarta",
      ".",
      "From",
      "1970",
      ",",
      "they",
      "lived",
      "in",
      "a",
      "wealthier",
      "neighborhood",
      "in",
      "the",
      "Menteng",
      "sub",
      "district",
      "of",
      "central",
      "Jakarta",
      "."
    ],
    "complete_sentence": "In 1963 , Dunham met Lolo Soetoro at the University of Hawaii ; he was an Indonesian East - West Center graduate student in geography . The couple married on Molokai on March 15 , 1965 . After two one - year extensions of his J-1 visa , Lolo returned to Indonesia in 1966 . His wife and stepson followed sixteen months later in 1967 . The family initially lived in the Menteng Dalam neighborhood in the Tebet sub district of south Jakarta . From 1970 , they lived in a wealthier neighborhood in the Menteng sub district of central Jakarta ."
  },
  {
    "sentences": [
      [
        "Obama",
        "started",
        "in",
        "St.",
        "Francis",
        "Pre",
        "-",
        "Education",
        "from",
        "age",
        "three",
        "to",
        "five",
        "."
      ],
      [
        "From",
        "age",
        "six",
        "to",
        "ten",
        ",",
        "he",
        "then",
        "attended",
        "local",
        "Indonesian",
        "-",
        "language",
        "schools",
        ":"
      ],
      [
        "Sekolah",
        "Dasar"
      ],
      [
        "Katolik",
        "Santo"
      ],
      [
        "Fransiskus",
        "Asisi",
        "(",
        "St.",
        "Francis",
        "of",
        "Assisi",
        "Catholic",
        "Elementary",
        "School",
        ")",
        "for",
        "two",
        "years",
        "and"
      ],
      [
        "Sekolah",
        "Dasar"
      ],
      [
        "Negeri",
        "Menteng",
        "01"
      ],
      [
        "(",
        "State",
        "Elementary",
        "School",
        "Menteng",
        "01/Besuki",
        "school",
        ")",
        "for",
        "one",
        "and",
        "a",
        "half",
        "years",
        ",",
        "supplemented",
        "by",
        "English",
        "-",
        "language",
        "Calvert",
        "School",
        "homeschooling",
        "by",
        "his",
        "mother",
        "."
      ],
      [
        "As",
        "a",
        "result",
        "of",
        "those",
        "four",
        "years",
        "in",
        "Jakarta",
        ",",
        "he",
        "was",
        "able",
        "to",
        "speak",
        "Indonesian",
        "fluently",
        "as",
        "a",
        "child",
        "."
      ],
      [
        "During",
        "his",
        "time",
        "in",
        "Indonesia",
        ",",
        "Obama",
        "'s",
        "step",
        "-",
        "father",
        "taught",
        "him",
        "to",
        "be",
        "resilient",
        "and",
        "gave",
        "him",
        "\"",
        "a",
        "pretty",
        "hardheaded",
        "assessment",
        "of",
        "how",
        "the",
        "world",
        "works",
        "\"",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            20,
            20
          ],
          [
            77,
            77
          ],
          [
            90,
            90
          ],
          [
            102,
            102
          ],
          [
            107,
            108
          ],
          [
            107,
            111
          ],
          [
            113,
            113
          ],
          [
            119,
            119
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "Obama",
            "'s"
          ],
          [
            "Obama",
            "'s",
            "step",
            "-",
            "father"
          ],
          [
            "him"
          ],
          [
            "him"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON",
            "O"
          ],
          [
            "B-PERSON",
            "O",
            "O",
            "O",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279809.476443B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279809.476426A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279809.476433A",
            "sequences": [
              "he"
            ],
            "positions": [
              20,
              20
            ]
          },
          {
            "id": "1571279809.476434A",
            "sequences": [
              "his"
            ],
            "positions": [
              77,
              77
            ]
          },
          {
            "id": "1571279809.476436A",
            "sequences": [
              "he"
            ],
            "positions": [
              90,
              90
            ]
          },
          {
            "id": "1571279809.476437A",
            "sequences": [
              "his"
            ],
            "positions": [
              102,
              102
            ]
          },
          {
            "id": "1571279809.476438A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              107,
              108
            ]
          },
          {
            "id": "1571279809.476439A",
            "sequences": [
              "Obama",
              "'s",
              "step",
              "-",
              "father"
            ],
            "positions": [
              107,
              111
            ]
          },
          {
            "id": "1571279809.47644A",
            "sequences": [
              "him"
            ],
            "positions": [
              113,
              113
            ]
          },
          {
            "id": "1571279809.476442A",
            "sequences": [
              "him"
            ],
            "positions": [
              119,
              119
            ]
          }
        ]
      },
      {
        "positions": [
          [
            29,
            30
          ],
          [
            48,
            49
          ]
        ],
        "sequences": [
          [
            "Sekolah",
            "Dasar"
          ],
          [
            "Sekolah",
            "Dasar"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "B-PERSON",
            "I-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279809.476456B",
        "main_words": [
          "Sekolah Dasar"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            29,
            30
          ],
          [
            48,
            49
          ]
        ],
        "words": [
          {
            "id": "1571279809.476453A",
            "sequences": [
              "Sekolah",
              "Dasar"
            ],
            "positions": [
              29,
              30
            ]
          },
          {
            "id": "1571279809.476455A",
            "sequences": [
              "Sekolah",
              "Dasar"
            ],
            "positions": [
              48,
              49
            ]
          }
        ]
      },
      {
        "positions": [
          [
            62,
            66
          ],
          [
            84,
            88
          ]
        ],
        "sequences": [
          [
            "one",
            "and",
            "a",
            "half",
            "years"
          ],
          [
            "those",
            "four",
            "years",
            "in",
            "Jakarta"
          ]
        ],
        "ner_sequences": [
          [
            "B-DATE",
            "I-DATE",
            "I-DATE",
            "I-DATE",
            "I-DATE"
          ],
          [
            "B-DATE",
            "I-DATE",
            "I-DATE",
            "O",
            "B-GPE"
          ]
        ],
        "flags": -1,
        "id": "1571279809.476466B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279809.476463A",
            "sequences": [
              "one",
              "and",
              "a",
              "half",
              "years"
            ],
            "positions": [
              62,
              66
            ]
          },
          {
            "id": "1571279809.476465A",
            "sequences": [
              "those",
              "four",
              "years",
              "in",
              "Jakarta"
            ],
            "positions": [
              84,
              88
            ]
          }
        ]
      },
      {
        "main_words": [
          "Indonesian"
        ],
        "ner_tags": [
          "NORP"
        ],
        "position_main_word": [
          [
            [
              95,
              95
            ]
          ]
        ],
        "positions": [
          [
            95,
            95
          ]
        ],
        "sequences": [
          [
            "Indonesian"
          ]
        ],
        "ner_sequences": [
          [
            "B-NORP"
          ]
        ],
        "flags": 1,
        "id": "1571279809.479869B",
        "words": [
          {
            "id": "1571279809.479877A",
            "sequences": [
              "Indonesian"
            ],
            "positions": [
              95,
              95
            ]
          }
        ]
      },
      {
        "main_words": [
          "Indonesia"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            [
              105,
              105
            ]
          ]
        ],
        "positions": [
          [
            105,
            105
          ]
        ],
        "sequences": [
          [
            "Indonesia"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ]
        ],
        "flags": 1,
        "id": "1571279809.479874B",
        "words": [
          {
            "id": "1571279809.479879A",
            "sequences": [
              "Indonesia"
            ],
            "positions": [
              105,
              105
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LANGUAGE",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "B-PERSON",
      "I-PERSON",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "I-PERSON",
      "B-EVENT",
      "I-ORG",
      "I-EVENT",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "B-LANGUAGE",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "started",
      "in",
      "St.",
      "Francis",
      "Pre",
      "-",
      "Education",
      "from",
      "age",
      "three",
      "to",
      "five",
      ".",
      "From",
      "age",
      "six",
      "to",
      "ten",
      ",",
      "he",
      "then",
      "attended",
      "local",
      "Indonesian",
      "-",
      "language",
      "schools",
      ":",
      "Sekolah",
      "Dasar",
      "Katolik",
      "Santo",
      "Fransiskus",
      "Asisi",
      "(",
      "St.",
      "Francis",
      "of",
      "Assisi",
      "Catholic",
      "Elementary",
      "School",
      ")",
      "for",
      "two",
      "years",
      "and",
      "Sekolah",
      "Dasar",
      "Negeri",
      "Menteng",
      "01",
      "(",
      "State",
      "Elementary",
      "School",
      "Menteng",
      "01/Besuki",
      "school",
      ")",
      "for",
      "one",
      "and",
      "a",
      "half",
      "years",
      ",",
      "supplemented",
      "by",
      "English",
      "-",
      "language",
      "Calvert",
      "School",
      "homeschooling",
      "by",
      "his",
      "mother",
      ".",
      "As",
      "a",
      "result",
      "of",
      "those",
      "four",
      "years",
      "in",
      "Jakarta",
      ",",
      "he",
      "was",
      "able",
      "to",
      "speak",
      "Indonesian",
      "fluently",
      "as",
      "a",
      "child",
      ".",
      "During",
      "his",
      "time",
      "in",
      "Indonesia",
      ",",
      "Obama",
      "'s",
      "step",
      "-",
      "father",
      "taught",
      "him",
      "to",
      "be",
      "resilient",
      "and",
      "gave",
      "him",
      "\"",
      "a",
      "pretty",
      "hardheaded",
      "assessment",
      "of",
      "how",
      "the",
      "world",
      "works",
      "\"",
      "."
    ],
    "complete_sentence": "Obama started in St. Francis Pre - Education from age three to five . From age six to ten , he then attended local Indonesian - language schools : Sekolah Dasar Katolik Santo Fransiskus Asisi ( St. Francis of Assisi Catholic Elementary School ) for two years and Sekolah Dasar Negeri Menteng 01 ( State Elementary School Menteng 01/Besuki school ) for one and a half years , supplemented by English - language Calvert School homeschooling by his mother . As a result of those four years in Jakarta , he was able to speak Indonesian fluently as a child . During his time in Indonesia , Obama 's step - father taught him to be resilient and gave him \" a pretty hardheaded assessment of how the world works \" ."
  },
  {
    "sentences": [
      [
        "In",
        "1971",
        ",",
        "Obama",
        "returned",
        "to",
        "Honolulu",
        "to",
        "live",
        "with",
        "his",
        "maternal",
        "grandparents",
        ",",
        "Madelyn",
        "and",
        "Stanley",
        "Dunham",
        "."
      ],
      [
        "He",
        "attended",
        "Punahou",
        "School",
        "--",
        "a",
        "private",
        "college",
        "preparatory",
        "school",
        "--",
        "with",
        "the",
        "aid",
        "of",
        "a",
        "scholarship",
        "from",
        "fifth",
        "grade",
        "until",
        "he",
        "graduated",
        "from",
        "high",
        "school",
        "in",
        "1979",
        "."
      ],
      [
        "In",
        "his",
        "youth",
        ",",
        "Obama",
        "went",
        "by",
        "the",
        "nickname",
        "\"",
        "Barry",
        "\"",
        "."
      ],
      [
        "Obama",
        "lived",
        "with",
        "his",
        "mother",
        "and",
        "half",
        "-",
        "sister",
        ",",
        "Maya",
        "Soetoro",
        ",",
        "in",
        "Hawaii",
        "for",
        "three",
        "years",
        "from",
        "1972",
        "to",
        "1975",
        "while",
        "his",
        "mother",
        "was",
        "a",
        "graduate",
        "student",
        "in",
        "anthropology",
        "at",
        "the",
        "University",
        "of",
        "Hawaii",
        "."
      ],
      [
        "Obama",
        "chose",
        "to",
        "stay",
        "in",
        "Hawaii",
        "with",
        "his",
        "grandparents",
        "for",
        "high",
        "school",
        "at",
        "Punahou",
        "when",
        "his",
        "mother",
        "and",
        "half",
        "-",
        "sister",
        "returned",
        "to",
        "Indonesia",
        "in",
        "1975",
        "so",
        "his",
        "mother",
        "could",
        "begin",
        "anthropology",
        "field",
        "work",
        "."
      ],
      [
        "His",
        "mother",
        "spent",
        "most",
        "of",
        "the",
        "next",
        "two",
        "decades",
        "in",
        "Indonesia",
        ",",
        "divorcing",
        "Lolo",
        "in",
        "1980",
        "and",
        "earning",
        "a",
        "PhD",
        "degree",
        "in",
        "1992",
        ",",
        "before",
        "dying",
        "in",
        "1995",
        "in",
        "Hawaii",
        "following",
        "unsuccessful",
        "treatment",
        "for",
        "ovarian",
        "and",
        "uterine",
        "cancer",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            3,
            3
          ],
          [
            10,
            10
          ],
          [
            19,
            19
          ],
          [
            40,
            40
          ],
          [
            49,
            49
          ],
          [
            52,
            52
          ],
          [
            61,
            61
          ],
          [
            64,
            64
          ],
          [
            84,
            84
          ],
          [
            98,
            98
          ],
          [
            105,
            105
          ],
          [
            113,
            113
          ],
          [
            125,
            125
          ],
          [
            133,
            133
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "His"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279810.599368B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            3,
            3
          ],
          [
            52,
            52
          ],
          [
            61,
            61
          ],
          [
            98,
            98
          ]
        ],
        "words": [
          {
            "id": "1571279810.599347A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              3,
              3
            ]
          },
          {
            "id": "1571279810.599353A",
            "sequences": [
              "his"
            ],
            "positions": [
              10,
              10
            ]
          },
          {
            "id": "1571279810.599355A",
            "sequences": [
              "He"
            ],
            "positions": [
              19,
              19
            ]
          },
          {
            "id": "1571279810.599356A",
            "sequences": [
              "he"
            ],
            "positions": [
              40,
              40
            ]
          },
          {
            "id": "1571279810.599357A",
            "sequences": [
              "his"
            ],
            "positions": [
              49,
              49
            ]
          },
          {
            "id": "1571279810.599358A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              52,
              52
            ]
          },
          {
            "id": "1571279810.59936A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              61,
              61
            ]
          },
          {
            "id": "1571279810.599361A",
            "sequences": [
              "his"
            ],
            "positions": [
              64,
              64
            ]
          },
          {
            "id": "1571279810.599362A",
            "sequences": [
              "his"
            ],
            "positions": [
              84,
              84
            ]
          },
          {
            "id": "1571279810.599363A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              98,
              98
            ]
          },
          {
            "id": "1571279810.599364A",
            "sequences": [
              "his"
            ],
            "positions": [
              105,
              105
            ]
          },
          {
            "id": "1571279810.599365A",
            "sequences": [
              "his"
            ],
            "positions": [
              113,
              113
            ]
          },
          {
            "id": "1571279810.599366A",
            "sequences": [
              "his"
            ],
            "positions": [
              125,
              125
            ]
          },
          {
            "id": "1571279810.599367A",
            "sequences": [
              "His"
            ],
            "positions": [
              133,
              133
            ]
          }
        ]
      },
      {
        "positions": [
          [
            75,
            75
          ],
          [
            103,
            103
          ],
          [
            162,
            162
          ]
        ],
        "sequences": [
          [
            "Hawaii"
          ],
          [
            "Hawaii"
          ],
          [
            "Hawaii"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279810.599381B",
        "main_words": [
          "Hawaii"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            75,
            75
          ],
          [
            103,
            103
          ],
          [
            162,
            162
          ]
        ],
        "words": [
          {
            "id": "1571279810.599378A",
            "sequences": [
              "Hawaii"
            ],
            "positions": [
              75,
              75
            ]
          },
          {
            "id": "1571279810.599379A",
            "sequences": [
              "Hawaii"
            ],
            "positions": [
              103,
              103
            ]
          },
          {
            "id": "1571279810.59938A",
            "sequences": [
              "Hawaii"
            ],
            "positions": [
              162,
              162
            ]
          }
        ]
      },
      {
        "positions": [
          [
            84,
            85
          ],
          [
            125,
            126
          ],
          [
            133,
            134
          ]
        ],
        "sequences": [
          [
            "his",
            "mother"
          ],
          [
            "his",
            "mother"
          ],
          [
            "His",
            "mother"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O"
          ],
          [
            "O",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279810.599391B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279810.599387A",
            "sequences": [
              "his",
              "mother"
            ],
            "positions": [
              84,
              85
            ]
          },
          {
            "id": "1571279810.599388A",
            "sequences": [
              "his",
              "mother"
            ],
            "positions": [
              125,
              126
            ]
          },
          {
            "id": "1571279810.599389A",
            "sequences": [
              "His",
              "mother"
            ],
            "positions": [
              133,
              134
            ]
          }
        ]
      },
      {
        "positions": [
          [
            121,
            121
          ],
          [
            143,
            143
          ]
        ],
        "sequences": [
          [
            "Indonesia"
          ],
          [
            "Indonesia"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279810.599399B",
        "main_words": [
          "Indonesia"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            121,
            121
          ],
          [
            143,
            143
          ]
        ],
        "words": [
          {
            "id": "1571279810.599397A",
            "sequences": [
              "Indonesia"
            ],
            "positions": [
              121,
              121
            ]
          },
          {
            "id": "1571279810.599398A",
            "sequences": [
              "Indonesia"
            ],
            "positions": [
              143,
              143
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-PERSON",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-WORK_OF_ART",
      "I-WORK_OF_ART",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "In",
      "1971",
      ",",
      "Obama",
      "returned",
      "to",
      "Honolulu",
      "to",
      "live",
      "with",
      "his",
      "maternal",
      "grandparents",
      ",",
      "Madelyn",
      "and",
      "Stanley",
      "Dunham",
      ".",
      "He",
      "attended",
      "Punahou",
      "School",
      "--",
      "a",
      "private",
      "college",
      "preparatory",
      "school",
      "--",
      "with",
      "the",
      "aid",
      "of",
      "a",
      "scholarship",
      "from",
      "fifth",
      "grade",
      "until",
      "he",
      "graduated",
      "from",
      "high",
      "school",
      "in",
      "1979",
      ".",
      "In",
      "his",
      "youth",
      ",",
      "Obama",
      "went",
      "by",
      "the",
      "nickname",
      "\"",
      "Barry",
      "\"",
      ".",
      "Obama",
      "lived",
      "with",
      "his",
      "mother",
      "and",
      "half",
      "-",
      "sister",
      ",",
      "Maya",
      "Soetoro",
      ",",
      "in",
      "Hawaii",
      "for",
      "three",
      "years",
      "from",
      "1972",
      "to",
      "1975",
      "while",
      "his",
      "mother",
      "was",
      "a",
      "graduate",
      "student",
      "in",
      "anthropology",
      "at",
      "the",
      "University",
      "of",
      "Hawaii",
      ".",
      "Obama",
      "chose",
      "to",
      "stay",
      "in",
      "Hawaii",
      "with",
      "his",
      "grandparents",
      "for",
      "high",
      "school",
      "at",
      "Punahou",
      "when",
      "his",
      "mother",
      "and",
      "half",
      "-",
      "sister",
      "returned",
      "to",
      "Indonesia",
      "in",
      "1975",
      "so",
      "his",
      "mother",
      "could",
      "begin",
      "anthropology",
      "field",
      "work",
      ".",
      "His",
      "mother",
      "spent",
      "most",
      "of",
      "the",
      "next",
      "two",
      "decades",
      "in",
      "Indonesia",
      ",",
      "divorcing",
      "Lolo",
      "in",
      "1980",
      "and",
      "earning",
      "a",
      "PhD",
      "degree",
      "in",
      "1992",
      ",",
      "before",
      "dying",
      "in",
      "1995",
      "in",
      "Hawaii",
      "following",
      "unsuccessful",
      "treatment",
      "for",
      "ovarian",
      "and",
      "uterine",
      "cancer",
      "."
    ],
    "complete_sentence": "In 1971 , Obama returned to Honolulu to live with his maternal grandparents , Madelyn and Stanley Dunham . He attended Punahou School -- a private college preparatory school -- with the aid of a scholarship from fifth grade until he graduated from high school in 1979 . In his youth , Obama went by the nickname \" Barry \" . Obama lived with his mother and half - sister , Maya Soetoro , in Hawaii for three years from 1972 to 1975 while his mother was a graduate student in anthropology at the University of Hawaii . Obama chose to stay in Hawaii with his grandparents for high school at Punahou when his mother and half - sister returned to Indonesia in 1975 so his mother could begin anthropology field work . His mother spent most of the next two decades in Indonesia , divorcing Lolo in 1980 and earning a PhD degree in 1992 , before dying in 1995 in Hawaii following unsuccessful treatment for ovarian and uterine cancer ."
  },
  {
    "sentences": [
      [
        "Obama",
        "later",
        "reflected",
        "on",
        "his",
        "years",
        "in",
        "Honolulu",
        "and",
        "wrote",
        ":",
        "\"",
        "The",
        "opportunity",
        "that",
        "Hawaii",
        "offered",
        "-",
        "to",
        "experience",
        "a",
        "variety",
        "of",
        "cultures",
        "in",
        "a",
        "climate",
        "of",
        "mutual",
        "respect",
        "-",
        "became",
        "an",
        "integral",
        "part",
        "of",
        "my",
        "world",
        "view",
        ",",
        "and",
        "a",
        "basis",
        "for",
        "the",
        "values",
        "that",
        "I",
        "hold",
        "most",
        "dear",
        "."
      ],
      [
        "\""
      ],
      [
        "Obama",
        "has",
        "also",
        "written",
        "and",
        "talked",
        "about",
        "using",
        "alcohol",
        ",",
        "marijuana",
        ",",
        "and",
        "cocaine",
        "during",
        "his",
        "teenage",
        "years",
        "to",
        "\"",
        "push",
        "questions",
        "of",
        "who",
        "I",
        "was",
        "out",
        "of",
        "my",
        "mind",
        "\"",
        "."
      ],
      [
        "Obama",
        "was",
        "also",
        "a",
        "member",
        "of",
        "the",
        "\"",
        "choom",
        "gang",
        "\"",
        ",",
        "a",
        "self",
        "-",
        "named",
        "group",
        "of",
        "friends",
        "who",
        "spent",
        "time",
        "together",
        "and",
        "occasionally",
        "smoked",
        "marijuana",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            4,
            4
          ],
          [
            36,
            36
          ],
          [
            47,
            47
          ],
          [
            53,
            53
          ],
          [
            68,
            68
          ],
          [
            77,
            77
          ],
          [
            81,
            81
          ],
          [
            85,
            85
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "my"
          ],
          [
            "I"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "I"
          ],
          [
            "my"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279811.917579B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            0
          ],
          [
            53,
            53
          ],
          [
            85,
            85
          ]
        ],
        "words": [
          {
            "id": "1571279811.917562A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279811.917569A",
            "sequences": [
              "his"
            ],
            "positions": [
              4,
              4
            ]
          },
          {
            "id": "1571279811.917571A",
            "sequences": [
              "my"
            ],
            "positions": [
              36,
              36
            ]
          },
          {
            "id": "1571279811.917572A",
            "sequences": [
              "I"
            ],
            "positions": [
              47,
              47
            ]
          },
          {
            "id": "1571279811.917573A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              53,
              53
            ]
          },
          {
            "id": "1571279811.917574A",
            "sequences": [
              "his"
            ],
            "positions": [
              68,
              68
            ]
          },
          {
            "id": "1571279811.917575A",
            "sequences": [
              "I"
            ],
            "positions": [
              77,
              77
            ]
          },
          {
            "id": "1571279811.917577A",
            "sequences": [
              "my"
            ],
            "positions": [
              81,
              81
            ]
          },
          {
            "id": "1571279811.917578A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              85,
              85
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "later",
      "reflected",
      "on",
      "his",
      "years",
      "in",
      "Honolulu",
      "and",
      "wrote",
      ":",
      "\"",
      "The",
      "opportunity",
      "that",
      "Hawaii",
      "offered",
      "-",
      "to",
      "experience",
      "a",
      "variety",
      "of",
      "cultures",
      "in",
      "a",
      "climate",
      "of",
      "mutual",
      "respect",
      "-",
      "became",
      "an",
      "integral",
      "part",
      "of",
      "my",
      "world",
      "view",
      ",",
      "and",
      "a",
      "basis",
      "for",
      "the",
      "values",
      "that",
      "I",
      "hold",
      "most",
      "dear",
      ".",
      "\"",
      "Obama",
      "has",
      "also",
      "written",
      "and",
      "talked",
      "about",
      "using",
      "alcohol",
      ",",
      "marijuana",
      ",",
      "and",
      "cocaine",
      "during",
      "his",
      "teenage",
      "years",
      "to",
      "\"",
      "push",
      "questions",
      "of",
      "who",
      "I",
      "was",
      "out",
      "of",
      "my",
      "mind",
      "\"",
      ".",
      "Obama",
      "was",
      "also",
      "a",
      "member",
      "of",
      "the",
      "\"",
      "choom",
      "gang",
      "\"",
      ",",
      "a",
      "self",
      "-",
      "named",
      "group",
      "of",
      "friends",
      "who",
      "spent",
      "time",
      "together",
      "and",
      "occasionally",
      "smoked",
      "marijuana",
      "."
    ],
    "complete_sentence": "Obama later reflected on his years in Honolulu and wrote : \" The opportunity that Hawaii offered - to experience a variety of cultures in a climate of mutual respect - became an integral part of my world view , and a basis for the values that I hold most dear . \" Obama has also written and talked about using alcohol , marijuana , and cocaine during his teenage years to \" push questions of who I was out of my mind \" . Obama was also a member of the \" choom gang \" , a self - named group of friends who spent time together and occasionally smoked marijuana ."
  },
  {
    "sentences": [
      [
        "After",
        "graduating",
        "from",
        "high",
        "school",
        "in",
        "1979",
        ",",
        "Obama",
        "moved",
        "to",
        "Los",
        "Angeles",
        "to",
        "attend",
        "Occidental",
        "College",
        "."
      ],
      [
        "In",
        "February",
        "1981",
        ",",
        "Obama",
        "made",
        "his",
        "first",
        "public",
        "speech",
        ",",
        "calling",
        "for",
        "Occidental",
        "to",
        "participate",
        "in",
        "the",
        "disinvestment",
        "from",
        "South",
        "Africa",
        "in",
        "response",
        "to",
        "that",
        "nation",
        "'s",
        "policy",
        "of",
        "apartheid",
        "."
      ],
      [
        "In",
        "mid-1981",
        ",",
        "Obama",
        "traveled",
        "to",
        "Indonesia",
        "to",
        "visit",
        "his",
        "mother",
        "and",
        "half",
        "-",
        "sister",
        "Maya",
        ",",
        "and",
        "visited",
        "the",
        "families",
        "of",
        "college",
        "friends",
        "in",
        "Pakistan",
        "and",
        "India",
        "for",
        "three",
        "weeks",
        "."
      ],
      [
        "Later",
        "in",
        "1981",
        ",",
        "he",
        "transferred",
        "as",
        "a",
        "junior",
        "to",
        "Columbia",
        "University",
        "in",
        "New",
        "York",
        "City",
        ",",
        "where",
        "he",
        "majored",
        "in",
        "political",
        "science",
        "with",
        "a",
        "specialty",
        "in",
        "international",
        "relations",
        "and",
        "in",
        "English",
        "literature",
        "and",
        "lived",
        "off",
        "-",
        "campus",
        "on",
        "West",
        "109th",
        "Street",
        "."
      ],
      [
        "He",
        "graduated",
        "with",
        "a",
        "BA",
        "degree",
        "in",
        "1983",
        "and",
        "worked",
        "for",
        "about",
        "a",
        "year",
        "at",
        "the",
        "Business",
        "International",
        "Corporation",
        ",",
        "where",
        "he",
        "was",
        "a",
        "financial",
        "researcher",
        "and",
        "writer",
        ",",
        "then",
        "as",
        "a",
        "project",
        "coordinator",
        "for",
        "the",
        "New",
        "York",
        "Public",
        "Interest",
        "Research",
        "Group",
        "on",
        "the",
        "City",
        "College",
        "of",
        "New",
        "York",
        "campus",
        "for",
        "three",
        "months",
        "in",
        "1985",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            8,
            8
          ],
          [
            22,
            22
          ],
          [
            24,
            24
          ],
          [
            53,
            53
          ],
          [
            59,
            59
          ],
          [
            86,
            86
          ],
          [
            100,
            100
          ],
          [
            125,
            125
          ],
          [
            146,
            146
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279813.394447B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            8,
            8
          ],
          [
            22,
            22
          ],
          [
            53,
            53
          ]
        ],
        "words": [
          {
            "id": "1571279813.394431A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              8,
              8
            ]
          },
          {
            "id": "1571279813.394437A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              22,
              22
            ]
          },
          {
            "id": "1571279813.394439A",
            "sequences": [
              "his"
            ],
            "positions": [
              24,
              24
            ]
          },
          {
            "id": "1571279813.39444A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              53,
              53
            ]
          },
          {
            "id": "1571279813.394441A",
            "sequences": [
              "his"
            ],
            "positions": [
              59,
              59
            ]
          },
          {
            "id": "1571279813.394442A",
            "sequences": [
              "he"
            ],
            "positions": [
              86,
              86
            ]
          },
          {
            "id": "1571279813.394444A",
            "sequences": [
              "he"
            ],
            "positions": [
              100,
              100
            ]
          },
          {
            "id": "1571279813.394445A",
            "sequences": [
              "He"
            ],
            "positions": [
              125,
              125
            ]
          },
          {
            "id": "1571279813.394446A",
            "sequences": [
              "he"
            ],
            "positions": [
              146,
              146
            ]
          }
        ]
      },
      {
        "main_words": [
          "Occidental College"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              15,
              16
            ]
          ]
        ],
        "positions": [
          [
            15,
            16
          ]
        ],
        "sequences": [
          [
            "Occidental",
            "College"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279813.398025B",
        "words": [
          {
            "id": "1571279813.398033A",
            "sequences": [
              "Occidental",
              "College"
            ],
            "positions": [
              15,
              16
            ]
          }
        ]
      },
      {
        "main_words": [
          "Occidental"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              31,
              31
            ]
          ]
        ],
        "positions": [
          [
            31,
            31
          ]
        ],
        "sequences": [
          [
            "Occidental"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279813.398029B",
        "words": [
          {
            "id": "1571279813.398035A",
            "sequences": [
              "Occidental"
            ],
            "positions": [
              31,
              31
            ]
          }
        ]
      },
      {
        "positions": [
          [
            38,
            39
          ],
          [
            43,
            45
          ]
        ],
        "sequences": [
          [
            "South",
            "Africa"
          ],
          [
            "that",
            "nation",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE",
            "I-GPE"
          ],
          [
            "O",
            "O",
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279813.398051B",
        "main_words": [
          "South Africa"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            38,
            39
          ]
        ],
        "words": [
          {
            "id": "1571279813.398048A",
            "sequences": [
              "South",
              "Africa"
            ],
            "positions": [
              38,
              39
            ]
          },
          {
            "id": "1571279813.39805A",
            "sequences": [
              "that",
              "nation",
              "'s"
            ],
            "positions": [
              43,
              45
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-GPE",
      "I-GPE",
      "I-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LANGUAGE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-FAC",
      "I-FAC",
      "I-FAC",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O"
    ],
    "doc_tokens": [
      "After",
      "graduating",
      "from",
      "high",
      "school",
      "in",
      "1979",
      ",",
      "Obama",
      "moved",
      "to",
      "Los",
      "Angeles",
      "to",
      "attend",
      "Occidental",
      "College",
      ".",
      "In",
      "February",
      "1981",
      ",",
      "Obama",
      "made",
      "his",
      "first",
      "public",
      "speech",
      ",",
      "calling",
      "for",
      "Occidental",
      "to",
      "participate",
      "in",
      "the",
      "disinvestment",
      "from",
      "South",
      "Africa",
      "in",
      "response",
      "to",
      "that",
      "nation",
      "'s",
      "policy",
      "of",
      "apartheid",
      ".",
      "In",
      "mid-1981",
      ",",
      "Obama",
      "traveled",
      "to",
      "Indonesia",
      "to",
      "visit",
      "his",
      "mother",
      "and",
      "half",
      "-",
      "sister",
      "Maya",
      ",",
      "and",
      "visited",
      "the",
      "families",
      "of",
      "college",
      "friends",
      "in",
      "Pakistan",
      "and",
      "India",
      "for",
      "three",
      "weeks",
      ".",
      "Later",
      "in",
      "1981",
      ",",
      "he",
      "transferred",
      "as",
      "a",
      "junior",
      "to",
      "Columbia",
      "University",
      "in",
      "New",
      "York",
      "City",
      ",",
      "where",
      "he",
      "majored",
      "in",
      "political",
      "science",
      "with",
      "a",
      "specialty",
      "in",
      "international",
      "relations",
      "and",
      "in",
      "English",
      "literature",
      "and",
      "lived",
      "off",
      "-",
      "campus",
      "on",
      "West",
      "109th",
      "Street",
      ".",
      "He",
      "graduated",
      "with",
      "a",
      "BA",
      "degree",
      "in",
      "1983",
      "and",
      "worked",
      "for",
      "about",
      "a",
      "year",
      "at",
      "the",
      "Business",
      "International",
      "Corporation",
      ",",
      "where",
      "he",
      "was",
      "a",
      "financial",
      "researcher",
      "and",
      "writer",
      ",",
      "then",
      "as",
      "a",
      "project",
      "coordinator",
      "for",
      "the",
      "New",
      "York",
      "Public",
      "Interest",
      "Research",
      "Group",
      "on",
      "the",
      "City",
      "College",
      "of",
      "New",
      "York",
      "campus",
      "for",
      "three",
      "months",
      "in",
      "1985",
      "."
    ],
    "complete_sentence": "After graduating from high school in 1979 , Obama moved to Los Angeles to attend Occidental College . In February 1981 , Obama made his first public speech , calling for Occidental to participate in the disinvestment from South Africa in response to that nation 's policy of apartheid . In mid-1981 , Obama traveled to Indonesia to visit his mother and half - sister Maya , and visited the families of college friends in Pakistan and India for three weeks . Later in 1981 , he transferred as a junior to Columbia University in New York City , where he majored in political science with a specialty in international relations and in English literature and lived off - campus on West 109th Street . He graduated with a BA degree in 1983 and worked for about a year at the Business International Corporation , where he was a financial researcher and writer , then as a project coordinator for the New York Public Interest Research Group on the City College of New York campus for three months in 1985 ."
  },
  {
    "sentences": [
      [
        "In",
        "a",
        "2006",
        "interview",
        ",",
        "Obama",
        "highlighted",
        "the",
        "diversity",
        "of",
        "his",
        "extended",
        "family",
        ":",
        "\"",
        "It",
        "'s",
        "like",
        "a",
        "little",
        "mini",
        "-",
        "United",
        "Nations",
        "\"",
        ",",
        "he",
        "said",
        "."
      ],
      [
        "\""
      ],
      [
        "I",
        "'ve",
        "got",
        "relatives",
        "who",
        "look",
        "like",
        "Bernie",
        "Mac",
        ",",
        "and",
        "I",
        "'ve",
        "got",
        "relatives",
        "who",
        "look",
        "like",
        "Margaret",
        "Thatcher",
        "."
      ],
      [
        "\""
      ],
      [
        "Obama",
        "has",
        "a",
        "half",
        "-",
        "sister",
        "with",
        "whom",
        "he",
        "was",
        "raised",
        "(",
        "Maya",
        "Soetoro",
        "-",
        "Ng",
        ")",
        "and",
        "seven",
        "other",
        "half",
        "-",
        "siblings",
        "from",
        "his",
        "Kenyan",
        "father",
        "'s",
        "family",
        "--",
        "six",
        "of",
        "them",
        "living",
        "."
      ],
      [
        "Obama",
        "'s",
        "mother",
        "was",
        "survived",
        "by",
        "her",
        "Kansas",
        "-",
        "born",
        "mother",
        ",",
        "Madelyn",
        "Dunham",
        ",",
        "until",
        "her",
        "death",
        "on",
        "November",
        "2",
        ",",
        "2008",
        ",",
        "two",
        "days",
        "before",
        "his",
        "election",
        "to",
        "the",
        "Presidency",
        "."
      ],
      [
        "Obama",
        "also",
        "has",
        "roots",
        "in",
        "Ireland",
        ";",
        "he",
        "met",
        "with",
        "his",
        "Irish",
        "cousins",
        "in",
        "Moneygall",
        "in",
        "May",
        "2011",
        "."
      ],
      [
        "In",
        "Dreams",
        "from",
        "My",
        "Father",
        ",",
        "Obama",
        "ties",
        "his",
        "mother",
        "'s",
        "family",
        "history",
        "to",
        "possible",
        "Native",
        "American",
        "ancestors",
        "and",
        "distant",
        "relatives",
        "of",
        "Jefferson",
        "Davis",
        ",",
        "President",
        "of",
        "the",
        "Confederate",
        "States",
        "of",
        "America",
        "during",
        "the",
        "American",
        "Civil",
        "War",
        "."
      ],
      [
        "He",
        "also",
        "shares",
        "distant",
        "ancestors",
        "in",
        "common",
        "with",
        "George",
        "W.",
        "Bush",
        "and",
        "Dick",
        "Cheney",
        ",",
        "among",
        "others",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            5,
            5
          ],
          [
            10,
            10
          ],
          [
            26,
            26
          ],
          [
            30,
            30
          ],
          [
            41,
            41
          ],
          [
            52,
            52
          ],
          [
            60,
            60
          ],
          [
            76,
            76
          ],
          [
            87,
            88
          ],
          [
            114,
            114
          ],
          [
            120,
            120
          ],
          [
            127,
            127
          ],
          [
            130,
            130
          ],
          [
            145,
            145
          ],
          [
            147,
            147
          ],
          [
            177,
            177
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "I"
          ],
          [
            "I"
          ],
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "Obama",
            "'s"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "He"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON",
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279815.354681B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            5,
            5
          ],
          [
            52,
            52
          ],
          [
            120,
            120
          ],
          [
            145,
            145
          ]
        ],
        "words": [
          {
            "id": "1571279815.354658A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              5,
              5
            ]
          },
          {
            "id": "1571279815.354664A",
            "sequences": [
              "his"
            ],
            "positions": [
              10,
              10
            ]
          },
          {
            "id": "1571279815.354666A",
            "sequences": [
              "he"
            ],
            "positions": [
              26,
              26
            ]
          },
          {
            "id": "1571279815.354667A",
            "sequences": [
              "I"
            ],
            "positions": [
              30,
              30
            ]
          },
          {
            "id": "1571279815.354668A",
            "sequences": [
              "I"
            ],
            "positions": [
              41,
              41
            ]
          },
          {
            "id": "1571279815.354669A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              52,
              52
            ]
          },
          {
            "id": "1571279815.35467A",
            "sequences": [
              "he"
            ],
            "positions": [
              60,
              60
            ]
          },
          {
            "id": "1571279815.354672A",
            "sequences": [
              "his"
            ],
            "positions": [
              76,
              76
            ]
          },
          {
            "id": "1571279815.354673A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              87,
              88
            ]
          },
          {
            "id": "1571279815.354674A",
            "sequences": [
              "his"
            ],
            "positions": [
              114,
              114
            ]
          },
          {
            "id": "1571279815.354675A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              120,
              120
            ]
          },
          {
            "id": "1571279815.354676A",
            "sequences": [
              "he"
            ],
            "positions": [
              127,
              127
            ]
          },
          {
            "id": "1571279815.354677A",
            "sequences": [
              "his"
            ],
            "positions": [
              130,
              130
            ]
          },
          {
            "id": "1571279815.354678A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              145,
              145
            ]
          },
          {
            "id": "1571279815.354679A",
            "sequences": [
              "his"
            ],
            "positions": [
              147,
              147
            ]
          },
          {
            "id": "1571279815.35468A",
            "sequences": [
              "He"
            ],
            "positions": [
              177,
              177
            ]
          }
        ]
      },
      {
        "positions": [
          [
            10,
            12
          ],
          [
            15,
            15
          ]
        ],
        "sequences": [
          [
            "his",
            "extended",
            "family"
          ],
          [
            "It"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279815.35469B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279815.354688A",
            "sequences": [
              "his",
              "extended",
              "family"
            ],
            "positions": [
              10,
              12
            ]
          },
          {
            "id": "1571279815.354689A",
            "sequences": [
              "It"
            ],
            "positions": [
              15,
              15
            ]
          }
        ]
      },
      {
        "positions": [
          [
            87,
            89
          ],
          [
            93,
            93
          ],
          [
            103,
            103
          ],
          [
            147,
            149
          ]
        ],
        "sequences": [
          [
            "Obama",
            "'s",
            "mother"
          ],
          [
            "her"
          ],
          [
            "her"
          ],
          [
            "his",
            "mother",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "O",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O",
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279815.354704B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279815.354699A",
            "sequences": [
              "Obama",
              "'s",
              "mother"
            ],
            "positions": [
              87,
              89
            ]
          },
          {
            "id": "1571279815.354701A",
            "sequences": [
              "her"
            ],
            "positions": [
              93,
              93
            ]
          },
          {
            "id": "1571279815.354702A",
            "sequences": [
              "her"
            ],
            "positions": [
              103,
              103
            ]
          },
          {
            "id": "1571279815.354703A",
            "sequences": [
              "his",
              "mother",
              "'s"
            ],
            "positions": [
              147,
              149
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "B-ORG",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "B-PERSON",
      "O",
      "B-CARDINAL",
      "I-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "B-WORK_OF_ART",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "I-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "I-GPE",
      "I-GPE",
      "I-GPE",
      "O",
      "O",
      "B-NORP",
      "B-EVENT",
      "I-EVENT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "In",
      "a",
      "2006",
      "interview",
      ",",
      "Obama",
      "highlighted",
      "the",
      "diversity",
      "of",
      "his",
      "extended",
      "family",
      ":",
      "\"",
      "It",
      "'s",
      "like",
      "a",
      "little",
      "mini",
      "-",
      "United",
      "Nations",
      "\"",
      ",",
      "he",
      "said",
      ".",
      "\"",
      "I",
      "'ve",
      "got",
      "relatives",
      "who",
      "look",
      "like",
      "Bernie",
      "Mac",
      ",",
      "and",
      "I",
      "'ve",
      "got",
      "relatives",
      "who",
      "look",
      "like",
      "Margaret",
      "Thatcher",
      ".",
      "\"",
      "Obama",
      "has",
      "a",
      "half",
      "-",
      "sister",
      "with",
      "whom",
      "he",
      "was",
      "raised",
      "(",
      "Maya",
      "Soetoro",
      "-",
      "Ng",
      ")",
      "and",
      "seven",
      "other",
      "half",
      "-",
      "siblings",
      "from",
      "his",
      "Kenyan",
      "father",
      "'s",
      "family",
      "--",
      "six",
      "of",
      "them",
      "living",
      ".",
      "Obama",
      "'s",
      "mother",
      "was",
      "survived",
      "by",
      "her",
      "Kansas",
      "-",
      "born",
      "mother",
      ",",
      "Madelyn",
      "Dunham",
      ",",
      "until",
      "her",
      "death",
      "on",
      "November",
      "2",
      ",",
      "2008",
      ",",
      "two",
      "days",
      "before",
      "his",
      "election",
      "to",
      "the",
      "Presidency",
      ".",
      "Obama",
      "also",
      "has",
      "roots",
      "in",
      "Ireland",
      ";",
      "he",
      "met",
      "with",
      "his",
      "Irish",
      "cousins",
      "in",
      "Moneygall",
      "in",
      "May",
      "2011",
      ".",
      "In",
      "Dreams",
      "from",
      "My",
      "Father",
      ",",
      "Obama",
      "ties",
      "his",
      "mother",
      "'s",
      "family",
      "history",
      "to",
      "possible",
      "Native",
      "American",
      "ancestors",
      "and",
      "distant",
      "relatives",
      "of",
      "Jefferson",
      "Davis",
      ",",
      "President",
      "of",
      "the",
      "Confederate",
      "States",
      "of",
      "America",
      "during",
      "the",
      "American",
      "Civil",
      "War",
      ".",
      "He",
      "also",
      "shares",
      "distant",
      "ancestors",
      "in",
      "common",
      "with",
      "George",
      "W.",
      "Bush",
      "and",
      "Dick",
      "Cheney",
      ",",
      "among",
      "others",
      "."
    ],
    "complete_sentence": "In a 2006 interview , Obama highlighted the diversity of his extended family : \" It 's like a little mini - United Nations \" , he said . \" I 've got relatives who look like Bernie Mac , and I 've got relatives who look like Margaret Thatcher . \" Obama has a half - sister with whom he was raised ( Maya Soetoro - Ng ) and seven other half - siblings from his Kenyan father 's family -- six of them living . Obama 's mother was survived by her Kansas - born mother , Madelyn Dunham , until her death on November 2 , 2008 , two days before his election to the Presidency . Obama also has roots in Ireland ; he met with his Irish cousins in Moneygall in May 2011 . In Dreams from My Father , Obama ties his mother 's family history to possible Native American ancestors and distant relatives of Jefferson Davis , President of the Confederate States of America during the American Civil War . He also shares distant ancestors in common with George W. Bush and Dick Cheney , among others ."
  },
  {
    "sentences": [
      [
        "Obama",
        "is",
        "a",
        "supporter",
        "of",
        "the",
        "Chicago",
        "White",
        "Sox",
        ",",
        "and",
        "he",
        "threw",
        "out",
        "the",
        "first",
        "pitch",
        "at",
        "the",
        "2005",
        "ALCS",
        "when",
        "he",
        "was",
        "still",
        "a",
        "senator",
        "."
      ],
      [
        "In",
        "2009",
        ",",
        "he",
        "threw",
        "out",
        "the",
        "ceremonial",
        "first",
        "pitch",
        "at",
        "the",
        "All",
        "-",
        "Star",
        "Game",
        "while",
        "wearing",
        "a",
        "White",
        "Sox",
        "jacket",
        "."
      ],
      [
        "He",
        "is",
        "also",
        "primarily",
        "a",
        "Chicago",
        "Bears",
        "football",
        "fan",
        "in",
        "the",
        "NFL",
        ",",
        "but",
        "in",
        "his",
        "childhood",
        "and",
        "adolescence",
        "was",
        "a",
        "fan",
        "of",
        "the",
        "Pittsburgh",
        "Steelers",
        ",",
        "and",
        "rooted",
        "for",
        "them",
        "ahead",
        "of",
        "their",
        "victory",
        "in",
        "Super",
        "Bowl",
        "XLIII",
        "12",
        "days",
        "after",
        "he",
        "took",
        "office",
        "as",
        "president",
        "."
      ],
      [
        "In",
        "2011",
        ",",
        "Obama",
        "invited",
        "the",
        "1985",
        "Chicago",
        "Bears",
        "to",
        "the",
        "White",
        "House",
        ";",
        "the",
        "team",
        "had",
        "not",
        "visited",
        "the",
        "White",
        "House",
        "after",
        "their",
        "Super",
        "Bowl",
        "win",
        "in",
        "1986",
        "due",
        "to",
        "the",
        "Space",
        "Shuttle",
        "Challenger",
        "disaster",
        "."
      ],
      [
        "He",
        "plays",
        "basketball",
        ",",
        "a",
        "sport",
        "he",
        "participated",
        "in",
        "as",
        "a",
        "member",
        "of",
        "his",
        "high",
        "school",
        "'s",
        "varsity",
        "team",
        ",",
        "and",
        "he",
        "is",
        "left",
        "-",
        "handed",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            11,
            11
          ],
          [
            22,
            22
          ],
          [
            31,
            31
          ],
          [
            51,
            51
          ],
          [
            66,
            66
          ],
          [
            93,
            93
          ],
          [
            102,
            102
          ],
          [
            136,
            136
          ],
          [
            142,
            142
          ],
          [
            149,
            149
          ],
          [
            157,
            157
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "Obama"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279816.626305B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            0
          ],
          [
            102,
            102
          ]
        ],
        "words": [
          {
            "id": "1571279816.626283A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279816.626289A",
            "sequences": [
              "he"
            ],
            "positions": [
              11,
              11
            ]
          },
          {
            "id": "1571279816.626291A",
            "sequences": [
              "he"
            ],
            "positions": [
              22,
              22
            ]
          },
          {
            "id": "1571279816.626292A",
            "sequences": [
              "he"
            ],
            "positions": [
              31,
              31
            ]
          },
          {
            "id": "1571279816.626293A",
            "sequences": [
              "He"
            ],
            "positions": [
              51,
              51
            ]
          },
          {
            "id": "1571279816.626294A",
            "sequences": [
              "his"
            ],
            "positions": [
              66,
              66
            ]
          },
          {
            "id": "1571279816.626295A",
            "sequences": [
              "he"
            ],
            "positions": [
              93,
              93
            ]
          },
          {
            "id": "1571279816.626297A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              102,
              102
            ]
          },
          {
            "id": "1571279816.6263A",
            "sequences": [
              "He"
            ],
            "positions": [
              136,
              136
            ]
          },
          {
            "id": "1571279816.626301A",
            "sequences": [
              "he"
            ],
            "positions": [
              142,
              142
            ]
          },
          {
            "id": "1571279816.626302A",
            "sequences": [
              "his"
            ],
            "positions": [
              149,
              149
            ]
          },
          {
            "id": "1571279816.626303A",
            "sequences": [
              "he"
            ],
            "positions": [
              157,
              157
            ]
          }
        ]
      },
      {
        "main_words": [
          "the White House"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              109,
              111
            ],
            [
              118,
              120
            ]
          ]
        ],
        "positions": [
          [
            109,
            111
          ],
          [
            118,
            120
          ]
        ],
        "sequences": [
          [
            "the",
            "White",
            "House"
          ],
          [
            "the",
            "White",
            "House"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279816.629743B",
        "words": [
          {
            "id": "1571279816.629753A",
            "sequences": [
              "the",
              "White",
              "House"
            ],
            "positions": [
              109,
              111
            ]
          },
          {
            "id": "1571279816.629754A",
            "sequences": [
              "the",
              "White",
              "House"
            ],
            "positions": [
              118,
              120
            ]
          }
        ]
      },
      {
        "main_words": [
          "the Chicago White Sox"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              5,
              8
            ]
          ]
        ],
        "positions": [
          [
            5,
            8
          ]
        ],
        "sequences": [
          [
            "the",
            "Chicago",
            "White",
            "Sox"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279816.629747B",
        "words": [
          {
            "id": "1571279816.629756A",
            "sequences": [
              "the",
              "Chicago",
              "White",
              "Sox"
            ],
            "positions": [
              5,
              8
            ]
          }
        ]
      },
      {
        "main_words": [
          "White Sox"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              47,
              48
            ]
          ]
        ],
        "positions": [
          [
            47,
            48
          ]
        ],
        "sequences": [
          [
            "White",
            "Sox"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279816.629749B",
        "words": [
          {
            "id": "1571279816.629757A",
            "sequences": [
              "White",
              "Sox"
            ],
            "positions": [
              47,
              48
            ]
          }
        ]
      },
      {
        "positions": [
          [
            74,
            76
          ],
          [
            81,
            81
          ],
          [
            84,
            84
          ]
        ],
        "sequences": [
          [
            "the",
            "Pittsburgh",
            "Steelers"
          ],
          [
            "them"
          ],
          [
            "their"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279816.629776B",
        "main_words": [
          "the Pittsburgh Steelers"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            74,
            76
          ]
        ],
        "words": [
          {
            "id": "1571279816.629772A",
            "sequences": [
              "the",
              "Pittsburgh",
              "Steelers"
            ],
            "positions": [
              74,
              76
            ]
          },
          {
            "id": "1571279816.629774A",
            "sequences": [
              "them"
            ],
            "positions": [
              81,
              81
            ]
          },
          {
            "id": "1571279816.629775A",
            "sequences": [
              "their"
            ],
            "positions": [
              84,
              84
            ]
          }
        ]
      },
      {
        "positions": [
          [
            104,
            107
          ],
          [
            113,
            114
          ],
          [
            122,
            122
          ]
        ],
        "sequences": [
          [
            "the",
            "1985",
            "Chicago",
            "Bears"
          ],
          [
            "the",
            "team"
          ],
          [
            "their"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "B-DATE",
            "B-GPE",
            "O"
          ],
          [
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279816.629786B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279816.629782A",
            "sequences": [
              "the",
              "1985",
              "Chicago",
              "Bears"
            ],
            "positions": [
              104,
              107
            ]
          },
          {
            "id": "1571279816.629784A",
            "sequences": [
              "the",
              "team"
            ],
            "positions": [
              113,
              114
            ]
          },
          {
            "id": "1571279816.629785A",
            "sequences": [
              "their"
            ],
            "positions": [
              122,
              122
            ]
          }
        ]
      },
      {
        "main_words": [
          "Super Bowl XLIII"
        ],
        "ner_tags": [
          "EVENT"
        ],
        "position_main_word": [
          [
            [
              87,
              89
            ]
          ]
        ],
        "positions": [
          [
            87,
            89
          ]
        ],
        "sequences": [
          [
            "Super",
            "Bowl",
            "XLIII"
          ]
        ],
        "ner_sequences": [
          [
            "B-EVENT",
            "I-EVENT",
            "I-EVENT"
          ]
        ],
        "flags": 1,
        "id": "1571279816.632698B",
        "words": [
          {
            "id": "1571279816.632706A",
            "sequences": [
              "Super",
              "Bowl",
              "XLIII"
            ],
            "positions": [
              87,
              89
            ]
          }
        ]
      },
      {
        "main_words": [
          "Super Bowl"
        ],
        "ner_tags": [
          "EVENT"
        ],
        "position_main_word": [
          [
            [
              123,
              124
            ]
          ]
        ],
        "positions": [
          [
            123,
            124
          ]
        ],
        "sequences": [
          [
            "Super",
            "Bowl"
          ]
        ],
        "ner_sequences": [
          [
            "B-EVENT",
            "I-EVENT"
          ]
        ],
        "flags": 1,
        "id": "1571279816.632702B",
        "words": [
          {
            "id": "1571279816.632708A",
            "sequences": [
              "Super",
              "Bowl"
            ],
            "positions": [
              123,
              124
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "B-DATE",
      "B-EVENT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-EVENT",
      "I-EVENT",
      "I-EVENT",
      "I-EVENT",
      "I-EVENT",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-EVENT",
      "I-EVENT",
      "I-EVENT",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-DATE",
      "B-GPE",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "B-EVENT",
      "I-EVENT",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-PRODUCT",
      "I-PRODUCT",
      "I-PRODUCT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "is",
      "a",
      "supporter",
      "of",
      "the",
      "Chicago",
      "White",
      "Sox",
      ",",
      "and",
      "he",
      "threw",
      "out",
      "the",
      "first",
      "pitch",
      "at",
      "the",
      "2005",
      "ALCS",
      "when",
      "he",
      "was",
      "still",
      "a",
      "senator",
      ".",
      "In",
      "2009",
      ",",
      "he",
      "threw",
      "out",
      "the",
      "ceremonial",
      "first",
      "pitch",
      "at",
      "the",
      "All",
      "-",
      "Star",
      "Game",
      "while",
      "wearing",
      "a",
      "White",
      "Sox",
      "jacket",
      ".",
      "He",
      "is",
      "also",
      "primarily",
      "a",
      "Chicago",
      "Bears",
      "football",
      "fan",
      "in",
      "the",
      "NFL",
      ",",
      "but",
      "in",
      "his",
      "childhood",
      "and",
      "adolescence",
      "was",
      "a",
      "fan",
      "of",
      "the",
      "Pittsburgh",
      "Steelers",
      ",",
      "and",
      "rooted",
      "for",
      "them",
      "ahead",
      "of",
      "their",
      "victory",
      "in",
      "Super",
      "Bowl",
      "XLIII",
      "12",
      "days",
      "after",
      "he",
      "took",
      "office",
      "as",
      "president",
      ".",
      "In",
      "2011",
      ",",
      "Obama",
      "invited",
      "the",
      "1985",
      "Chicago",
      "Bears",
      "to",
      "the",
      "White",
      "House",
      ";",
      "the",
      "team",
      "had",
      "not",
      "visited",
      "the",
      "White",
      "House",
      "after",
      "their",
      "Super",
      "Bowl",
      "win",
      "in",
      "1986",
      "due",
      "to",
      "the",
      "Space",
      "Shuttle",
      "Challenger",
      "disaster",
      ".",
      "He",
      "plays",
      "basketball",
      ",",
      "a",
      "sport",
      "he",
      "participated",
      "in",
      "as",
      "a",
      "member",
      "of",
      "his",
      "high",
      "school",
      "'s",
      "varsity",
      "team",
      ",",
      "and",
      "he",
      "is",
      "left",
      "-",
      "handed",
      "."
    ],
    "complete_sentence": "Obama is a supporter of the Chicago White Sox , and he threw out the first pitch at the 2005 ALCS when he was still a senator . In 2009 , he threw out the ceremonial first pitch at the All - Star Game while wearing a White Sox jacket . He is also primarily a Chicago Bears football fan in the NFL , but in his childhood and adolescence was a fan of the Pittsburgh Steelers , and rooted for them ahead of their victory in Super Bowl XLIII 12 days after he took office as president . In 2011 , Obama invited the 1985 Chicago Bears to the White House ; the team had not visited the White House after their Super Bowl win in 1986 due to the Space Shuttle Challenger disaster . He plays basketball , a sport he participated in as a member of his high school 's varsity team , and he is left - handed ."
  },
  {
    "sentences": [
      [
        "Obama",
        "lived",
        "with",
        "anthropologist",
        "Sheila",
        "Miyoshi",
        "Jager",
        "while",
        "he",
        "was",
        "a",
        "community",
        "organizer",
        "in",
        "Chicago",
        "in",
        "the",
        "1980s",
        "."
      ],
      [
        "He",
        "proposed",
        "to",
        "her",
        "twice",
        ",",
        "but",
        "both",
        "Jager",
        "and",
        "her",
        "parents",
        "turned",
        "him",
        "down",
        "."
      ],
      [
        "The",
        "relationship",
        "was",
        "not",
        "made",
        "public",
        "until",
        "May",
        "2017",
        ",",
        "several",
        "months",
        "after",
        "his",
        "presidency",
        "had",
        "ended",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            8,
            8
          ],
          [
            19,
            19
          ],
          [
            32,
            32
          ],
          [
            48,
            48
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "him"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279817.099524B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            0
          ]
        ],
        "words": [
          {
            "id": "1571279817.099512A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279817.099519A",
            "sequences": [
              "he"
            ],
            "positions": [
              8,
              8
            ]
          },
          {
            "id": "1571279817.09952A",
            "sequences": [
              "He"
            ],
            "positions": [
              19,
              19
            ]
          },
          {
            "id": "1571279817.099522A",
            "sequences": [
              "him"
            ],
            "positions": [
              32,
              32
            ]
          },
          {
            "id": "1571279817.099523A",
            "sequences": [
              "his"
            ],
            "positions": [
              48,
              48
            ]
          }
        ]
      },
      {
        "positions": [
          [
            3,
            6
          ],
          [
            22,
            22
          ],
          [
            27,
            27
          ],
          [
            29,
            29
          ]
        ],
        "sequences": [
          [
            "anthropologist",
            "Sheila",
            "Miyoshi",
            "Jager"
          ],
          [
            "her"
          ],
          [
            "Jager"
          ],
          [
            "her"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "B-PERSON",
            "I-PERSON",
            "I-PERSON"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279817.099539B",
        "main_words": [
          "Jager"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            27,
            27
          ]
        ],
        "words": [
          {
            "id": "1571279817.099534A",
            "sequences": [
              "anthropologist",
              "Sheila",
              "Miyoshi",
              "Jager"
            ],
            "positions": [
              3,
              6
            ]
          },
          {
            "id": "1571279817.099536A",
            "sequences": [
              "her"
            ],
            "positions": [
              22,
              22
            ]
          },
          {
            "id": "1571279817.099537A",
            "sequences": [
              "Jager"
            ],
            "positions": [
              27,
              27
            ]
          },
          {
            "id": "1571279817.099538A",
            "sequences": [
              "her"
            ],
            "positions": [
              29,
              29
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "lived",
      "with",
      "anthropologist",
      "Sheila",
      "Miyoshi",
      "Jager",
      "while",
      "he",
      "was",
      "a",
      "community",
      "organizer",
      "in",
      "Chicago",
      "in",
      "the",
      "1980s",
      ".",
      "He",
      "proposed",
      "to",
      "her",
      "twice",
      ",",
      "but",
      "both",
      "Jager",
      "and",
      "her",
      "parents",
      "turned",
      "him",
      "down",
      ".",
      "The",
      "relationship",
      "was",
      "not",
      "made",
      "public",
      "until",
      "May",
      "2017",
      ",",
      "several",
      "months",
      "after",
      "his",
      "presidency",
      "had",
      "ended",
      "."
    ],
    "complete_sentence": "Obama lived with anthropologist Sheila Miyoshi Jager while he was a community organizer in Chicago in the 1980s . He proposed to her twice , but both Jager and her parents turned him down . The relationship was not made public until May 2017 , several months after his presidency had ended ."
  },
  {
    "sentences": [
      [
        "In",
        "June",
        "1989",
        ",",
        "Obama",
        "met",
        "Michelle",
        "Robinson",
        "when",
        "he",
        "was",
        "employed",
        "as",
        "a",
        "summer",
        "associate",
        "at",
        "the",
        "Chicago",
        "law",
        "firm",
        "of",
        "Sidley",
        "Austin",
        "."
      ],
      [
        "Robinson",
        "was",
        "assigned",
        "for",
        "three",
        "months",
        "as",
        "Obama",
        "'s",
        "adviser",
        "at",
        "the",
        "firm",
        ",",
        "and",
        "she",
        "joined",
        "him",
        "at",
        "several",
        "group",
        "social",
        "functions",
        "but",
        "declined",
        "his",
        "initial",
        "requests",
        "to",
        "date",
        "."
      ],
      [
        "They",
        "began",
        "dating",
        "later",
        "that",
        "summer",
        ",",
        "became",
        "engaged",
        "in",
        "1991",
        ",",
        "and",
        "were",
        "married",
        "on",
        "October",
        "3",
        ",",
        "1992",
        "."
      ],
      [
        "After",
        "suffering",
        "a",
        "miscarriage",
        ",",
        "Michelle",
        "underwent",
        "in",
        "vitro",
        "fertilisation",
        "to",
        "conceive",
        "their",
        "children",
        "."
      ],
      [
        "The",
        "couple",
        "'s",
        "first",
        "daughter",
        ",",
        "Malia",
        "Ann",
        ",",
        "was",
        "born",
        "in",
        "1998",
        ",",
        "followed",
        "by",
        "a",
        "second",
        "daughter",
        ",",
        "Natasha",
        "(",
        "\"",
        "Sasha",
        "\"",
        ")",
        ",",
        "in",
        "2001",
        "."
      ],
      [
        "The",
        "Obama",
        "daughters",
        "attended",
        "the",
        "University",
        "of",
        "Chicago",
        "Laboratory",
        "Schools",
        "."
      ],
      [
        "When",
        "they",
        "moved",
        "to",
        "Washington",
        ",",
        "D.C.",
        ",",
        "in",
        "January",
        "2009",
        ",",
        "the",
        "girls",
        "started",
        "at",
        "the",
        "Sidwell",
        "Friends",
        "School",
        "."
      ],
      [
        "The",
        "Obamas",
        "have",
        "two",
        "Portuguese",
        "Water",
        "Dogs",
        ";",
        "the",
        "first",
        ",",
        "a",
        "male",
        "named",
        "Bo",
        ",",
        "was",
        "a",
        "gift",
        "from",
        "Senator",
        "Ted",
        "Kennedy",
        "."
      ],
      [
        "In",
        "2013",
        ",",
        "Bo",
        "was",
        "joined",
        "by",
        "Sunny",
        ",",
        "a",
        "female",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            4,
            4
          ],
          [
            9,
            9
          ],
          [
            32,
            33
          ],
          [
            123,
            123
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "Obama",
            "'s"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "B-PERSON",
            "O"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279818.714937B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            4,
            4
          ],
          [
            123,
            123
          ]
        ],
        "words": [
          {
            "id": "1571279818.714926A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              4,
              4
            ]
          },
          {
            "id": "1571279818.714933A",
            "sequences": [
              "he"
            ],
            "positions": [
              9,
              9
            ]
          },
          {
            "id": "1571279818.714935A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              32,
              33
            ]
          },
          {
            "id": "1571279818.714936A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              123,
              123
            ]
          }
        ]
      },
      {
        "main_words": [
          "Michelle Robinson"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              6,
              7
            ],
            [
              25,
              25
            ]
          ]
        ],
        "positions": [
          [
            6,
            7
          ],
          [
            25,
            25
          ],
          [
            40,
            40
          ],
          [
            42,
            42
          ],
          [
            50,
            50
          ]
        ],
        "sequences": [
          [
            "Michelle",
            "Robinson"
          ],
          [
            "Robinson"
          ],
          [
            "she"
          ],
          [
            "him"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 1,
        "id": "1571279818.718515B",
        "words": [
          {
            "id": "1571279818.718526A",
            "sequences": [
              "Michelle",
              "Robinson"
            ],
            "positions": [
              6,
              7
            ]
          },
          {
            "id": "1571279818.718528A",
            "sequences": [
              "Robinson"
            ],
            "positions": [
              25,
              25
            ]
          },
          {
            "id": "1571279818.718529A",
            "sequences": [
              "she"
            ],
            "positions": [
              40,
              40
            ]
          },
          {
            "id": "1571279818.71853A",
            "sequences": [
              "him"
            ],
            "positions": [
              42,
              42
            ]
          },
          {
            "id": "1571279818.718531A",
            "sequences": [
              "his"
            ],
            "positions": [
              50,
              50
            ]
          }
        ]
      },
      {
        "main_words": [
          "Michelle"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              82,
              82
            ]
          ]
        ],
        "positions": [
          [
            82,
            82
          ]
        ],
        "sequences": [
          [
            "Michelle"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ]
        ],
        "flags": 1,
        "id": "1571279818.71852B",
        "words": [
          {
            "id": "1571279818.718533A",
            "sequences": [
              "Michelle"
            ],
            "positions": [
              82,
              82
            ]
          }
        ]
      },
      {
        "positions": [
          [
            17,
            23
          ],
          [
            36,
            37
          ]
        ],
        "sequences": [
          [
            "the",
            "Chicago",
            "law",
            "firm",
            "of",
            "Sidley",
            "Austin"
          ],
          [
            "the",
            "firm"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "B-GPE",
            "O",
            "O",
            "O",
            "B-ORG",
            "I-ORG"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279818.718549B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279818.718546A",
            "sequences": [
              "the",
              "Chicago",
              "law",
              "firm",
              "of",
              "Sidley",
              "Austin"
            ],
            "positions": [
              17,
              23
            ]
          },
          {
            "id": "1571279818.718548A",
            "sequences": [
              "the",
              "firm"
            ],
            "positions": [
              36,
              37
            ]
          }
        ]
      },
      {
        "positions": [
          [
            56,
            56
          ],
          [
            89,
            89
          ],
          [
            92,
            94
          ],
          [
            154,
            155
          ]
        ],
        "sequences": [
          [
            "They"
          ],
          [
            "their"
          ],
          [
            "The",
            "couple",
            "'s"
          ],
          [
            "The",
            "Obamas"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O",
            "O",
            "O"
          ],
          [
            "O",
            "B-PERSON"
          ]
        ],
        "flags": -1,
        "id": "1571279818.718561B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279818.718557A",
            "sequences": [
              "They"
            ],
            "positions": [
              56,
              56
            ]
          },
          {
            "id": "1571279818.718558A",
            "sequences": [
              "their"
            ],
            "positions": [
              89,
              89
            ]
          },
          {
            "id": "1571279818.718559A",
            "sequences": [
              "The",
              "couple",
              "'s"
            ],
            "positions": [
              92,
              94
            ]
          },
          {
            "id": "1571279818.71856A",
            "sequences": [
              "The",
              "Obamas"
            ],
            "positions": [
              154,
              155
            ]
          }
        ]
      },
      {
        "positions": [
          [
            92,
            99
          ],
          [
            122,
            124
          ],
          [
            134,
            134
          ],
          [
            145,
            146
          ]
        ],
        "sequences": [
          [
            "The",
            "couple",
            "'s",
            "first",
            "daughter",
            ",",
            "Malia",
            "Ann"
          ],
          [
            "The",
            "Obama",
            "daughters"
          ],
          [
            "they"
          ],
          [
            "the",
            "girls"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O",
            "O",
            "B-ORDINAL",
            "O",
            "O",
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "O",
            "B-PERSON",
            "O"
          ],
          [
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279818.718574B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279818.71857A",
            "sequences": [
              "The",
              "couple",
              "'s",
              "first",
              "daughter",
              ",",
              "Malia",
              "Ann"
            ],
            "positions": [
              92,
              99
            ]
          },
          {
            "id": "1571279818.718571A",
            "sequences": [
              "The",
              "Obama",
              "daughters"
            ],
            "positions": [
              122,
              124
            ]
          },
          {
            "id": "1571279818.718572A",
            "sequences": [
              "they"
            ],
            "positions": [
              134,
              134
            ]
          },
          {
            "id": "1571279818.718573A",
            "sequences": [
              "the",
              "girls"
            ],
            "positions": [
              145,
              146
            ]
          }
        ]
      },
      {
        "positions": [
          [
            126,
            131
          ],
          [
            149,
            152
          ]
        ],
        "sequences": [
          [
            "the",
            "University",
            "of",
            "Chicago",
            "Laboratory",
            "Schools"
          ],
          [
            "the",
            "Sidwell",
            "Friends",
            "School"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "B-ORG",
            "B-ORG",
            "O",
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279818.718585B",
        "main_words": [
          "the University of Chicago Laboratory Schools"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            126,
            131
          ]
        ],
        "words": [
          {
            "id": "1571279818.718583A",
            "sequences": [
              "the",
              "University",
              "of",
              "Chicago",
              "Laboratory",
              "Schools"
            ],
            "positions": [
              126,
              131
            ]
          },
          {
            "id": "1571279818.718584A",
            "sequences": [
              "the",
              "Sidwell",
              "Friends",
              "School"
            ],
            "positions": [
              149,
              152
            ]
          }
        ]
      },
      {
        "positions": [
          [
            162,
            168
          ],
          [
            181,
            181
          ]
        ],
        "sequences": [
          [
            "the",
            "first",
            ",",
            "a",
            "male",
            "named",
            "Bo"
          ],
          [
            "Bo"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "B-ORDINAL",
            "O",
            "O",
            "O",
            "O",
            "B-PERSON"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279818.718595B",
        "main_words": [
          "Bo"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            181,
            181
          ]
        ],
        "words": [
          {
            "id": "1571279818.718592A",
            "sequences": [
              "the",
              "first",
              ",",
              "a",
              "male",
              "named",
              "Bo"
            ],
            "positions": [
              162,
              168
            ]
          },
          {
            "id": "1571279818.718594A",
            "sequences": [
              "Bo"
            ],
            "positions": [
              181,
              181
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-TIME",
      "I-TIME",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "I-GPE",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "B-CARDINAL",
      "B-NORP",
      "O",
      "I-NORP",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "In",
      "June",
      "1989",
      ",",
      "Obama",
      "met",
      "Michelle",
      "Robinson",
      "when",
      "he",
      "was",
      "employed",
      "as",
      "a",
      "summer",
      "associate",
      "at",
      "the",
      "Chicago",
      "law",
      "firm",
      "of",
      "Sidley",
      "Austin",
      ".",
      "Robinson",
      "was",
      "assigned",
      "for",
      "three",
      "months",
      "as",
      "Obama",
      "'s",
      "adviser",
      "at",
      "the",
      "firm",
      ",",
      "and",
      "she",
      "joined",
      "him",
      "at",
      "several",
      "group",
      "social",
      "functions",
      "but",
      "declined",
      "his",
      "initial",
      "requests",
      "to",
      "date",
      ".",
      "They",
      "began",
      "dating",
      "later",
      "that",
      "summer",
      ",",
      "became",
      "engaged",
      "in",
      "1991",
      ",",
      "and",
      "were",
      "married",
      "on",
      "October",
      "3",
      ",",
      "1992",
      ".",
      "After",
      "suffering",
      "a",
      "miscarriage",
      ",",
      "Michelle",
      "underwent",
      "in",
      "vitro",
      "fertilisation",
      "to",
      "conceive",
      "their",
      "children",
      ".",
      "The",
      "couple",
      "'s",
      "first",
      "daughter",
      ",",
      "Malia",
      "Ann",
      ",",
      "was",
      "born",
      "in",
      "1998",
      ",",
      "followed",
      "by",
      "a",
      "second",
      "daughter",
      ",",
      "Natasha",
      "(",
      "\"",
      "Sasha",
      "\"",
      ")",
      ",",
      "in",
      "2001",
      ".",
      "The",
      "Obama",
      "daughters",
      "attended",
      "the",
      "University",
      "of",
      "Chicago",
      "Laboratory",
      "Schools",
      ".",
      "When",
      "they",
      "moved",
      "to",
      "Washington",
      ",",
      "D.C.",
      ",",
      "in",
      "January",
      "2009",
      ",",
      "the",
      "girls",
      "started",
      "at",
      "the",
      "Sidwell",
      "Friends",
      "School",
      ".",
      "The",
      "Obamas",
      "have",
      "two",
      "Portuguese",
      "Water",
      "Dogs",
      ";",
      "the",
      "first",
      ",",
      "a",
      "male",
      "named",
      "Bo",
      ",",
      "was",
      "a",
      "gift",
      "from",
      "Senator",
      "Ted",
      "Kennedy",
      ".",
      "In",
      "2013",
      ",",
      "Bo",
      "was",
      "joined",
      "by",
      "Sunny",
      ",",
      "a",
      "female",
      "."
    ],
    "complete_sentence": "In June 1989 , Obama met Michelle Robinson when he was employed as a summer associate at the Chicago law firm of Sidley Austin . Robinson was assigned for three months as Obama 's adviser at the firm , and she joined him at several group social functions but declined his initial requests to date . They began dating later that summer , became engaged in 1991 , and were married on October 3 , 1992 . After suffering a miscarriage , Michelle underwent in vitro fertilisation to conceive their children . The couple 's first daughter , Malia Ann , was born in 1998 , followed by a second daughter , Natasha ( \" Sasha \" ) , in 2001 . The Obama daughters attended the University of Chicago Laboratory Schools . When they moved to Washington , D.C. , in January 2009 , the girls started at the Sidwell Friends School . The Obamas have two Portuguese Water Dogs ; the first , a male named Bo , was a gift from Senator Ted Kennedy . In 2013 , Bo was joined by Sunny , a female ."
  },
  {
    "sentences": [
      [
        "In",
        "2005",
        ",",
        "the",
        "family",
        "applied",
        "the",
        "proceeds",
        "of",
        "a",
        "book",
        "deal",
        "and",
        "moved",
        "from",
        "a",
        "Hyde",
        "Park",
        ",",
        "Chicago",
        "condominium",
        "to",
        "a",
        "$",
        "1.6",
        "million",
        "house",
        "(",
        "equivalent",
        "to",
        "$",
        "2.1",
        "million",
        "in",
        "2018",
        ")",
        "in",
        "neighboring",
        "Kenwood",
        ",",
        "Chicago",
        "."
      ],
      [
        "The",
        "purchase",
        "of",
        "an",
        "adjacent",
        "lot",
        "--",
        "and",
        "sale",
        "of",
        "part",
        "of",
        "it",
        "to",
        "Obama",
        "by",
        "the",
        "wife",
        "of",
        "developer",
        ",",
        "campaign",
        "donor",
        "and",
        "friend",
        "Tony",
        "Rezko",
        "--",
        "attracted",
        "media",
        "attention",
        "because",
        "of",
        "Rezko",
        "'s",
        "subsequent",
        "indictment",
        "and",
        "conviction",
        "on",
        "political",
        "corruption",
        "charges",
        "that",
        "were",
        "unrelated",
        "to",
        "Obama",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            19,
            19
          ],
          [
            40,
            40
          ]
        ],
        "sequences": [
          [
            "Chicago"
          ],
          [
            "Chicago"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279819.810561B",
        "main_words": [
          "Chicago"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            19,
            19
          ],
          [
            40,
            40
          ]
        ],
        "words": [
          {
            "id": "1571279819.810553A",
            "sequences": [
              "Chicago"
            ],
            "positions": [
              19,
              19
            ]
          },
          {
            "id": "1571279819.810559A",
            "sequences": [
              "Chicago"
            ],
            "positions": [
              40,
              40
            ]
          }
        ]
      },
      {
        "positions": [
          [
            45,
            47
          ],
          [
            54,
            54
          ]
        ],
        "sequences": [
          [
            "an",
            "adjacent",
            "lot"
          ],
          [
            "it"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279819.81057B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279819.810567A",
            "sequences": [
              "an",
              "adjacent",
              "lot"
            ],
            "positions": [
              45,
              47
            ]
          },
          {
            "id": "1571279819.810569A",
            "sequences": [
              "it"
            ],
            "positions": [
              54,
              54
            ]
          }
        ]
      },
      {
        "positions": [
          [
            61,
            68
          ],
          [
            75,
            76
          ]
        ],
        "sequences": [
          [
            "developer",
            ",",
            "campaign",
            "donor",
            "and",
            "friend",
            "Tony",
            "Rezko"
          ],
          [
            "Rezko",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "B-PERSON",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279819.81058B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279819.810577A",
            "sequences": [
              "developer",
              ",",
              "campaign",
              "donor",
              "and",
              "friend",
              "Tony",
              "Rezko"
            ],
            "positions": [
              61,
              68
            ]
          },
          {
            "id": "1571279819.810578A",
            "sequences": [
              "Rezko",
              "'s"
            ],
            "positions": [
              75,
              76
            ]
          }
        ]
      },
      {
        "positions": [
          [
            56,
            56
          ],
          [
            89,
            89
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279819.810589B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            56,
            56
          ],
          [
            89,
            89
          ]
        ],
        "words": [
          {
            "id": "1571279819.810587A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              56,
              56
            ]
          },
          {
            "id": "1571279819.810588A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              89,
              89
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "I-FAC",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "O",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O"
    ],
    "doc_tokens": [
      "In",
      "2005",
      ",",
      "the",
      "family",
      "applied",
      "the",
      "proceeds",
      "of",
      "a",
      "book",
      "deal",
      "and",
      "moved",
      "from",
      "a",
      "Hyde",
      "Park",
      ",",
      "Chicago",
      "condominium",
      "to",
      "a",
      "$",
      "1.6",
      "million",
      "house",
      "(",
      "equivalent",
      "to",
      "$",
      "2.1",
      "million",
      "in",
      "2018",
      ")",
      "in",
      "neighboring",
      "Kenwood",
      ",",
      "Chicago",
      ".",
      "The",
      "purchase",
      "of",
      "an",
      "adjacent",
      "lot",
      "--",
      "and",
      "sale",
      "of",
      "part",
      "of",
      "it",
      "to",
      "Obama",
      "by",
      "the",
      "wife",
      "of",
      "developer",
      ",",
      "campaign",
      "donor",
      "and",
      "friend",
      "Tony",
      "Rezko",
      "--",
      "attracted",
      "media",
      "attention",
      "because",
      "of",
      "Rezko",
      "'s",
      "subsequent",
      "indictment",
      "and",
      "conviction",
      "on",
      "political",
      "corruption",
      "charges",
      "that",
      "were",
      "unrelated",
      "to",
      "Obama",
      "."
    ],
    "complete_sentence": "In 2005 , the family applied the proceeds of a book deal and moved from a Hyde Park , Chicago condominium to a $ 1.6 million house ( equivalent to $ 2.1 million in 2018 ) in neighboring Kenwood , Chicago . The purchase of an adjacent lot -- and sale of part of it to Obama by the wife of developer , campaign donor and friend Tony Rezko -- attracted media attention because of Rezko 's subsequent indictment and conviction on political corruption charges that were unrelated to Obama ."
  },
  {
    "sentences": [
      [
        "In",
        "December",
        "2007",
        ",",
        "Money",
        "Magazine",
        "estimated",
        "Obama",
        "'s",
        "net",
        "worth",
        "at",
        "$",
        "1.3",
        "million",
        "(",
        "equivalent",
        "to",
        "$",
        "1.6",
        "million",
        "in",
        "2018",
        ")",
        "."
      ],
      [
        "Their",
        "2009",
        "tax",
        "return",
        "showed",
        "a",
        "household",
        "income",
        "of",
        "$",
        "5.5",
        "million",
        "--",
        "up",
        "from",
        "about",
        "$",
        "4.2",
        "million",
        "in",
        "2007",
        "and",
        "$",
        "1.6",
        "million",
        "in",
        "2005",
        "-",
        "-mostly",
        "from",
        "sales",
        "of",
        "his",
        "books",
        "."
      ],
      [
        "On",
        "his",
        "2010",
        "income",
        "of",
        "$",
        "1.7",
        "million",
        ",",
        "he",
        "gave",
        "14",
        "%",
        "to",
        "non",
        "-",
        "profit",
        "organizations",
        ",",
        "including",
        "$",
        "131,000",
        "to",
        "Fisher",
        "House",
        "Foundation",
        ",",
        "a",
        "charity",
        "assisting",
        "wounded",
        "veterans",
        "'",
        "families",
        ",",
        "allowing",
        "them",
        "to",
        "reside",
        "near",
        "where",
        "the",
        "veteran",
        "is",
        "receiving",
        "medical",
        "treatments",
        "."
      ],
      [
        "Per",
        "his",
        "2012",
        "financial",
        "disclosure",
        ",",
        "Obama",
        "may",
        "be",
        "worth",
        "as",
        "much",
        "as",
        "$",
        "10",
        "million",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            4,
            5
          ],
          [
            25,
            25
          ]
        ],
        "sequences": [
          [
            "Money",
            "Magazine"
          ],
          [
            "Their"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279821.064199B",
        "main_words": [
          "Money Magazine"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            4,
            5
          ]
        ],
        "words": [
          {
            "id": "1571279821.064191A",
            "sequences": [
              "Money",
              "Magazine"
            ],
            "positions": [
              4,
              5
            ]
          },
          {
            "id": "1571279821.064198A",
            "sequences": [
              "Their"
            ],
            "positions": [
              25,
              25
            ]
          }
        ]
      },
      {
        "positions": [
          [
            2,
            2
          ],
          [
            26,
            26
          ],
          [
            45,
            45
          ]
        ],
        "sequences": [
          [
            "2007"
          ],
          [
            "2009"
          ],
          [
            "2007"
          ]
        ],
        "ner_sequences": [
          [
            "I-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "B-DATE"
          ]
        ],
        "flags": -1,
        "id": "1571279821.064212B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279821.064208A",
            "sequences": [
              "2007"
            ],
            "positions": [
              2,
              2
            ]
          },
          {
            "id": "1571279821.064209A",
            "sequences": [
              "2009"
            ],
            "positions": [
              26,
              26
            ]
          },
          {
            "id": "1571279821.06421A",
            "sequences": [
              "2007"
            ],
            "positions": [
              45,
              45
            ]
          }
        ]
      },
      {
        "positions": [
          [
            7,
            8
          ],
          [
            57,
            57
          ],
          [
            61,
            61
          ],
          [
            69,
            69
          ],
          [
            109,
            109
          ],
          [
            114,
            114
          ]
        ],
        "sequences": [
          [
            "Obama",
            "'s"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279821.064227B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279821.06422A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              7,
              8
            ]
          },
          {
            "id": "1571279821.064222A",
            "sequences": [
              "his"
            ],
            "positions": [
              57,
              57
            ]
          },
          {
            "id": "1571279821.064223A",
            "sequences": [
              "his"
            ],
            "positions": [
              61,
              61
            ]
          },
          {
            "id": "1571279821.064224A",
            "sequences": [
              "he"
            ],
            "positions": [
              69,
              69
            ]
          },
          {
            "id": "1571279821.064225A",
            "sequences": [
              "his"
            ],
            "positions": [
              109,
              109
            ]
          },
          {
            "id": "1571279821.064226A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              114,
              114
            ]
          }
        ]
      },
      {
        "positions": [
          [
            90,
            92
          ],
          [
            96,
            96
          ]
        ],
        "sequences": [
          [
            "wounded",
            "veterans",
            "'"
          ],
          [
            "them"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279821.064238B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279821.064236A",
            "sequences": [
              "wounded",
              "veterans",
              "'"
            ],
            "positions": [
              90,
              92
            ]
          },
          {
            "id": "1571279821.064237A",
            "sequences": [
              "them"
            ],
            "positions": [
              96,
              96
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "B-DATE",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O",
      "O",
      "O",
      "B-PERCENT",
      "I-PERCENT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-MONEY",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-MONEY",
      "I-MONEY",
      "I-MONEY",
      "I-MONEY",
      "I-MONEY",
      "I-MONEY",
      "O"
    ],
    "doc_tokens": [
      "In",
      "December",
      "2007",
      ",",
      "Money",
      "Magazine",
      "estimated",
      "Obama",
      "'s",
      "net",
      "worth",
      "at",
      "$",
      "1.3",
      "million",
      "(",
      "equivalent",
      "to",
      "$",
      "1.6",
      "million",
      "in",
      "2018",
      ")",
      ".",
      "Their",
      "2009",
      "tax",
      "return",
      "showed",
      "a",
      "household",
      "income",
      "of",
      "$",
      "5.5",
      "million",
      "--",
      "up",
      "from",
      "about",
      "$",
      "4.2",
      "million",
      "in",
      "2007",
      "and",
      "$",
      "1.6",
      "million",
      "in",
      "2005",
      "-",
      "-mostly",
      "from",
      "sales",
      "of",
      "his",
      "books",
      ".",
      "On",
      "his",
      "2010",
      "income",
      "of",
      "$",
      "1.7",
      "million",
      ",",
      "he",
      "gave",
      "14",
      "%",
      "to",
      "non",
      "-",
      "profit",
      "organizations",
      ",",
      "including",
      "$",
      "131,000",
      "to",
      "Fisher",
      "House",
      "Foundation",
      ",",
      "a",
      "charity",
      "assisting",
      "wounded",
      "veterans",
      "'",
      "families",
      ",",
      "allowing",
      "them",
      "to",
      "reside",
      "near",
      "where",
      "the",
      "veteran",
      "is",
      "receiving",
      "medical",
      "treatments",
      ".",
      "Per",
      "his",
      "2012",
      "financial",
      "disclosure",
      ",",
      "Obama",
      "may",
      "be",
      "worth",
      "as",
      "much",
      "as",
      "$",
      "10",
      "million",
      "."
    ],
    "complete_sentence": "In December 2007 , Money Magazine estimated Obama 's net worth at $ 1.3 million ( equivalent to $ 1.6 million in 2018 ) . Their 2009 tax return showed a household income of $ 5.5 million -- up from about $ 4.2 million in 2007 and $ 1.6 million in 2005 - -mostly from sales of his books . On his 2010 income of $ 1.7 million , he gave 14 % to non - profit organizations , including $ 131,000 to Fisher House Foundation , a charity assisting wounded veterans ' families , allowing them to reside near where the veteran is receiving medical treatments . Per his 2012 financial disclosure , Obama may be worth as much as $ 10 million ."
  },
  {
    "sentences": [
      [
        "In",
        "early",
        "2010",
        ",",
        "Michelle",
        "spoke",
        "about",
        "her",
        "husband",
        "'s",
        "smoking",
        "habit",
        "and",
        "said",
        "Barack",
        "had",
        "quit",
        "smoking",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            4,
            4
          ],
          [
            7,
            7
          ]
        ],
        "sequences": [
          [
            "Michelle"
          ],
          [
            "her"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279821.358326B",
        "main_words": [
          "Michelle"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            4,
            4
          ]
        ],
        "words": [
          {
            "id": "1571279821.358316A",
            "sequences": [
              "Michelle"
            ],
            "positions": [
              4,
              4
            ]
          },
          {
            "id": "1571279821.358324A",
            "sequences": [
              "her"
            ],
            "positions": [
              7,
              7
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "In",
      "early",
      "2010",
      ",",
      "Michelle",
      "spoke",
      "about",
      "her",
      "husband",
      "'s",
      "smoking",
      "habit",
      "and",
      "said",
      "Barack",
      "had",
      "quit",
      "smoking",
      "."
    ],
    "complete_sentence": "In early 2010 , Michelle spoke about her husband 's smoking habit and said Barack had quit smoking ."
  },
  {
    "sentences": [
      [
        "On",
        "his",
        "55th",
        "birthday",
        ",",
        "August",
        "4",
        ",",
        "2016",
        ",",
        "Obama",
        "penned",
        "an",
        "essay",
        "in",
        "Glamour",
        ",",
        "in",
        "which",
        "he",
        "described",
        "how",
        "his",
        "daughters",
        "and",
        "the",
        "presidency",
        "have",
        "made",
        "him",
        "a",
        "feminist",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            1,
            1
          ],
          [
            10,
            10
          ],
          [
            19,
            19
          ],
          [
            22,
            22
          ],
          [
            29,
            29
          ]
        ],
        "sequences": [
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "him"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279821.843195B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            10,
            10
          ]
        ],
        "words": [
          {
            "id": "1571279821.843182A",
            "sequences": [
              "his"
            ],
            "positions": [
              1,
              1
            ]
          },
          {
            "id": "1571279821.843189A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              10,
              10
            ]
          },
          {
            "id": "1571279821.843191A",
            "sequences": [
              "he"
            ],
            "positions": [
              19,
              19
            ]
          },
          {
            "id": "1571279821.843192A",
            "sequences": [
              "his"
            ],
            "positions": [
              22,
              22
            ]
          },
          {
            "id": "1571279821.843193A",
            "sequences": [
              "him"
            ],
            "positions": [
              29,
              29
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-WORK_OF_ART",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "On",
      "his",
      "55th",
      "birthday",
      ",",
      "August",
      "4",
      ",",
      "2016",
      ",",
      "Obama",
      "penned",
      "an",
      "essay",
      "in",
      "Glamour",
      ",",
      "in",
      "which",
      "he",
      "described",
      "how",
      "his",
      "daughters",
      "and",
      "the",
      "presidency",
      "have",
      "made",
      "him",
      "a",
      "feminist",
      "."
    ],
    "complete_sentence": "On his 55th birthday , August 4 , 2016 , Obama penned an essay in Glamour , in which he described how his daughters and the presidency have made him a feminist ."
  },
  {
    "sentences": [
      [
        "Obama",
        "is",
        "a",
        "Protestant",
        "Christian",
        "whose",
        "religious",
        "views",
        "developed",
        "in",
        "his",
        "adult",
        "life",
        "."
      ],
      [
        "He",
        "wrote",
        "in",
        "The",
        "Audacity",
        "of",
        "Hope",
        "that",
        "he",
        "\"",
        "was",
        "not",
        "raised",
        "in",
        "a",
        "religious",
        "household",
        "\"",
        "."
      ],
      [
        "He",
        "described",
        "his",
        "mother",
        ",",
        "raised",
        "by",
        "non",
        "-",
        "religious",
        "parents",
        ",",
        "as",
        "being",
        "detached",
        "from",
        "religion",
        ",",
        "yet",
        "\"",
        "in",
        "many",
        "ways",
        "the",
        "most",
        "spiritually",
        "awakened",
        "person",
        "..."
      ],
      [
        "I",
        "have",
        "ever",
        "known",
        "\"",
        "."
      ],
      [
        "He",
        "described",
        "his",
        "father",
        "as",
        "a",
        "\"",
        "confirmed",
        "atheist",
        "\"",
        "by",
        "the",
        "time",
        "his",
        "parents",
        "met",
        ",",
        "and",
        "his",
        "stepfather",
        "as",
        "\"",
        "a",
        "man",
        "who",
        "saw",
        "religion",
        "as",
        "not",
        "particularly",
        "useful",
        "\"",
        "."
      ],
      [
        "Obama",
        "explained",
        "how",
        ",",
        "through",
        "working",
        "with",
        "black",
        "churches",
        "as",
        "a",
        "community",
        "organizer",
        "while",
        "in",
        "his",
        "twenties",
        ",",
        "he",
        "came",
        "to",
        "understand",
        "\"",
        "the",
        "power",
        "of",
        "the",
        "African",
        "-",
        "American",
        "religious",
        "tradition",
        "to",
        "spur",
        "social",
        "change",
        "."
      ],
      [
        "\""
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            10,
            10
          ],
          [
            14,
            14
          ],
          [
            22,
            22
          ],
          [
            33,
            33
          ],
          [
            35,
            35
          ],
          [
            62,
            62
          ],
          [
            68,
            68
          ],
          [
            70,
            70
          ],
          [
            81,
            81
          ],
          [
            86,
            86
          ],
          [
            101,
            101
          ],
          [
            116,
            116
          ],
          [
            119,
            119
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "his"
          ],
          [
            "I"
          ],
          [
            "He"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279822.962981B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            0
          ]
        ],
        "words": [
          {
            "id": "1571279822.962959A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279822.962965A",
            "sequences": [
              "his"
            ],
            "positions": [
              10,
              10
            ]
          },
          {
            "id": "1571279822.962967A",
            "sequences": [
              "He"
            ],
            "positions": [
              14,
              14
            ]
          },
          {
            "id": "1571279822.962968A",
            "sequences": [
              "he"
            ],
            "positions": [
              22,
              22
            ]
          },
          {
            "id": "1571279822.96297A",
            "sequences": [
              "He"
            ],
            "positions": [
              33,
              33
            ]
          },
          {
            "id": "1571279822.962971A",
            "sequences": [
              "his"
            ],
            "positions": [
              35,
              35
            ]
          },
          {
            "id": "1571279822.962972A",
            "sequences": [
              "I"
            ],
            "positions": [
              62,
              62
            ]
          },
          {
            "id": "1571279822.962973A",
            "sequences": [
              "He"
            ],
            "positions": [
              68,
              68
            ]
          },
          {
            "id": "1571279822.962974A",
            "sequences": [
              "his"
            ],
            "positions": [
              70,
              70
            ]
          },
          {
            "id": "1571279822.962976A",
            "sequences": [
              "his"
            ],
            "positions": [
              81,
              81
            ]
          },
          {
            "id": "1571279822.962977A",
            "sequences": [
              "his"
            ],
            "positions": [
              86,
              86
            ]
          },
          {
            "id": "1571279822.962978A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              101,
              101
            ]
          },
          {
            "id": "1571279822.962979A",
            "sequences": [
              "his"
            ],
            "positions": [
              116,
              116
            ]
          },
          {
            "id": "1571279822.96298A",
            "sequences": [
              "he"
            ],
            "positions": [
              119,
              119
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "B-NORP",
      "I-NORP",
      "I-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-WORK_OF_ART",
      "I-WORK_OF_ART",
      "I-WORK_OF_ART",
      "I-WORK_OF_ART",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "I-NORP",
      "I-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "is",
      "a",
      "Protestant",
      "Christian",
      "whose",
      "religious",
      "views",
      "developed",
      "in",
      "his",
      "adult",
      "life",
      ".",
      "He",
      "wrote",
      "in",
      "The",
      "Audacity",
      "of",
      "Hope",
      "that",
      "he",
      "\"",
      "was",
      "not",
      "raised",
      "in",
      "a",
      "religious",
      "household",
      "\"",
      ".",
      "He",
      "described",
      "his",
      "mother",
      ",",
      "raised",
      "by",
      "non",
      "-",
      "religious",
      "parents",
      ",",
      "as",
      "being",
      "detached",
      "from",
      "religion",
      ",",
      "yet",
      "\"",
      "in",
      "many",
      "ways",
      "the",
      "most",
      "spiritually",
      "awakened",
      "person",
      "...",
      "I",
      "have",
      "ever",
      "known",
      "\"",
      ".",
      "He",
      "described",
      "his",
      "father",
      "as",
      "a",
      "\"",
      "confirmed",
      "atheist",
      "\"",
      "by",
      "the",
      "time",
      "his",
      "parents",
      "met",
      ",",
      "and",
      "his",
      "stepfather",
      "as",
      "\"",
      "a",
      "man",
      "who",
      "saw",
      "religion",
      "as",
      "not",
      "particularly",
      "useful",
      "\"",
      ".",
      "Obama",
      "explained",
      "how",
      ",",
      "through",
      "working",
      "with",
      "black",
      "churches",
      "as",
      "a",
      "community",
      "organizer",
      "while",
      "in",
      "his",
      "twenties",
      ",",
      "he",
      "came",
      "to",
      "understand",
      "\"",
      "the",
      "power",
      "of",
      "the",
      "African",
      "-",
      "American",
      "religious",
      "tradition",
      "to",
      "spur",
      "social",
      "change",
      ".",
      "\""
    ],
    "complete_sentence": "Obama is a Protestant Christian whose religious views developed in his adult life . He wrote in The Audacity of Hope that he \" was not raised in a religious household \" . He described his mother , raised by non - religious parents , as being detached from religion , yet \" in many ways the most spiritually awakened person ... I have ever known \" . He described his father as a \" confirmed atheist \" by the time his parents met , and his stepfather as \" a man who saw religion as not particularly useful \" . Obama explained how , through working with black churches as a community organizer while in his twenties , he came to understand \" the power of the African - American religious tradition to spur social change . \""
  },
  {
    "sentences": [
      [
        "In",
        "January",
        "2008",
        ",",
        "Obama",
        "told",
        "Christianity",
        "Today",
        ":",
        "\"",
        "I",
        "am",
        "a",
        "Christian",
        ",",
        "and",
        "I",
        "am",
        "a",
        "devout",
        "Christian",
        "."
      ],
      [
        "I",
        "believe",
        "in",
        "the",
        "redemptive",
        "death",
        "and",
        "resurrection",
        "of",
        "Jesus",
        "Christ",
        "."
      ],
      [
        "I",
        "believe",
        "that",
        "faith",
        "gives",
        "me",
        "a",
        "path",
        "to",
        "be",
        "cleansed",
        "of",
        "sin",
        "and",
        "have",
        "eternal",
        "life",
        "."
      ],
      [
        "\""
      ],
      [
        "On",
        "September",
        "27",
        ",",
        "2010",
        ",",
        "Obama",
        "released",
        "a",
        "statement",
        "commenting",
        "on",
        "his",
        "religious",
        "views",
        "saying",
        ",",
        "\"",
        "I",
        "'m",
        "a",
        "Christian",
        "by",
        "choice",
        "."
      ],
      [
        "My",
        "family",
        "did",
        "n't",
        "-",
        "frankly",
        ",",
        "they",
        "were",
        "n't",
        "folks",
        "who",
        "went",
        "to",
        "church",
        "every",
        "week",
        "."
      ],
      [
        "And",
        "my",
        "mother",
        "was",
        "one",
        "of",
        "the",
        "most",
        "spiritual",
        "people",
        "I",
        "knew",
        ",",
        "but",
        "she",
        "did",
        "n't",
        "raise",
        "me",
        "in",
        "the",
        "church",
        "."
      ],
      [
        "So",
        "I",
        "came",
        "to",
        "my",
        "Christian",
        "faith",
        "later",
        "in",
        "life",
        ",",
        "and",
        "it",
        "was",
        "because",
        "the",
        "precepts",
        "of",
        "Jesus",
        "Christ",
        "spoke",
        "to",
        "me",
        "in",
        "terms",
        "of",
        "the",
        "kind",
        "of",
        "life",
        "that",
        "I",
        "would",
        "want",
        "to",
        "lead",
        "-",
        "being",
        "my",
        "brothers",
        "'",
        "and",
        "sisters",
        "'",
        "keeper",
        ",",
        "treating",
        "others",
        "as",
        "they",
        "would",
        "treat",
        "me",
        "."
      ],
      [
        "\""
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            4,
            4
          ],
          [
            10,
            10
          ],
          [
            16,
            16
          ],
          [
            22,
            22
          ],
          [
            34,
            34
          ],
          [
            39,
            39
          ],
          [
            59,
            59
          ],
          [
            65,
            65
          ],
          [
            71,
            71
          ],
          [
            78,
            78
          ],
          [
            97,
            97
          ],
          [
            106,
            106
          ],
          [
            114,
            114
          ],
          [
            120,
            120
          ],
          [
            123,
            123
          ],
          [
            141,
            141
          ],
          [
            150,
            150
          ],
          [
            157,
            157
          ],
          [
            171,
            171
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "I"
          ],
          [
            "I"
          ],
          [
            "I"
          ],
          [
            "I"
          ],
          [
            "me"
          ],
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "I"
          ],
          [
            "My"
          ],
          [
            "my"
          ],
          [
            "I"
          ],
          [
            "me"
          ],
          [
            "I"
          ],
          [
            "my"
          ],
          [
            "me"
          ],
          [
            "I"
          ],
          [
            "my"
          ],
          [
            "me"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279825.633085B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            4,
            4
          ],
          [
            59,
            59
          ]
        ],
        "words": [
          {
            "id": "1571279825.633056A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              4,
              4
            ]
          },
          {
            "id": "1571279825.633063A",
            "sequences": [
              "I"
            ],
            "positions": [
              10,
              10
            ]
          },
          {
            "id": "1571279825.633066A",
            "sequences": [
              "I"
            ],
            "positions": [
              16,
              16
            ]
          },
          {
            "id": "1571279825.633067A",
            "sequences": [
              "I"
            ],
            "positions": [
              22,
              22
            ]
          },
          {
            "id": "1571279825.633068A",
            "sequences": [
              "I"
            ],
            "positions": [
              34,
              34
            ]
          },
          {
            "id": "1571279825.63307A",
            "sequences": [
              "me"
            ],
            "positions": [
              39,
              39
            ]
          },
          {
            "id": "1571279825.633071A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              59,
              59
            ]
          },
          {
            "id": "1571279825.633072A",
            "sequences": [
              "his"
            ],
            "positions": [
              65,
              65
            ]
          },
          {
            "id": "1571279825.633073A",
            "sequences": [
              "I"
            ],
            "positions": [
              71,
              71
            ]
          },
          {
            "id": "1571279825.633074A",
            "sequences": [
              "My"
            ],
            "positions": [
              78,
              78
            ]
          },
          {
            "id": "1571279825.633075A",
            "sequences": [
              "my"
            ],
            "positions": [
              97,
              97
            ]
          },
          {
            "id": "1571279825.633076A",
            "sequences": [
              "I"
            ],
            "positions": [
              106,
              106
            ]
          },
          {
            "id": "1571279825.633078A",
            "sequences": [
              "me"
            ],
            "positions": [
              114,
              114
            ]
          },
          {
            "id": "1571279825.633079A",
            "sequences": [
              "I"
            ],
            "positions": [
              120,
              120
            ]
          },
          {
            "id": "1571279825.63308A",
            "sequences": [
              "my"
            ],
            "positions": [
              123,
              123
            ]
          },
          {
            "id": "1571279825.633081A",
            "sequences": [
              "me"
            ],
            "positions": [
              141,
              141
            ]
          },
          {
            "id": "1571279825.633082A",
            "sequences": [
              "I"
            ],
            "positions": [
              150,
              150
            ]
          },
          {
            "id": "1571279825.633083A",
            "sequences": [
              "my"
            ],
            "positions": [
              157,
              157
            ]
          },
          {
            "id": "1571279825.633084A",
            "sequences": [
              "me"
            ],
            "positions": [
              171,
              171
            ]
          }
        ]
      },
      {
        "positions": [
          [
            78,
            79
          ],
          [
            85,
            85
          ]
        ],
        "sequences": [
          [
            "My",
            "family"
          ],
          [
            "they"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279825.633094B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279825.633092A",
            "sequences": [
              "My",
              "family"
            ],
            "positions": [
              78,
              79
            ]
          },
          {
            "id": "1571279825.633093A",
            "sequences": [
              "they"
            ],
            "positions": [
              85,
              85
            ]
          }
        ]
      },
      {
        "positions": [
          [
            97,
            98
          ],
          [
            110,
            110
          ]
        ],
        "sequences": [
          [
            "my",
            "mother"
          ],
          [
            "she"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279825.633102B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279825.633099A",
            "sequences": [
              "my",
              "mother"
            ],
            "positions": [
              97,
              98
            ]
          },
          {
            "id": "1571279825.6331A",
            "sequences": [
              "she"
            ],
            "positions": [
              110,
              110
            ]
          }
        ]
      },
      {
        "positions": [
          [
            92,
            92
          ],
          [
            116,
            117
          ]
        ],
        "sequences": [
          [
            "church"
          ],
          [
            "the",
            "church"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279825.63311B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279825.633106A",
            "sequences": [
              "church"
            ],
            "positions": [
              92,
              92
            ]
          },
          {
            "id": "1571279825.633107A",
            "sequences": [
              "the",
              "church"
            ],
            "positions": [
              116,
              117
            ]
          }
        ]
      },
      {
        "positions": [
          [
            31,
            32
          ],
          [
            137,
            138
          ]
        ],
        "sequences": [
          [
            "Jesus",
            "Christ"
          ],
          [
            "Jesus",
            "Christ"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "B-PERSON",
            "I-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279825.63312B",
        "main_words": [
          "Jesus Christ"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            31,
            32
          ],
          [
            137,
            138
          ]
        ],
        "words": [
          {
            "id": "1571279825.633118A",
            "sequences": [
              "Jesus",
              "Christ"
            ],
            "positions": [
              31,
              32
            ]
          },
          {
            "id": "1571279825.633119A",
            "sequences": [
              "Jesus",
              "Christ"
            ],
            "positions": [
              137,
              138
            ]
          }
        ]
      },
      {
        "positions": [
          [
            166,
            166
          ],
          [
            168,
            168
          ]
        ],
        "sequences": [
          [
            "others"
          ],
          [
            "they"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279825.633127B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279825.633125A",
            "sequences": [
              "others"
            ],
            "positions": [
              166,
              166
            ]
          },
          {
            "id": "1571279825.633126A",
            "sequences": [
              "they"
            ],
            "positions": [
              168,
              168
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "B-ORG",
      "I-WORK_OF_ART",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "In",
      "January",
      "2008",
      ",",
      "Obama",
      "told",
      "Christianity",
      "Today",
      ":",
      "\"",
      "I",
      "am",
      "a",
      "Christian",
      ",",
      "and",
      "I",
      "am",
      "a",
      "devout",
      "Christian",
      ".",
      "I",
      "believe",
      "in",
      "the",
      "redemptive",
      "death",
      "and",
      "resurrection",
      "of",
      "Jesus",
      "Christ",
      ".",
      "I",
      "believe",
      "that",
      "faith",
      "gives",
      "me",
      "a",
      "path",
      "to",
      "be",
      "cleansed",
      "of",
      "sin",
      "and",
      "have",
      "eternal",
      "life",
      ".",
      "\"",
      "On",
      "September",
      "27",
      ",",
      "2010",
      ",",
      "Obama",
      "released",
      "a",
      "statement",
      "commenting",
      "on",
      "his",
      "religious",
      "views",
      "saying",
      ",",
      "\"",
      "I",
      "'m",
      "a",
      "Christian",
      "by",
      "choice",
      ".",
      "My",
      "family",
      "did",
      "n't",
      "-",
      "frankly",
      ",",
      "they",
      "were",
      "n't",
      "folks",
      "who",
      "went",
      "to",
      "church",
      "every",
      "week",
      ".",
      "And",
      "my",
      "mother",
      "was",
      "one",
      "of",
      "the",
      "most",
      "spiritual",
      "people",
      "I",
      "knew",
      ",",
      "but",
      "she",
      "did",
      "n't",
      "raise",
      "me",
      "in",
      "the",
      "church",
      ".",
      "So",
      "I",
      "came",
      "to",
      "my",
      "Christian",
      "faith",
      "later",
      "in",
      "life",
      ",",
      "and",
      "it",
      "was",
      "because",
      "the",
      "precepts",
      "of",
      "Jesus",
      "Christ",
      "spoke",
      "to",
      "me",
      "in",
      "terms",
      "of",
      "the",
      "kind",
      "of",
      "life",
      "that",
      "I",
      "would",
      "want",
      "to",
      "lead",
      "-",
      "being",
      "my",
      "brothers",
      "'",
      "and",
      "sisters",
      "'",
      "keeper",
      ",",
      "treating",
      "others",
      "as",
      "they",
      "would",
      "treat",
      "me",
      ".",
      "\""
    ],
    "complete_sentence": "In January 2008 , Obama told Christianity Today : \" I am a Christian , and I am a devout Christian . I believe in the redemptive death and resurrection of Jesus Christ . I believe that faith gives me a path to be cleansed of sin and have eternal life . \" On September 27 , 2010 , Obama released a statement commenting on his religious views saying , \" I 'm a Christian by choice . My family did n't - frankly , they were n't folks who went to church every week . And my mother was one of the most spiritual people I knew , but she did n't raise me in the church . So I came to my Christian faith later in life , and it was because the precepts of Jesus Christ spoke to me in terms of the kind of life that I would want to lead - being my brothers ' and sisters ' keeper , treating others as they would treat me . \""
  },
  {
    "sentences": [
      [
        "Obama",
        "met",
        "Trinity",
        "United",
        "Church",
        "of",
        "Christ",
        "pastor",
        "Jeremiah",
        "Wright",
        "in",
        "October",
        "1987",
        "and",
        "became",
        "a",
        "member",
        "of",
        "Trinity",
        "in",
        "1992",
        "."
      ],
      [
        "During",
        "Obama",
        "'s",
        "first",
        "presidential",
        "campaign",
        "in",
        "May",
        "2008",
        ",",
        "he",
        "resigned",
        "from",
        "Trinity",
        "after",
        "some",
        "of",
        "Wright",
        "'s",
        "statements",
        "were",
        "criticized",
        "."
      ],
      [
        "Since",
        "moving",
        "to",
        "Washington",
        ",",
        "D.C.",
        ",",
        "in",
        "2009",
        ",",
        "the",
        "Obama",
        "family",
        "has",
        "attended",
        "several",
        "Protestant",
        "churches",
        ",",
        "including",
        "Shiloh",
        "Baptist",
        "Church",
        "and",
        "St.",
        "John",
        "'s",
        "Episcopal",
        "Church",
        ",",
        "as",
        "well",
        "as",
        "Evergreen",
        "Chapel",
        "at",
        "Camp",
        "David",
        ",",
        "but",
        "the",
        "members",
        "of",
        "the",
        "family",
        "do",
        "not",
        "attend",
        "church",
        "on",
        "a",
        "regular",
        "basis",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            23,
            24
          ],
          [
            32,
            32
          ],
          [
            56,
            56
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "Obama",
            "'s"
          ],
          [
            "he"
          ],
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "B-PERSON",
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ]
        ],
        "flags": 0,
        "id": "1571279826.895764B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            56,
            56
          ]
        ],
        "words": [
          {
            "id": "1571279826.895753A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279826.89576A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              23,
              24
            ]
          },
          {
            "id": "1571279826.895762A",
            "sequences": [
              "he"
            ],
            "positions": [
              32,
              32
            ]
          },
          {
            "id": "1571279826.895763A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              56,
              56
            ]
          }
        ]
      },
      {
        "positions": [
          [
            18,
            18
          ],
          [
            35,
            35
          ]
        ],
        "sequences": [
          [
            "Trinity"
          ],
          [
            "Trinity"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG"
          ],
          [
            "B-ORG"
          ]
        ],
        "flags": 0,
        "id": "1571279826.895775B",
        "main_words": [
          "Trinity"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            18,
            18
          ],
          [
            35,
            35
          ]
        ],
        "words": [
          {
            "id": "1571279826.895772A",
            "sequences": [
              "Trinity"
            ],
            "positions": [
              18,
              18
            ]
          },
          {
            "id": "1571279826.895774A",
            "sequences": [
              "Trinity"
            ],
            "positions": [
              35,
              35
            ]
          }
        ]
      },
      {
        "positions": [
          [
            2,
            9
          ],
          [
            39,
            40
          ]
        ],
        "sequences": [
          [
            "Trinity",
            "United",
            "Church",
            "of",
            "Christ",
            "pastor",
            "Jeremiah",
            "Wright"
          ],
          [
            "Wright",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "O",
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "B-PERSON",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279826.895784B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279826.895782A",
            "sequences": [
              "Trinity",
              "United",
              "Church",
              "of",
              "Christ",
              "pastor",
              "Jeremiah",
              "Wright"
            ],
            "positions": [
              2,
              9
            ]
          },
          {
            "id": "1571279826.895783A",
            "sequences": [
              "Wright",
              "'s"
            ],
            "positions": [
              39,
              40
            ]
          }
        ]
      },
      {
        "positions": [
          [
            55,
            57
          ],
          [
            88,
            89
          ]
        ],
        "sequences": [
          [
            "the",
            "Obama",
            "family"
          ],
          [
            "the",
            "family"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "B-PERSON",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279826.895792B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279826.89579A",
            "sequences": [
              "the",
              "Obama",
              "family"
            ],
            "positions": [
              55,
              57
            ]
          },
          {
            "id": "1571279826.895791A",
            "sequences": [
              "the",
              "family"
            ],
            "positions": [
              88,
              89
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-PERSON",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "B-FAC",
      "I-ORG",
      "O",
      "B-FAC",
      "I-FAC",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "met",
      "Trinity",
      "United",
      "Church",
      "of",
      "Christ",
      "pastor",
      "Jeremiah",
      "Wright",
      "in",
      "October",
      "1987",
      "and",
      "became",
      "a",
      "member",
      "of",
      "Trinity",
      "in",
      "1992",
      ".",
      "During",
      "Obama",
      "'s",
      "first",
      "presidential",
      "campaign",
      "in",
      "May",
      "2008",
      ",",
      "he",
      "resigned",
      "from",
      "Trinity",
      "after",
      "some",
      "of",
      "Wright",
      "'s",
      "statements",
      "were",
      "criticized",
      ".",
      "Since",
      "moving",
      "to",
      "Washington",
      ",",
      "D.C.",
      ",",
      "in",
      "2009",
      ",",
      "the",
      "Obama",
      "family",
      "has",
      "attended",
      "several",
      "Protestant",
      "churches",
      ",",
      "including",
      "Shiloh",
      "Baptist",
      "Church",
      "and",
      "St.",
      "John",
      "'s",
      "Episcopal",
      "Church",
      ",",
      "as",
      "well",
      "as",
      "Evergreen",
      "Chapel",
      "at",
      "Camp",
      "David",
      ",",
      "but",
      "the",
      "members",
      "of",
      "the",
      "family",
      "do",
      "not",
      "attend",
      "church",
      "on",
      "a",
      "regular",
      "basis",
      "."
    ],
    "complete_sentence": "Obama met Trinity United Church of Christ pastor Jeremiah Wright in October 1987 and became a member of Trinity in 1992 . During Obama 's first presidential campaign in May 2008 , he resigned from Trinity after some of Wright 's statements were criticized . Since moving to Washington , D.C. , in 2009 , the Obama family has attended several Protestant churches , including Shiloh Baptist Church and St. John 's Episcopal Church , as well as Evergreen Chapel at Camp David , but the members of the family do not attend church on a regular basis ."
  },
  {
    "sentences": [
      [
        "Two",
        "years",
        "after",
        "graduating",
        "from",
        "Columbia",
        ",",
        "Obama",
        "moved",
        "from",
        "New",
        "York",
        "to",
        "Chicago",
        "when",
        "he",
        "was",
        "hired",
        "as",
        "director",
        "of",
        "the",
        "Developing",
        "Communities",
        "Project",
        ",",
        "a",
        "church",
        "-",
        "based",
        "community",
        "organization",
        "originally",
        "comprising",
        "eight",
        "Catholic",
        "parishes",
        "in",
        "Roseland",
        ",",
        "West",
        "Pullman",
        ",",
        "and",
        "Riverdale",
        "on",
        "Chicago",
        "'s",
        "South",
        "Side",
        "."
      ],
      [
        "He",
        "worked",
        "there",
        "as",
        "a",
        "community",
        "organizer",
        "from",
        "June",
        "1985",
        "to",
        "May",
        "1988",
        "."
      ],
      [
        "He",
        "helped",
        "set",
        "up",
        "a",
        "job",
        "training",
        "program",
        ",",
        "a",
        "college",
        "preparatory",
        "tutoring",
        "program",
        ",",
        "and",
        "a",
        "tenants",
        "'",
        "rights",
        "organization",
        "in",
        "Altgeld",
        "Gardens",
        "."
      ],
      [
        "Obama",
        "also",
        "worked",
        "as",
        "a",
        "consultant",
        "and",
        "instructor",
        "for",
        "the",
        "Gamaliel",
        "Foundation",
        ",",
        "a",
        "community",
        "organizing",
        "institute",
        "."
      ],
      [
        "In",
        "mid-1988",
        ",",
        "he",
        "traveled",
        "for",
        "the",
        "first",
        "time",
        "in",
        "Europe",
        "for",
        "three",
        "weeks",
        "and",
        "then",
        "for",
        "five",
        "weeks",
        "in",
        "Kenya",
        ",",
        "where",
        "he",
        "met",
        "many",
        "of",
        "his",
        "paternal",
        "relatives",
        "for",
        "the",
        "first",
        "time",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            7,
            7
          ],
          [
            15,
            15
          ],
          [
            51,
            51
          ],
          [
            65,
            65
          ],
          [
            90,
            90
          ],
          [
            111,
            111
          ],
          [
            131,
            131
          ],
          [
            135,
            135
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "He"
          ],
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279828.214288B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            7,
            7
          ],
          [
            90,
            90
          ]
        ],
        "words": [
          {
            "id": "1571279828.214273A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              7,
              7
            ]
          },
          {
            "id": "1571279828.214279A",
            "sequences": [
              "he"
            ],
            "positions": [
              15,
              15
            ]
          },
          {
            "id": "1571279828.214281A",
            "sequences": [
              "He"
            ],
            "positions": [
              51,
              51
            ]
          },
          {
            "id": "1571279828.214282A",
            "sequences": [
              "He"
            ],
            "positions": [
              65,
              65
            ]
          },
          {
            "id": "1571279828.214283A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              90,
              90
            ]
          },
          {
            "id": "1571279828.214284A",
            "sequences": [
              "he"
            ],
            "positions": [
              111,
              111
            ]
          },
          {
            "id": "1571279828.214285A",
            "sequences": [
              "he"
            ],
            "positions": [
              131,
              131
            ]
          },
          {
            "id": "1571279828.214286A",
            "sequences": [
              "his"
            ],
            "positions": [
              135,
              135
            ]
          }
        ]
      },
      {
        "positions": [
          [
            13,
            13
          ],
          [
            46,
            47
          ]
        ],
        "sequences": [
          [
            "Chicago"
          ],
          [
            "Chicago",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE"
          ],
          [
            "B-GPE",
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279828.214298B",
        "main_words": [
          "Chicago"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            13,
            13
          ]
        ],
        "words": [
          {
            "id": "1571279828.214295A",
            "sequences": [
              "Chicago"
            ],
            "positions": [
              13,
              13
            ]
          },
          {
            "id": "1571279828.214297A",
            "sequences": [
              "Chicago",
              "'s"
            ],
            "positions": [
              46,
              47
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "B-NORP",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "I-GPE",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "B-LOC",
      "I-LOC",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-LOC",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Two",
      "years",
      "after",
      "graduating",
      "from",
      "Columbia",
      ",",
      "Obama",
      "moved",
      "from",
      "New",
      "York",
      "to",
      "Chicago",
      "when",
      "he",
      "was",
      "hired",
      "as",
      "director",
      "of",
      "the",
      "Developing",
      "Communities",
      "Project",
      ",",
      "a",
      "church",
      "-",
      "based",
      "community",
      "organization",
      "originally",
      "comprising",
      "eight",
      "Catholic",
      "parishes",
      "in",
      "Roseland",
      ",",
      "West",
      "Pullman",
      ",",
      "and",
      "Riverdale",
      "on",
      "Chicago",
      "'s",
      "South",
      "Side",
      ".",
      "He",
      "worked",
      "there",
      "as",
      "a",
      "community",
      "organizer",
      "from",
      "June",
      "1985",
      "to",
      "May",
      "1988",
      ".",
      "He",
      "helped",
      "set",
      "up",
      "a",
      "job",
      "training",
      "program",
      ",",
      "a",
      "college",
      "preparatory",
      "tutoring",
      "program",
      ",",
      "and",
      "a",
      "tenants",
      "'",
      "rights",
      "organization",
      "in",
      "Altgeld",
      "Gardens",
      ".",
      "Obama",
      "also",
      "worked",
      "as",
      "a",
      "consultant",
      "and",
      "instructor",
      "for",
      "the",
      "Gamaliel",
      "Foundation",
      ",",
      "a",
      "community",
      "organizing",
      "institute",
      ".",
      "In",
      "mid-1988",
      ",",
      "he",
      "traveled",
      "for",
      "the",
      "first",
      "time",
      "in",
      "Europe",
      "for",
      "three",
      "weeks",
      "and",
      "then",
      "for",
      "five",
      "weeks",
      "in",
      "Kenya",
      ",",
      "where",
      "he",
      "met",
      "many",
      "of",
      "his",
      "paternal",
      "relatives",
      "for",
      "the",
      "first",
      "time",
      "."
    ],
    "complete_sentence": "Two years after graduating from Columbia , Obama moved from New York to Chicago when he was hired as director of the Developing Communities Project , a church - based community organization originally comprising eight Catholic parishes in Roseland , West Pullman , and Riverdale on Chicago 's South Side . He worked there as a community organizer from June 1985 to May 1988 . He helped set up a job training program , a college preparatory tutoring program , and a tenants ' rights organization in Altgeld Gardens . Obama also worked as a consultant and instructor for the Gamaliel Foundation , a community organizing institute . In mid-1988 , he traveled for the first time in Europe for three weeks and then for five weeks in Kenya , where he met many of his paternal relatives for the first time ."
  },
  {
    "sentences": [
      [
        "Obama",
        "entered",
        "Harvard",
        "Law",
        "School",
        "in",
        "the",
        "fall",
        "of",
        "1988",
        ",",
        "living",
        "in",
        "nearby",
        "Somerville",
        ",",
        "Massachusetts",
        "."
      ],
      [
        "He",
        "was",
        "selected",
        "as",
        "an",
        "editor",
        "of",
        "the",
        "Harvard",
        "Law",
        "Review",
        "at",
        "the",
        "end",
        "of",
        "his",
        "first",
        "year",
        ",",
        "president",
        "of",
        "the",
        "journal",
        "in",
        "his",
        "second",
        "year",
        ",",
        "and",
        "research",
        "assistant",
        "to",
        "the",
        "constitutional",
        "scholar",
        "Laurence",
        "Tribe",
        "while",
        "at",
        "Harvard",
        "for",
        "two",
        "years",
        "."
      ],
      [
        "During",
        "his",
        "summers",
        ",",
        "he",
        "returned",
        "to",
        "Chicago",
        ",",
        "where",
        "he",
        "worked",
        "as",
        "a",
        "summer",
        "associate",
        "at",
        "the",
        "law",
        "firms",
        "of",
        "Sidley",
        "Austin",
        "in",
        "1989",
        "and",
        "Hopkins",
        "&",
        "Sutter",
        "in",
        "1990",
        "."
      ],
      [
        "After",
        "graduating",
        "with",
        "a",
        "JD",
        "degree",
        "magna",
        "cum",
        "laude",
        "from",
        "Harvard",
        "in",
        "1991",
        ",",
        "he",
        "returned",
        "to",
        "Chicago",
        "."
      ],
      [
        "Obama",
        "'s",
        "election",
        "as",
        "the",
        "first",
        "black",
        "president",
        "of",
        "the",
        "Harvard",
        "Law",
        "Review",
        "gained",
        "national",
        "media",
        "attention",
        "and",
        "led",
        "to",
        "a",
        "publishing",
        "contract",
        "and",
        "advance",
        "for",
        "a",
        "book",
        "about",
        "race",
        "relations",
        ",",
        "which",
        "evolved",
        "into",
        "a",
        "personal",
        "memoir",
        "."
      ],
      [
        "The",
        "manuscript",
        "was",
        "published",
        "in",
        "mid-1995",
        "as",
        "Dreams",
        "from",
        "My",
        "Father",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            18,
            18
          ],
          [
            33,
            33
          ],
          [
            42,
            42
          ],
          [
            63,
            63
          ],
          [
            66,
            66
          ],
          [
            72,
            72
          ],
          [
            108,
            108
          ],
          [
            113,
            114
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "He"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "Obama",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "I-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-PERSON",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279829.458566B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279829.458549A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279829.458556A",
            "sequences": [
              "He"
            ],
            "positions": [
              18,
              18
            ]
          },
          {
            "id": "1571279829.458558A",
            "sequences": [
              "his"
            ],
            "positions": [
              33,
              33
            ]
          },
          {
            "id": "1571279829.458559A",
            "sequences": [
              "his"
            ],
            "positions": [
              42,
              42
            ]
          },
          {
            "id": "1571279829.45856A",
            "sequences": [
              "his"
            ],
            "positions": [
              63,
              63
            ]
          },
          {
            "id": "1571279829.458561A",
            "sequences": [
              "he"
            ],
            "positions": [
              66,
              66
            ]
          },
          {
            "id": "1571279829.458563A",
            "sequences": [
              "he"
            ],
            "positions": [
              72,
              72
            ]
          },
          {
            "id": "1571279829.458564A",
            "sequences": [
              "he"
            ],
            "positions": [
              108,
              108
            ]
          },
          {
            "id": "1571279829.458565A",
            "sequences": [
              "Obama",
              "'s"
            ],
            "positions": [
              113,
              114
            ]
          }
        ]
      },
      {
        "positions": [
          [
            25,
            28
          ],
          [
            39,
            40
          ],
          [
            122,
            125
          ]
        ],
        "sequences": [
          [
            "the",
            "Harvard",
            "Law",
            "Review"
          ],
          [
            "the",
            "journal"
          ],
          [
            "the",
            "Harvard",
            "Law",
            "Review"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "O",
            "O"
          ],
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 0,
        "id": "1571279829.458584B",
        "main_words": [
          "the Harvard Law Review"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            25,
            28
          ],
          [
            122,
            125
          ]
        ],
        "words": [
          {
            "id": "1571279829.45858A",
            "sequences": [
              "the",
              "Harvard",
              "Law",
              "Review"
            ],
            "positions": [
              25,
              28
            ]
          },
          {
            "id": "1571279829.458581A",
            "sequences": [
              "the",
              "journal"
            ],
            "positions": [
              39,
              40
            ]
          },
          {
            "id": "1571279829.458582A",
            "sequences": [
              "the",
              "Harvard",
              "Law",
              "Review"
            ],
            "positions": [
              122,
              125
            ]
          }
        ]
      },
      {
        "main_words": [
          "Harvard Law School"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              2,
              4
            ]
          ]
        ],
        "positions": [
          [
            2,
            4
          ]
        ],
        "sequences": [
          [
            "Harvard",
            "Law",
            "School"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279829.462092B",
        "words": [
          {
            "id": "1571279829.4621A",
            "sequences": [
              "Harvard",
              "Law",
              "School"
            ],
            "positions": [
              2,
              4
            ]
          }
        ]
      },
      {
        "main_words": [
          "Harvard"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              57,
              57
            ],
            [
              104,
              104
            ]
          ]
        ],
        "positions": [
          [
            57,
            57
          ],
          [
            104,
            104
          ]
        ],
        "sequences": [
          [
            "Harvard"
          ],
          [
            "Harvard"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG"
          ],
          [
            "B-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279829.462096B",
        "words": [
          {
            "id": "1571279829.462102A",
            "sequences": [
              "Harvard"
            ],
            "positions": [
              57,
              57
            ]
          },
          {
            "id": "1571279829.462103A",
            "sequences": [
              "Harvard"
            ],
            "positions": [
              104,
              104
            ]
          }
        ]
      },
      {
        "positions": [
          [
            69,
            92
          ],
          [
            111,
            111
          ]
        ],
        "sequences": [
          [
            "Chicago",
            ",",
            "where",
            "he",
            "worked",
            "as",
            "a",
            "summer",
            "associate",
            "at",
            "the",
            "law",
            "firms",
            "of",
            "Sidley",
            "Austin",
            "in",
            "1989",
            "and",
            "Hopkins",
            "&",
            "Sutter",
            "in",
            "1990"
          ],
          [
            "Chicago"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "B-DATE",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "B-ORG",
            "I-ORG",
            "O",
            "B-DATE",
            "O",
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "O",
            "B-DATE"
          ],
          [
            "B-GPE"
          ]
        ],
        "flags": 0,
        "id": "1571279829.462125B",
        "main_words": [
          "Chicago"
        ],
        "ner_tags": [
          "GPE"
        ],
        "position_main_word": [
          [
            111,
            111
          ]
        ],
        "words": [
          {
            "id": "1571279829.462122A",
            "sequences": [
              "Chicago",
              ",",
              "where",
              "he",
              "worked",
              "as",
              "a",
              "summer",
              "associate",
              "at",
              "the",
              "law",
              "firms",
              "of",
              "Sidley",
              "Austin",
              "in",
              "1989",
              "and",
              "Hopkins",
              "&",
              "Sutter",
              "in",
              "1990"
            ],
            "positions": [
              69,
              92
            ]
          },
          {
            "id": "1571279829.462123A",
            "sequences": [
              "Chicago"
            ],
            "positions": [
              111,
              111
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "B-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "B-WORK_OF_ART",
      "I-WORK_OF_ART",
      "I-WORK_OF_ART",
      "I-WORK_OF_ART",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "entered",
      "Harvard",
      "Law",
      "School",
      "in",
      "the",
      "fall",
      "of",
      "1988",
      ",",
      "living",
      "in",
      "nearby",
      "Somerville",
      ",",
      "Massachusetts",
      ".",
      "He",
      "was",
      "selected",
      "as",
      "an",
      "editor",
      "of",
      "the",
      "Harvard",
      "Law",
      "Review",
      "at",
      "the",
      "end",
      "of",
      "his",
      "first",
      "year",
      ",",
      "president",
      "of",
      "the",
      "journal",
      "in",
      "his",
      "second",
      "year",
      ",",
      "and",
      "research",
      "assistant",
      "to",
      "the",
      "constitutional",
      "scholar",
      "Laurence",
      "Tribe",
      "while",
      "at",
      "Harvard",
      "for",
      "two",
      "years",
      ".",
      "During",
      "his",
      "summers",
      ",",
      "he",
      "returned",
      "to",
      "Chicago",
      ",",
      "where",
      "he",
      "worked",
      "as",
      "a",
      "summer",
      "associate",
      "at",
      "the",
      "law",
      "firms",
      "of",
      "Sidley",
      "Austin",
      "in",
      "1989",
      "and",
      "Hopkins",
      "&",
      "Sutter",
      "in",
      "1990",
      ".",
      "After",
      "graduating",
      "with",
      "a",
      "JD",
      "degree",
      "magna",
      "cum",
      "laude",
      "from",
      "Harvard",
      "in",
      "1991",
      ",",
      "he",
      "returned",
      "to",
      "Chicago",
      ".",
      "Obama",
      "'s",
      "election",
      "as",
      "the",
      "first",
      "black",
      "president",
      "of",
      "the",
      "Harvard",
      "Law",
      "Review",
      "gained",
      "national",
      "media",
      "attention",
      "and",
      "led",
      "to",
      "a",
      "publishing",
      "contract",
      "and",
      "advance",
      "for",
      "a",
      "book",
      "about",
      "race",
      "relations",
      ",",
      "which",
      "evolved",
      "into",
      "a",
      "personal",
      "memoir",
      ".",
      "The",
      "manuscript",
      "was",
      "published",
      "in",
      "mid-1995",
      "as",
      "Dreams",
      "from",
      "My",
      "Father",
      "."
    ],
    "complete_sentence": "Obama entered Harvard Law School in the fall of 1988 , living in nearby Somerville , Massachusetts . He was selected as an editor of the Harvard Law Review at the end of his first year , president of the journal in his second year , and research assistant to the constitutional scholar Laurence Tribe while at Harvard for two years . During his summers , he returned to Chicago , where he worked as a summer associate at the law firms of Sidley Austin in 1989 and Hopkins & Sutter in 1990 . After graduating with a JD degree magna cum laude from Harvard in 1991 , he returned to Chicago . Obama 's election as the first black president of the Harvard Law Review gained national media attention and led to a publishing contract and advance for a book about race relations , which evolved into a personal memoir . The manuscript was published in mid-1995 as Dreams from My Father ."
  },
  {
    "sentences": [
      [
        "In",
        "1991",
        ",",
        "Obama",
        "accepted",
        "a",
        "two",
        "-",
        "year",
        "position",
        "as",
        "Visiting",
        "Law",
        "and",
        "Government",
        "Fellow",
        "at",
        "the",
        "University",
        "of",
        "Chicago",
        "Law",
        "School",
        "to",
        "work",
        "on",
        "his",
        "first",
        "book",
        "."
      ],
      [
        "He",
        "then",
        "taught",
        "constitutional",
        "law",
        "at",
        "the",
        "University",
        "of",
        "Chicago",
        "Law",
        "School",
        "for",
        "twelve",
        "years",
        ",",
        "first",
        "as",
        "a",
        "lecturer",
        "from",
        "1992",
        "to",
        "1996",
        ",",
        "and",
        "then",
        "as",
        "a",
        "senior",
        "lecturer",
        "from",
        "1996",
        "to",
        "2004",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            3,
            3
          ],
          [
            26,
            26
          ],
          [
            30,
            30
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "his"
          ],
          [
            "He"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279830.26992B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            3,
            3
          ]
        ],
        "words": [
          {
            "id": "1571279830.26991A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              3,
              3
            ]
          },
          {
            "id": "1571279830.269917A",
            "sequences": [
              "his"
            ],
            "positions": [
              26,
              26
            ]
          },
          {
            "id": "1571279830.269918A",
            "sequences": [
              "He"
            ],
            "positions": [
              30,
              30
            ]
          }
        ]
      },
      {
        "positions": [
          [
            17,
            22
          ],
          [
            36,
            41
          ]
        ],
        "sequences": [
          [
            "the",
            "University",
            "of",
            "Chicago",
            "Law",
            "School"
          ],
          [
            "the",
            "University",
            "of",
            "Chicago",
            "Law",
            "School"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 0,
        "id": "1571279830.269933B",
        "main_words": [
          "the University of Chicago Law School"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            17,
            22
          ],
          [
            36,
            41
          ]
        ],
        "words": [
          {
            "id": "1571279830.269931A",
            "sequences": [
              "the",
              "University",
              "of",
              "Chicago",
              "Law",
              "School"
            ],
            "positions": [
              17,
              22
            ]
          },
          {
            "id": "1571279830.269932A",
            "sequences": [
              "the",
              "University",
              "of",
              "Chicago",
              "Law",
              "School"
            ],
            "positions": [
              36,
              41
            ]
          }
        ]
      },
      {
        "positions": [
          [
            53,
            53
          ],
          [
            62,
            62
          ]
        ],
        "sequences": [
          [
            "1996"
          ],
          [
            "1996"
          ]
        ],
        "ner_sequences": [
          [
            "I-DATE"
          ],
          [
            "B-DATE"
          ]
        ],
        "flags": -1,
        "id": "1571279830.269941B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279830.269939A",
            "sequences": [
              "1996"
            ],
            "positions": [
              53,
              53
            ]
          },
          {
            "id": "1571279830.26994A",
            "sequences": [
              "1996"
            ],
            "positions": [
              62,
              62
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "B-EVENT",
      "I-LAW",
      "O",
      "B-NORP",
      "I-NORP",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O"
    ],
    "doc_tokens": [
      "In",
      "1991",
      ",",
      "Obama",
      "accepted",
      "a",
      "two",
      "-",
      "year",
      "position",
      "as",
      "Visiting",
      "Law",
      "and",
      "Government",
      "Fellow",
      "at",
      "the",
      "University",
      "of",
      "Chicago",
      "Law",
      "School",
      "to",
      "work",
      "on",
      "his",
      "first",
      "book",
      ".",
      "He",
      "then",
      "taught",
      "constitutional",
      "law",
      "at",
      "the",
      "University",
      "of",
      "Chicago",
      "Law",
      "School",
      "for",
      "twelve",
      "years",
      ",",
      "first",
      "as",
      "a",
      "lecturer",
      "from",
      "1992",
      "to",
      "1996",
      ",",
      "and",
      "then",
      "as",
      "a",
      "senior",
      "lecturer",
      "from",
      "1996",
      "to",
      "2004",
      "."
    ],
    "complete_sentence": "In 1991 , Obama accepted a two - year position as Visiting Law and Government Fellow at the University of Chicago Law School to work on his first book . He then taught constitutional law at the University of Chicago Law School for twelve years , first as a lecturer from 1992 to 1996 , and then as a senior lecturer from 1996 to 2004 ."
  },
  {
    "sentences": [
      [
        "From",
        "April",
        "to",
        "October",
        "1992",
        ",",
        "Obama",
        "directed",
        "Illinois",
        "'s",
        "Project",
        "Vote",
        ",",
        "a",
        "voter",
        "registration",
        "campaign",
        "with",
        "ten",
        "staffers",
        "and",
        "seven",
        "hundred",
        "volunteer",
        "registrars",
        ";",
        "it",
        "achieved",
        "its",
        "goal",
        "of",
        "registering",
        "150,000",
        "of",
        "400,000",
        "unregistered",
        "African",
        "Americans",
        "in",
        "the",
        "state",
        ",",
        "leading",
        "Crain",
        "'s",
        "Chicago",
        "Business",
        "to",
        "name",
        "Obama",
        "to",
        "its",
        "1993",
        "list",
        "of",
        "\"",
        "40",
        "under",
        "Forty",
        "\"",
        "powers",
        "to",
        "be",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            8,
            24
          ],
          [
            26,
            26
          ],
          [
            28,
            28
          ],
          [
            51,
            51
          ]
        ],
        "sequences": [
          [
            "Illinois",
            "'s",
            "Project",
            "Vote",
            ",",
            "a",
            "voter",
            "registration",
            "campaign",
            "with",
            "ten",
            "staffers",
            "and",
            "seven",
            "hundred",
            "volunteer",
            "registrars"
          ],
          [
            "it"
          ],
          [
            "its"
          ],
          [
            "its"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE",
            "O",
            "B-ORG",
            "I-ORG",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "B-CARDINAL",
            "O",
            "O",
            "B-CARDINAL",
            "I-CARDINAL",
            "O",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279831.108099B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279831.108088A",
            "sequences": [
              "Illinois",
              "'s",
              "Project",
              "Vote",
              ",",
              "a",
              "voter",
              "registration",
              "campaign",
              "with",
              "ten",
              "staffers",
              "and",
              "seven",
              "hundred",
              "volunteer",
              "registrars"
            ],
            "positions": [
              8,
              24
            ]
          },
          {
            "id": "1571279831.108095A",
            "sequences": [
              "it"
            ],
            "positions": [
              26,
              26
            ]
          },
          {
            "id": "1571279831.108097A",
            "sequences": [
              "its"
            ],
            "positions": [
              28,
              28
            ]
          },
          {
            "id": "1571279831.108098A",
            "sequences": [
              "its"
            ],
            "positions": [
              51,
              51
            ]
          }
        ]
      },
      {
        "positions": [
          [
            8,
            9
          ],
          [
            39,
            40
          ]
        ],
        "sequences": [
          [
            "Illinois",
            "'s"
          ],
          [
            "the",
            "state"
          ]
        ],
        "ner_sequences": [
          [
            "B-GPE",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279831.108108B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279831.108105A",
            "sequences": [
              "Illinois",
              "'s"
            ],
            "positions": [
              8,
              9
            ]
          },
          {
            "id": "1571279831.108107A",
            "sequences": [
              "the",
              "state"
            ],
            "positions": [
              39,
              40
            ]
          }
        ]
      },
      {
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              49,
              49
            ]
          ]
        ],
        "positions": [
          [
            49,
            49
          ]
        ],
        "sequences": [
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279831.111459B",
        "words": [
          {
            "id": "1571279831.111471A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              49,
              49
            ]
          }
        ]
      },
      {
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "NORP"
        ],
        "position_main_word": [
          [
            [
              6,
              6
            ]
          ]
        ],
        "positions": [
          [
            6,
            6
          ]
        ],
        "sequences": [
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "B-NORP"
          ]
        ],
        "flags": 1,
        "id": "1571279831.111467B",
        "words": [
          {
            "id": "1571279831.111473A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              6,
              6
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-NORP",
      "O",
      "B-GPE",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "B-CARDINAL",
      "I-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "B-CARDINAL",
      "O",
      "B-NORP",
      "I-NORP",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "From",
      "April",
      "to",
      "October",
      "1992",
      ",",
      "Obama",
      "directed",
      "Illinois",
      "'s",
      "Project",
      "Vote",
      ",",
      "a",
      "voter",
      "registration",
      "campaign",
      "with",
      "ten",
      "staffers",
      "and",
      "seven",
      "hundred",
      "volunteer",
      "registrars",
      ";",
      "it",
      "achieved",
      "its",
      "goal",
      "of",
      "registering",
      "150,000",
      "of",
      "400,000",
      "unregistered",
      "African",
      "Americans",
      "in",
      "the",
      "state",
      ",",
      "leading",
      "Crain",
      "'s",
      "Chicago",
      "Business",
      "to",
      "name",
      "Obama",
      "to",
      "its",
      "1993",
      "list",
      "of",
      "\"",
      "40",
      "under",
      "Forty",
      "\"",
      "powers",
      "to",
      "be",
      "."
    ],
    "complete_sentence": "From April to October 1992 , Obama directed Illinois 's Project Vote , a voter registration campaign with ten staffers and seven hundred volunteer registrars ; it achieved its goal of registering 150,000 of 400,000 unregistered African Americans in the state , leading Crain 's Chicago Business to name Obama to its 1993 list of \" 40 under Forty \" powers to be ."
  },
  {
    "sentences": [
      [
        "He",
        "joined",
        "Davis",
        ",",
        "Miner",
        ",",
        "Barnhill",
        "&",
        "Galland",
        ",",
        "a",
        "13-attorney",
        "law",
        "firm",
        "specializing",
        "in",
        "civil",
        "rights",
        "litigation",
        "and",
        "neighborhood",
        "economic",
        "development",
        ",",
        "where",
        "he",
        "was",
        "an",
        "associate",
        "for",
        "three",
        "years",
        "from",
        "1993",
        "to",
        "1996",
        ",",
        "then",
        "of",
        "counsel",
        "from",
        "1996",
        "to",
        "2004",
        "."
      ],
      [
        "In",
        "1994",
        ",",
        "he",
        "was",
        "listed",
        "as",
        "one",
        "of",
        "the",
        "lawyers",
        "in",
        "Buycks",
        "-",
        "Roberson",
        "v.",
        "Citibank",
        "Fed",
        "."
      ],
      [
        "Sav",
        "."
      ],
      [
        "Bank",
        ",",
        "94",
        "C"
      ],
      [
        "4094",
        "(",
        "N.D.",
        "Ill.",
        ")",
        "."
      ],
      [
        "This",
        "class",
        "action",
        "lawsuit",
        "was",
        "filed",
        "in",
        "1994",
        "with",
        "Selma",
        "Buycks",
        "-",
        "Roberson",
        "as",
        "lead",
        "plaintiff",
        "and",
        "alleged",
        "that",
        "Citibank",
        "Federal",
        "Savings",
        "Bank",
        "had",
        "engaged",
        "in",
        "practices",
        "forbidden",
        "under",
        "the",
        "Equal",
        "Credit",
        "Opportunity",
        "Act",
        "and",
        "the",
        "Fair",
        "Housing",
        "Act",
        "."
      ],
      [
        "The",
        "case",
        "was",
        "settled",
        "out",
        "of",
        "court",
        "."
      ],
      [
        "Final",
        "judgment",
        "was",
        "issued",
        "on",
        "May",
        "13",
        ",",
        "1998",
        ",",
        "with",
        "Citibank",
        "Federal",
        "Savings",
        "Bank",
        "agreeing",
        "to",
        "pay",
        "attorney",
        "fees",
        "."
      ],
      [
        "His",
        "law",
        "license",
        "became",
        "inactive",
        "in",
        "2007",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            25,
            25
          ],
          [
            48,
            48
          ],
          [
            145,
            145
          ]
        ],
        "sequences": [
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "His"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279833.335439B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279833.335428A",
            "sequences": [
              "He"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279833.335435A",
            "sequences": [
              "he"
            ],
            "positions": [
              25,
              25
            ]
          },
          {
            "id": "1571279833.335436A",
            "sequences": [
              "he"
            ],
            "positions": [
              48,
              48
            ]
          },
          {
            "id": "1571279833.335438A",
            "sequences": [
              "His"
            ],
            "positions": [
              145,
              145
            ]
          }
        ]
      },
      {
        "positions": [
          [
            76,
            79
          ],
          [
            116,
            117
          ]
        ],
        "sequences": [
          [
            "This",
            "class",
            "action",
            "lawsuit"
          ],
          [
            "The",
            "case"
          ]
        ],
        "ner_sequences": [
          [
            "O",
            "O",
            "O",
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279833.335448B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279833.335445A",
            "sequences": [
              "This",
              "class",
              "action",
              "lawsuit"
            ],
            "positions": [
              76,
              79
            ]
          },
          {
            "id": "1571279833.335447A",
            "sequences": [
              "The",
              "case"
            ],
            "positions": [
              116,
              117
            ]
          }
        ]
      },
      {
        "positions": [
          [
            95,
            98
          ],
          [
            135,
            138
          ]
        ],
        "sequences": [
          [
            "Citibank",
            "Federal",
            "Savings",
            "Bank"
          ],
          [
            "Citibank",
            "Federal",
            "Savings",
            "Bank"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "B-ORG",
            "I-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 0,
        "id": "1571279833.335461B",
        "main_words": [
          "Citibank Federal Savings Bank"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            95,
            98
          ],
          [
            135,
            138
          ]
        ],
        "words": [
          {
            "id": "1571279833.335458A",
            "sequences": [
              "Citibank",
              "Federal",
              "Savings",
              "Bank"
            ],
            "positions": [
              95,
              98
            ]
          },
          {
            "id": "1571279833.33546A",
            "sequences": [
              "Citibank",
              "Federal",
              "Savings",
              "Bank"
            ],
            "positions": [
              135,
              138
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-PERSON",
      "O",
      "B-ORG",
      "O",
      "B-PERCENT",
      "O",
      "B-CARDINAL",
      "O",
      "B-GPE",
      "I-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "B-PERSON",
      "I-PERSON",
      "I-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "B-LAW",
      "I-LAW",
      "I-LAW",
      "I-LAW",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O"
    ],
    "doc_tokens": [
      "He",
      "joined",
      "Davis",
      ",",
      "Miner",
      ",",
      "Barnhill",
      "&",
      "Galland",
      ",",
      "a",
      "13-attorney",
      "law",
      "firm",
      "specializing",
      "in",
      "civil",
      "rights",
      "litigation",
      "and",
      "neighborhood",
      "economic",
      "development",
      ",",
      "where",
      "he",
      "was",
      "an",
      "associate",
      "for",
      "three",
      "years",
      "from",
      "1993",
      "to",
      "1996",
      ",",
      "then",
      "of",
      "counsel",
      "from",
      "1996",
      "to",
      "2004",
      ".",
      "In",
      "1994",
      ",",
      "he",
      "was",
      "listed",
      "as",
      "one",
      "of",
      "the",
      "lawyers",
      "in",
      "Buycks",
      "-",
      "Roberson",
      "v.",
      "Citibank",
      "Fed",
      ".",
      "Sav",
      ".",
      "Bank",
      ",",
      "94",
      "C",
      "4094",
      "(",
      "N.D.",
      "Ill.",
      ")",
      ".",
      "This",
      "class",
      "action",
      "lawsuit",
      "was",
      "filed",
      "in",
      "1994",
      "with",
      "Selma",
      "Buycks",
      "-",
      "Roberson",
      "as",
      "lead",
      "plaintiff",
      "and",
      "alleged",
      "that",
      "Citibank",
      "Federal",
      "Savings",
      "Bank",
      "had",
      "engaged",
      "in",
      "practices",
      "forbidden",
      "under",
      "the",
      "Equal",
      "Credit",
      "Opportunity",
      "Act",
      "and",
      "the",
      "Fair",
      "Housing",
      "Act",
      ".",
      "The",
      "case",
      "was",
      "settled",
      "out",
      "of",
      "court",
      ".",
      "Final",
      "judgment",
      "was",
      "issued",
      "on",
      "May",
      "13",
      ",",
      "1998",
      ",",
      "with",
      "Citibank",
      "Federal",
      "Savings",
      "Bank",
      "agreeing",
      "to",
      "pay",
      "attorney",
      "fees",
      ".",
      "His",
      "law",
      "license",
      "became",
      "inactive",
      "in",
      "2007",
      "."
    ],
    "complete_sentence": "He joined Davis , Miner , Barnhill & Galland , a 13-attorney law firm specializing in civil rights litigation and neighborhood economic development , where he was an associate for three years from 1993 to 1996 , then of counsel from 1996 to 2004 . In 1994 , he was listed as one of the lawyers in Buycks - Roberson v. Citibank Fed . Sav . Bank , 94 C 4094 ( N.D. Ill. ) . This class action lawsuit was filed in 1994 with Selma Buycks - Roberson as lead plaintiff and alleged that Citibank Federal Savings Bank had engaged in practices forbidden under the Equal Credit Opportunity Act and the Fair Housing Act . The case was settled out of court . Final judgment was issued on May 13 , 1998 , with Citibank Federal Savings Bank agreeing to pay attorney fees . His law license became inactive in 2007 ."
  },
  {
    "sentences": [
      [
        "From",
        "1994",
        "to",
        "2002",
        ",",
        "Obama",
        "served",
        "on",
        "the",
        "boards",
        "of",
        "directors",
        "of",
        "the",
        "Woods",
        "Fund",
        "of",
        "Chicago",
        "--",
        "which",
        "in",
        "1985",
        "had",
        "been",
        "the",
        "first",
        "foundation",
        "to",
        "fund",
        "the",
        "Developing",
        "Communities",
        "Project",
        "--",
        "and",
        "of",
        "the",
        "Joyce",
        "Foundation",
        "."
      ],
      [
        "He",
        "served",
        "on",
        "the",
        "board",
        "of",
        "directors",
        "of",
        "the",
        "Chicago",
        "Annenberg",
        "Challenge",
        "from",
        "1995",
        "to",
        "2002",
        ",",
        "as",
        "founding",
        "president",
        "and",
        "chairman",
        "of",
        "the",
        "board",
        "of",
        "directors",
        "from",
        "1995",
        "to",
        "1999",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            5,
            5
          ],
          [
            40,
            40
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "He"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279834.22828B",
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            5,
            5
          ]
        ],
        "words": [
          {
            "id": "1571279834.228271A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              5,
              5
            ]
          },
          {
            "id": "1571279834.228278A",
            "sequences": [
              "He"
            ],
            "positions": [
              40,
              40
            ]
          }
        ]
      },
      {
        "positions": [
          [
            53,
            53
          ],
          [
            68,
            68
          ]
        ],
        "sequences": [
          [
            "1995"
          ],
          [
            "1995"
          ]
        ],
        "ner_sequences": [
          [
            "B-DATE"
          ],
          [
            "B-DATE"
          ]
        ],
        "flags": -1,
        "id": "1571279834.228289B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279834.228287A",
            "sequences": [
              "1995"
            ],
            "positions": [
              53,
              53
            ]
          },
          {
            "id": "1571279834.228288A",
            "sequences": [
              "1995"
            ],
            "positions": [
              68,
              68
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O"
    ],
    "doc_tokens": [
      "From",
      "1994",
      "to",
      "2002",
      ",",
      "Obama",
      "served",
      "on",
      "the",
      "boards",
      "of",
      "directors",
      "of",
      "the",
      "Woods",
      "Fund",
      "of",
      "Chicago",
      "--",
      "which",
      "in",
      "1985",
      "had",
      "been",
      "the",
      "first",
      "foundation",
      "to",
      "fund",
      "the",
      "Developing",
      "Communities",
      "Project",
      "--",
      "and",
      "of",
      "the",
      "Joyce",
      "Foundation",
      ".",
      "He",
      "served",
      "on",
      "the",
      "board",
      "of",
      "directors",
      "of",
      "the",
      "Chicago",
      "Annenberg",
      "Challenge",
      "from",
      "1995",
      "to",
      "2002",
      ",",
      "as",
      "founding",
      "president",
      "and",
      "chairman",
      "of",
      "the",
      "board",
      "of",
      "directors",
      "from",
      "1995",
      "to",
      "1999",
      "."
    ],
    "complete_sentence": "From 1994 to 2002 , Obama served on the boards of directors of the Woods Fund of Chicago -- which in 1985 had been the first foundation to fund the Developing Communities Project -- and of the Joyce Foundation . He served on the board of directors of the Chicago Annenberg Challenge from 1995 to 2002 , as founding president and chairman of the board of directors from 1995 to 1999 ."
  },
  {
    "sentences": [
      [
        "Obama",
        "was",
        "elected",
        "to",
        "the",
        "Illinois",
        "Senate",
        "in",
        "1996",
        ",",
        "succeeding",
        "Democratic",
        "State",
        "Senator",
        "Alice",
        "Palmer",
        "from",
        "Illinois",
        "'s",
        "13th",
        "District",
        ",",
        "which",
        ",",
        "at",
        "that",
        "time",
        ",",
        "spanned",
        "Chicago",
        "South",
        "Side",
        "neighborhoods",
        "from",
        "Hyde",
        "Park",
        "-",
        "Kenwood",
        "south",
        "to",
        "South",
        "Shore",
        "and",
        "west",
        "to",
        "Chicago",
        "Lawn",
        "."
      ],
      [
        "Once",
        "elected",
        ",",
        "Obama",
        "gained",
        "bipartisan",
        "support",
        "for",
        "legislation",
        "that",
        "reformed",
        "ethics",
        "and",
        "health",
        "care",
        "laws",
        "."
      ],
      [
        "He",
        "sponsored",
        "a",
        "law",
        "that",
        "increased",
        "tax",
        "credits",
        "for",
        "low",
        "-",
        "income",
        "workers",
        ",",
        "negotiated",
        "welfare",
        "reform",
        ",",
        "and",
        "promoted",
        "increased",
        "subsidies",
        "for",
        "childcare",
        "."
      ],
      [
        "In",
        "2001",
        ",",
        "as",
        "co",
        "-",
        "chairman",
        "of",
        "the",
        "bipartisan",
        "Joint",
        "Committee",
        "on",
        "Administrative",
        "Rules",
        ",",
        "Obama",
        "supported",
        "Republican",
        "Governor",
        "Ryan",
        "'s",
        "payday",
        "loan",
        "regulations",
        "and",
        "predatory",
        "mortgage",
        "lending",
        "regulations",
        "aimed",
        "at",
        "averting",
        "home",
        "foreclosures",
        "."
      ]
    ],
    "elements": [
      {
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            [
              0,
              0
            ],
            [
              51,
              51
            ]
          ]
        ],
        "positions": [
          [
            0,
            0
          ],
          [
            51,
            51
          ],
          [
            65,
            65
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "Obama"
          ],
          [
            "He"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "B-PERSON"
          ],
          [
            "O"
          ]
        ],
        "flags": 1,
        "id": "1571279835.472557B",
        "words": [
          {
            "id": "1571279835.472569A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279835.472571A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              51,
              51
            ]
          },
          {
            "id": "1571279835.472572A",
            "sequences": [
              "He"
            ],
            "positions": [
              65,
              65
            ]
          }
        ]
      },
      {
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            [
              106,
              106
            ]
          ]
        ],
        "positions": [
          [
            106,
            106
          ]
        ],
        "sequences": [
          [
            "Obama"
          ]
        ],
        "ner_sequences": [
          [
            "I-ORG"
          ]
        ],
        "flags": 1,
        "id": "1571279835.472565B",
        "words": [
          {
            "id": "1571279835.472574A",
            "sequences": [
              "Obama"
            ],
            "positions": [
              106,
              106
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-NORP",
      "B-ORG",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-GPE",
      "O",
      "B-ORDINAL",
      "I-LOC",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-LOC",
      "I-LOC",
      "I-LOC",
      "O",
      "O",
      "B-LOC",
      "I-LOC",
      "I-LOC",
      "I-LOC",
      "O",
      "O",
      "B-LOC",
      "I-LOC",
      "O",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-NORP",
      "O",
      "B-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O"
    ],
    "doc_tokens": [
      "Obama",
      "was",
      "elected",
      "to",
      "the",
      "Illinois",
      "Senate",
      "in",
      "1996",
      ",",
      "succeeding",
      "Democratic",
      "State",
      "Senator",
      "Alice",
      "Palmer",
      "from",
      "Illinois",
      "'s",
      "13th",
      "District",
      ",",
      "which",
      ",",
      "at",
      "that",
      "time",
      ",",
      "spanned",
      "Chicago",
      "South",
      "Side",
      "neighborhoods",
      "from",
      "Hyde",
      "Park",
      "-",
      "Kenwood",
      "south",
      "to",
      "South",
      "Shore",
      "and",
      "west",
      "to",
      "Chicago",
      "Lawn",
      ".",
      "Once",
      "elected",
      ",",
      "Obama",
      "gained",
      "bipartisan",
      "support",
      "for",
      "legislation",
      "that",
      "reformed",
      "ethics",
      "and",
      "health",
      "care",
      "laws",
      ".",
      "He",
      "sponsored",
      "a",
      "law",
      "that",
      "increased",
      "tax",
      "credits",
      "for",
      "low",
      "-",
      "income",
      "workers",
      ",",
      "negotiated",
      "welfare",
      "reform",
      ",",
      "and",
      "promoted",
      "increased",
      "subsidies",
      "for",
      "childcare",
      ".",
      "In",
      "2001",
      ",",
      "as",
      "co",
      "-",
      "chairman",
      "of",
      "the",
      "bipartisan",
      "Joint",
      "Committee",
      "on",
      "Administrative",
      "Rules",
      ",",
      "Obama",
      "supported",
      "Republican",
      "Governor",
      "Ryan",
      "'s",
      "payday",
      "loan",
      "regulations",
      "and",
      "predatory",
      "mortgage",
      "lending",
      "regulations",
      "aimed",
      "at",
      "averting",
      "home",
      "foreclosures",
      "."
    ],
    "complete_sentence": "Obama was elected to the Illinois Senate in 1996 , succeeding Democratic State Senator Alice Palmer from Illinois 's 13th District , which , at that time , spanned Chicago South Side neighborhoods from Hyde Park - Kenwood south to South Shore and west to Chicago Lawn . Once elected , Obama gained bipartisan support for legislation that reformed ethics and health care laws . He sponsored a law that increased tax credits for low - income workers , negotiated welfare reform , and promoted increased subsidies for childcare . In 2001 , as co - chairman of the bipartisan Joint Committee on Administrative Rules , Obama supported Republican Governor Ryan 's payday loan regulations and predatory mortgage lending regulations aimed at averting home foreclosures ."
  },
  {
    "sentences": [
      [
        "He",
        "was",
        "reelected",
        "to",
        "the",
        "Illinois",
        "Senate",
        "in",
        "1998",
        ",",
        "defeating",
        "Republican",
        "Yesse",
        "Yehudah",
        "in",
        "the",
        "general",
        "election",
        ",",
        "and",
        "was",
        "re",
        "-",
        "elected",
        "again",
        "in",
        "2002",
        "."
      ],
      [
        "In",
        "2000",
        ",",
        "he",
        "lost",
        "a",
        "Democratic",
        "primary",
        "race",
        "for",
        "Illinois",
        "'s",
        "1st",
        "congressional",
        "district",
        "in",
        "the",
        "United",
        "States",
        "House",
        "of",
        "Representatives",
        "to",
        "four",
        "-",
        "term",
        "incumbent",
        "Bobby",
        "Rush",
        "by",
        "a",
        "margin",
        "of",
        "two",
        "to",
        "one",
        "."
      ]
    ],
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            31,
            31
          ]
        ],
        "sequences": [
          [
            "He"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": -1,
        "id": "1571279836.293637B",
        "main_words": [],
        "ner_tags": [],
        "position_main_word": [],
        "words": [
          {
            "id": "1571279836.293629A",
            "sequences": [
              "He"
            ],
            "positions": [
              0,
              0
            ]
          },
          {
            "id": "1571279836.293635A",
            "sequences": [
              "he"
            ],
            "positions": [
              31,
              31
            ]
          }
        ]
      },
      {
        "positions": [
          [
            5,
            5
          ],
          [
            38,
            39
          ]
        ],
        "sequences": [
          [
            "Illinois"
          ],
          [
            "Illinois",
            "'s"
          ]
        ],
        "ner_sequences": [
          [
            "I-ORG"
          ],
          [
            "B-GPE",
            "O"
          ]
        ],
        "flags": 0,
        "id": "1571279836.293648B",
        "main_words": [
          "Illinois"
        ],
        "ner_tags": [
          "ORG"
        ],
        "position_main_word": [
          [
            5,
            5
          ]
        ],
        "words": [
          {
            "id": "1571279836.293645A",
            "sequences": [
              "Illinois"
            ],
            "positions": [
              5,
              5
            ]
          },
          {
            "id": "1571279836.293647A",
            "sequences": [
              "Illinois",
              "'s"
            ],
            "positions": [
              38,
              39
            ]
          }
        ]
      }
    ],
    "all_ner_tags": [
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-NORP",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "O",
      "B-GPE",
      "I-GPE",
      "I-GPE",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "B-CARDINAL",
      "O"
    ],
    "doc_tokens": [
      "He",
      "was",
      "reelected",
      "to",
      "the",
      "Illinois",
      "Senate",
      "in",
      "1998",
      ",",
      "defeating",
      "Republican",
      "Yesse",
      "Yehudah",
      "in",
      "the",
      "general",
      "election",
      ",",
      "and",
      "was",
      "re",
      "-",
      "elected",
      "again",
      "in",
      "2002",
      ".",
      "In",
      "2000",
      ",",
      "he",
      "lost",
      "a",
      "Democratic",
      "primary",
      "race",
      "for",
      "Illinois",
      "'s",
      "1st",
      "congressional",
      "district",
      "in",
      "the",
      "United",
      "States",
      "House",
      "of",
      "Representatives",
      "to",
      "four",
      "-",
      "term",
      "incumbent",
      "Bobby",
      "Rush",
      "by",
      "a",
      "margin",
      "of",
      "two",
      "to",
      "one",
      "."
    ],
    "complete_sentence": "He was reelected to the Illinois Senate in 1998 , defeating Republican Yesse Yehudah in the general election , and was re - elected again in 2002 . In 2000 , he lost a Democratic primary race for Illinois 's 1st congressional district in the United States House of Representatives to four - term incumbent Bobby Rush by a margin of two to one ."
  }
]

export const coRefData = [
  {
    "sentences": "Barack Obama appeared to take a swipe at Donald Trump on Wednesday , saying he would “ advise , if you ’ re president ” to avoid social media and cable news . The former US president was speaking as a guest at an event for Splunk , an international data and software firm , when he was asked how he parsed information while in office . He touted the importance of building a solid team to stay informed . “ The presidency is like drinking out of a fire hose – you can ’ t absorb that information yourself , ” he said . “ You can make sure you have a team that is distilling info as effectively as possible so you can get a basic framework for what the problem is . “ The other thing that ’ s helpful is not watching TV or reading social media , ” he added , to laughter from the crowd . “ Those are two things I ’ d advise , if you ’ re president , not to do . ” The criticism appears to be targeted at Trump , known for his Twitter diatribes and obsession with cable news channels and how they portray him . Trump tweeted 284 times a month over the last six months , the Hill reports , an increase from months past . Despite the increase in frequency , Trump is getting less engagement on his posts today , the report showed . EU rejects German call to boycott British lamb .",
    "elements": [
      {
        "positions": [
          [
            0,
            1
          ],
          [
            14,
            14
          ],
          [
            33,
            36
          ],
          [
            56,
            56
          ],
          [
            60,
            60
          ],
          [
            67,
            67
          ],
          [
            102,
            102
          ],
          [
            153,
            153
          ],
          [
            167,
            167
          ]
        ],
        "sequences": [
          [
            "Barack",
            "Obama"
          ],
          [
            "he"
          ],
          [
            "The",
            "former",
            "US",
            "president"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "I"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON"
          ],
          [
            "O"
          ],
          [
            "O",
            "O",
            "B-GPE",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "main_words": [
          "Barack Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            1
          ]
        ]
      },
      {
        "positions": [
          [
            62,
            62
          ],
          [
            97,
            98
          ]
        ],
        "sequences": [
          [
            "information"
          ],
          [
            "that",
            "information"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "main_words": [],
        "ner_tags": [],
        "position_main_word": []
      },
      {
        "main_words": "Donald Trump",
        "ner_tags": "PERSON",
        "position_main_word": [
          [
            8,
            9
          ]
        ],
        "positions": [
          [
            8,
            9
          ]
        ],
        "sequences": [
          [
            "Donald",
            "Trump"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON",
            "I-PERSON"
          ]
        ],
        "flags": 1
      },
      {
        "main_words": "Trump",
        "ner_tags": "ORG",
        "position_main_word": [
          [
            209,
            209
          ],
          [
            237,
            237
          ]
        ],
        "positions": [
          [
            190,
            207
          ],
          [
            194,
            194
          ],
          [
            207,
            207
          ],
          [
            209,
            209
          ],
          [
            237,
            237
          ],
          [
            243,
            243
          ]
        ],
        "sequences": [
          [
            "Trump",
            ",",
            "known",
            "for",
            "his",
            "Twitter",
            "diatribes",
            "and",
            "obsession",
            "with",
            "cable",
            "news",
            "channels",
            "and",
            "how",
            "they",
            "portray",
            "him"
          ],
          [
            "his"
          ],
          [
            "him"
          ],
          [
            "Trump"
          ],
          [
            "Trump"
          ],
          [
            "his"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "O",
            "O",
            "O",
            "O",
            "B-ORG",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O",
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "B-ORG"
          ],
          [
            "B-ORG"
          ],
          [
            "O"
          ]
        ],
        "flags": 1
      },
      {
        "positions": [
          [
            223,
            223
          ],
          [
            247,
            248
          ]
        ],
        "sequences": [
          [
            "reports"
          ],
          [
            "the",
            "report"
          ]
        ],
        "ner_sequences": [
          [
            "O"
          ],
          [
            "O",
            "O"
          ]
        ],
        "flags": -1,
        "main_words": [],
        "ner_tags": [],
        "position_main_word": []
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "B-NORP",
      "O",
      "O",
      "O",
      "B-NORP",
      "O",
      "O"
    ]
  },
  {
    "sentences": "Obama was born in Honolulu , Hawaii . After graduating from Columbia University in 1983 , he worked as a community organizer in Chicago . In 1988 , he enrolled in Harvard Law School , where he was the first black president of the Harvard Law Review . After graduating , he became a civil rights attorney and an academic , teaching constitutional law at the University of Chicago Law School from 1992 to 2004 . He represented the 13th district for three terms in the Illinois Senate from 1997 until 2004 , when he ran for the U.S. Senate . He received national attention in 2004 with his March primary win , his well - received July Democratic National Convention keynote address , and his landslide November election to the Senate . In 2008 , he was nominated for president a year after his campaign began , after a close primary campaign against Hillary Clinton . He was elected over Republican John McCain and was inaugurated on January 20 , 2009 . Nine months later , he was named the 2009 Nobel Peace Prize laureate .",
    "elements": [
      {
        "positions": [
          [
            0,
            0
          ],
          [
            16,
            16
          ],
          [
            28,
            28
          ],
          [
            36,
            36
          ],
          [
            51,
            51
          ],
          [
            76,
            76
          ],
          [
            94,
            94
          ],
          [
            101,
            101
          ],
          [
            108,
            108
          ],
          [
            113,
            113
          ],
          [
            125,
            125
          ],
          [
            136,
            136
          ],
          [
            144,
            144
          ],
          [
            157,
            157
          ],
          [
            177,
            177
          ]
        ],
        "sequences": [
          [
            "Obama"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "he"
          ],
          [
            "He"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "his"
          ],
          [
            "he"
          ],
          [
            "his"
          ],
          [
            "He"
          ],
          [
            "he"
          ]
        ],
        "ner_sequences": [
          [
            "B-PERSON"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ],
          [
            "O"
          ]
        ],
        "flags": 0,
        "main_words": [
          "Obama"
        ],
        "ner_tags": [
          "PERSON"
        ],
        "position_main_word": [
          [
            0,
            0
          ]
        ]
      },
      {
        "positions": [
          [
            74,
            74
          ],
          [
            91,
            91
          ],
          [
            106,
            106
          ],
          [
            134,
            134
          ],
          [
            171,
            171
          ]
        ],
        "sequences": [
          [
            "2004"
          ],
          [
            "2004"
          ],
          [
            "2004"
          ],
          [
            "2008"
          ],
          [
            "2009"
          ]
        ],
        "ner_sequences": [
          [
            "I-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "B-DATE"
          ],
          [
            "I-DATE"
          ]
        ],
        "flags": -1,
        "main_words": [],
        "ner_tags": [],
        "position_main_word": []
      },
      {
        "main_words": "the Illinois Senate",
        "ner_tags": "ORG",
        "position_main_word": [
          [
            85,
            87
          ]
        ],
        "positions": [
          [
            85,
            87
          ]
        ],
        "sequences": [
          [
            "the",
            "Illinois",
            "Senate"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ]
        ],
        "flags": 1
      },
      {
        "main_words": "the U.S. Senate",
        "ner_tags": "ORG",
        "position_main_word": [
          [
            97,
            99
          ]
        ],
        "positions": [
          [
            97,
            99
          ],
          [
            130,
            131
          ]
        ],
        "sequences": [
          [
            "the",
            "U.S.",
            "Senate"
          ],
          [
            "the",
            "Senate"
          ]
        ],
        "ner_sequences": [
          [
            "B-ORG",
            "I-ORG",
            "I-ORG"
          ],
          [
            "O",
            "B-ORG"
          ]
        ],
        "flags": 1
      }
    ],
    "all_ner_tags": [
      "B-PERSON",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "B-GPE",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-GPE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "B-ORDINAL",
      "O",
      "O",
      "B-CARDINAL",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "B-DATE",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-ORG",
      "I-ORG",
      "I-ORG",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "B-ORG",
      "B-ORG",
      "I-EVENT",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "B-ORG",
      "O",
      "O",
      "B-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-NORP",
      "B-PERSON",
      "I-PERSON",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "B-DATE",
      "I-DATE",
      "I-DATE",
      "O",
      "O",
      "O",
      "O",
      "O",
      "B-DATE",
      "B-WORK_OF_ART",
      "I-WORK_OF_ART",
      "I-WORK_OF_ART",
      "O",
      "O"
    ]
  }
]

export const display = [
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          8,
          17
        ],
        "namedEntity": "Ah - sheng"
      }
    ],
    "id": 0,
    "label_seq": "O O B-PERSON I-PERSON I-PERSON O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "RB , NNP HYPH NNP VBZ DT JJ NN TO VB IN NNS CC VBZ IN VBG DT NN NN IN PRP VBZ DT JJ NN IN DT NN IN NN POS NN CC NN , VBG `` DT JJ NN NN IN PRP$ NNS IN NN . ''",
    "text": "There , Ah - sheng demonstrates a startling ability to respond to circumstances and succeeds in wrecking the meeting hall as he makes an eloquent speech on the love of one 's family and birthplace , making \" the entire village jump to its feet in agitation . \""
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          7,
          17
        ],
        "namedEntity": "Al - Waleed"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          48,
          59
        ],
        "namedEntity": "five billion"
      },
      {
        "entity_type": "GPE",
        "index": [
          116,
          121
        ],
        "namedEntity": "Riyadh"
      },
      {
        "entity_type": "DATE",
        "index": [
          157,
          203
        ],
        "namedEntity": "the first quarter of the current financial year"
      },
      {
        "entity_type": "GPE",
        "index": [
          215,
          220
        ],
        "namedEntity": "Jeddah"
      },
      {
        "entity_type": "DATE",
        "index": [
          253,
          287
        ],
        "namedEntity": "at the beginning of the coming year"
      },
      {
        "entity_type": "QUANTITY",
        "index": [
          316,
          340
        ],
        "namedEntity": "165 million square meters"
      },
      {
        "entity_type": "ORG",
        "index": [
          381,
          407
        ],
        "namedEntity": "the Kingdom Holding Company"
      },
      {
        "entity_type": "GPE",
        "index": [
          412,
          417
        ],
        "namedEntity": "Riyadh"
      },
      {
        "entity_type": "QUANTITY",
        "index": [
          439,
          462
        ],
        "namedEntity": "53 million square meters"
      },
      {
        "entity_type": "GPE",
        "index": [
          467,
          472
        ],
        "namedEntity": "Jeddah"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          505,
          507
        ],
        "namedEntity": "two"
      }
    ],
    "id": 1,
    "label_seq": "O B-PERSON I-PERSON I-PERSON O O O O B-CARDINAL I-CARDINAL O O O O O O O O O B-GPE O O O O O O B-DATE I-DATE I-DATE I-DATE I-DATE I-DATE I-DATE I-DATE O O O B-GPE O O O O O B-DATE I-DATE I-DATE I-DATE I-DATE I-DATE I-DATE O O O O O B-QUANTITY I-QUANTITY I-QUANTITY I-QUANTITY O O O O O O O B-ORG I-ORG I-ORG I-ORG O B-GPE O O O O B-QUANTITY I-QUANTITY I-QUANTITY I-QUANTITY O B-GPE O O O O O B-CARDINAL O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP NNP HYPH NNP VBD IN DT VBG CD CD VBD VBN IN DT NN NN WDT VBD DT NNP NN WDT MD VB VBN IN DT JJ NN IN DT JJ JJ NN , CC DT NNP NN WDT MD VB VBN IN DT NN IN DT VBG NN VBG IN DT NN IN CD CD JJ NNS IN NN VBD RB VBN VBN IN DT NNP NNP NNP IN NNP CC DT NN IN CD CD JJ NNS IN NNP IN DT NN IN DT CD NNS . CC DT NN VBN TO VB DT NN NNS IN DT NN IN NNS RB VBN IN DT NN NN .",
    "text": "Prince Al - Waleed explained that the remaining five billion were invested in the property sector that included the Riyadh project which will be launched in the first quarter of the current financial year , and the Jeddah project which will be launched at the beginning of the coming year indicating that an area of 165 million square meters of land had actually been purchased by the Kingdom Holding Company in Riyadh and another area of 53 million square meters in Jeddah for the establishment of these two projects . and a study undertaken to turn these property companies in the future into ones publicly listed on the share market ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          139,
          155
        ],
        "namedEntity": "Charles Manson 's"
      },
      {
        "entity_type": "DATE",
        "index": [
          170,
          186
        ],
        "namedEntity": "the last 19 years"
      }
    ],
    "id": 2,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O B-PERSON I-PERSON I-PERSON O O B-DATE I-DATE I-DATE I-DATE O O O O O",
    "pos_seq": "'' '' PRP VBD : DT NN : DT NN IN NN PRP MD VB VBG JJ PRP$ NN NN : CC DT NN WP VBD PRP VBD VBN NNP NNP POS NN IN DT JJ CD NNS , '' PRP VBD",
    "text": "`` I thought -LCB- the drawing -RCB- a cross between someone you 'd spot whipping open his trench coat ... or a guy who boasted he 'd been Charles Manson 's roommate for the last 19 years , '' he said ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          18,
          26
        ],
        "namedEntity": "Ci Suo 's"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          69,
          69
        ],
        "namedEntity": "5"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          130,
          132
        ],
        "namedEntity": "two"
      }
    ],
    "id": 3,
    "label_seq": "O O O B-PERSON I-PERSON I-PERSON O O O O O O O O B-CARDINAL O O O O O O O O O O O B-CARDINAL O O O O O O O O O O O O O O",
    "pos_seq": "DT NN IN NNP NNP POS NN VBD DT NNS : DT NN IN CD JJ CC JJ NNS , PRP VBZ DT NN NN IN CD NNS IN NN RB RB IN DT NN VBN IN NN CC NN .",
    "text": "The furnishing of Ci Suo 's home astonished the visitors : a home of 5 earthen and wooden structures , it has a sitting room with two layers of glass as well as a warehouse filled with mutton and ghee ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          0,
          6
        ],
        "namedEntity": "Melanie"
      },
      {
        "entity_type": "GPE",
        "index": [
          65,
          68
        ],
        "namedEntity": "Iraq"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          107,
          109
        ],
        "namedEntity": "two"
      },
      {
        "entity_type": "LOC",
        "index": [
          224,
          237
        ],
        "namedEntity": "the green zone"
      }
    ],
    "id": 4,
    "label_seq": "B-PERSON O O O O O O O O O O O O B-GPE O O O O O O O B-CARDINAL O O O O O O O O O O O O O O O O O O O O O O B-LOC I-LOC I-LOC O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP WRB VBP PRP VB DT JJ NN IN WP VBZ VBG IN NNP IN NNS VBP PRP EX VBZ RB CD NNS TO VB RB RB IN DT NN PRP VBP PRP$ NN VBZ DT PRP CC VB RB RB CC VB IN DT JJ NN CC DT NN UH UH WDT VBZ RB JJ CC PRP VBZ RB DT NN CC PRP VBP RP IN DT NN IN UH RB NN IN DT NN DT VBN NN .",
    "text": "Melanie how do we get the straight scoop on what 's happening in Iraq because people tell me there 's only two ways to go over there as a journalist I think your experience confirms this you either go over there and stay in the green zone or that part uh uh which is very secure and it 's basically a compound or you go out with a unit as uh basically part of the unit an embedded reporter /."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "DATE",
        "index": [
          0,
          14
        ],
        "namedEntity": "Three years ago"
      },
      {
        "entity_type": "DATE",
        "index": [
          54,
          64
        ],
        "namedEntity": "space - age"
      },
      {
        "entity_type": "GPE",
        "index": [
          144,
          150
        ],
        "namedEntity": "Britain"
      },
      {
        "entity_type": "PERSON",
        "index": [
          162,
          168
        ],
        "namedEntity": "Charles"
      }
    ],
    "id": 5,
    "label_seq": "B-DATE I-DATE I-DATE O O O O O O O O B-DATE I-DATE I-DATE O O O O O O O O O O O O O O B-GPE O O B-PERSON O O O",
    "pos_seq": "CD NNS RB , DT NN VBD RP NN IN DT NN HYPH NN NN IN NN CC NN : JJ IN DT NN IN JJ NN IN NNP POS NNP NNP VBZ VBN .",
    "text": "Three years ago , the exchange took up residence in a space - age tower of steel and glass -- evocative of the kind of modern architecture that Britain 's Prince Charles has denounced ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          18,
          20
        ],
        "namedEntity": "two"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          46,
          48
        ],
        "namedEntity": "one"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          91,
          93
        ],
        "namedEntity": "two"
      },
      {
        "entity_type": "DATE",
        "index": [
          114,
          119
        ],
        "namedEntity": "age 45"
      }
    ],
    "id": 6,
    "label_seq": "O O O B-CARDINAL O O O B-CARDINAL O O O O O O O O B-CARDINAL O O O O B-DATE I-DATE O O O O O O O O O O O O",
    "pos_seq": "DT NNS IN CD JJ NNS , CD DT NN IN NN NN CC DT DT CD HYPH NN NN IN NN CD , VB JJ NNS IN NN IN NNS VBP TO VB .",
    "text": "The portfolios of two hypothetical families , one a couple at retirement age and another a two - income couple at age 45 , illustrate several types of risk that investors need to consider ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          44,
          48
        ],
        "namedEntity": "Lazio"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          54,
          55
        ],
        "namedEntity": "91"
      },
      {
        "entity_type": "PERSON",
        "index": [
          113,
          120
        ],
        "namedEntity": "Moynihan"
      },
      {
        "entity_type": "PERCENT",
        "index": [
          191,
          194
        ],
        "namedEntity": "68 %"
      },
      {
        "entity_type": "PERCENT",
        "index": [
          211,
          214
        ],
        "namedEntity": "69 %"
      }
    ],
    "id": 7,
    "label_seq": "O O O O O O O O B-PERSON O B-CARDINAL O O O O O O O O O O O O B-PERSON O O O O O O O O O O O O O B-PERCENT I-PERCENT O O O O B-PERCENT I-PERCENT O O O O",
    "pos_seq": "IN DT WP VBP IN PRP$ NN , NNP VBD CD , CC PRP VBZ RB DT JJ NN IN NN IN DT NNP NNS PRP '' RB VBN JJ IN WRB DT NN VBD MD PRP VB CD NN IN DT NN CC CD NN IN DT NN",
    "text": "Among those who disapprove of her husband , Lazio won 91 , and it 's certainly a different kind of race from the Moynihan races we 've grown accustomed to where the question was would he get 68 % of the vote or 69 % of the vote ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          81,
          102
        ],
        "namedEntity": "Bristol - Myers Squibb"
      },
      {
        "entity_type": "GPE",
        "index": [
          185,
          192
        ],
        "namedEntity": "Shanghai"
      },
      {
        "entity_type": "GPE",
        "index": [
          293,
          300
        ],
        "namedEntity": "Shanghai"
      },
      {
        "entity_type": "NORP",
        "index": [
          313,
          319
        ],
        "namedEntity": "Chinese"
      },
      {
        "entity_type": "LOC",
        "index": [
          330,
          350
        ],
        "namedEntity": "Asia - Pacific region"
      }
    ],
    "id": 8,
    "label_seq": "O O O O O O O O O O O O O O O O B-ORG I-ORG I-ORG I-ORG O O O O O O O O O O O O O B-GPE O O O O O O O O O O O O O O O O O B-GPE O O B-NORP O O B-LOC I-LOC I-LOC I-LOC O O O O O",
    "pos_seq": "IN DT NN IN `` VBG DT NNS '' , JJR CC JJR JJ NNS IN NNP HYPH NNP NNP VBP VBN TO VB RB IN DT NN NN CC NN NN IN NNP , CC VB CD IN DT , VBN NNS TO VB NN , CC MD RB VB NNP IN PRP$ JJ CC RB NNP HYPH NNP NN JJ CC NNS NN .",
    "text": "After a period of \" testing the waters \" , more and more foreign businesses like Bristol - Myers Squibb have begun to think highly of the investment environment and market potential in Shanghai , and have one after another , added investments to expand reproduction , and will gradually build Shanghai into their Chinese and even Asia - Pacific region operational and sales center ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "TIME",
        "index": [
          11,
          31
        ],
        "namedEntity": "an unpleasant evening"
      },
      {
        "entity_type": "PERSON",
        "index": [
          122,
          128
        ],
        "namedEntity": "Douglas"
      },
      {
        "entity_type": "PERSON",
        "index": [
          173,
          181
        ],
        "namedEntity": "Stoltzman"
      }
    ],
    "id": 9,
    "label_seq": "O O O B-TIME I-TIME I-TIME O O O O O O O O O O O O O O O O B-PERSON O O O O O O O O B-PERSON O O O O",
    "pos_seq": "PRP VBD RB DT JJ NN , RB , NNS IN DT JJ NN IN NN , DT JJ NNS IN NNP NNP , CC DT JJ NN IN WDT NNP NNP VBZ PRP$ NNS .",
    "text": "It was not an unpleasant evening , certainly , thanks to the high level of performance , the compositional talents of Mr. Douglas , and the obvious sincerity with which Mr. Stoltzman chooses his selections ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "GPE",
        "index": [
          118,
          122
        ],
        "namedEntity": "Wenbu"
      },
      {
        "entity_type": "NORP",
        "index": [
          212,
          218
        ],
        "namedEntity": "Tibetan"
      }
    ],
    "id": 10,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O B-GPE O O O O O O O O O O O O O O O B-NORP O O O O O O O",
    "pos_seq": "DT NN NN VBD IN NN , IN DT `` JJ NN '' IN DT NNS VBZ DT `` NN IN JJ NN '' , RB NNP NNS MD VB VBN DT `` NN IN NN '' WRB DT JJ NN IN JJ NNS VBP JJ NNS IN NN .",
    "text": "A county head said with emotion , if the \" western heaven \" in the legends is a \" world of extreme happiness \" , then Wenbu grasslands should be called the \" garden of happiness \" where the current generation of Tibetan herdsmen live new lives under socialism ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          0,
          6
        ],
        "namedEntity": "Abather"
      },
      {
        "entity_type": "NORP",
        "index": [
          15,
          18
        ],
        "namedEntity": "U.S."
      },
      {
        "entity_type": "GPE",
        "index": [
          171,
          174
        ],
        "namedEntity": "Iraq"
      }
    ],
    "id": 11,
    "label_seq": "B-PERSON O B-NORP O O O O O O O O O O O O O O O O O O O O O O O O O O O O B-GPE O O O O O O O O O",
    "pos_seq": "NNP VBD NNP '' '' NN '' NNS , JJ IN DT NN TO VB DT VBG NN IN PRP$ NN , CC PRP RB VBD RP IN DT JJ HYPH NN NNP NNS WDT RB VBD JJ IN DT NNS",
    "text": "Abather joined U.S. `` democratization '' efforts , such as a project to create a governing council for his neighborhood , and he occasionally ended up in the good - news Iraq stories that still seemed plausible in those days ;"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          17,
          27
        ],
        "namedEntity": "Hua Guofeng"
      },
      {
        "entity_type": "ORG",
        "index": [
          46,
          75
        ],
        "namedEntity": "the Party Central Committee 's"
      },
      {
        "entity_type": "ORG",
        "index": [
          77,
          89
        ],
        "namedEntity": "State Council"
      },
      {
        "entity_type": "ORG",
        "index": [
          235,
          261
        ],
        "namedEntity": "the Party Central Committee"
      },
      {
        "entity_type": "PERSON",
        "index": [
          284,
          286
        ],
        "namedEntity": "Mao"
      }
    ],
    "id": 12,
    "label_seq": "O O O O B-PERSON I-PERSON O O O O O B-ORG I-ORG I-ORG I-ORG I-ORG B-ORG I-ORG O O O O O O O O O O O O O O O O O O O O O O O O B-ORG I-ORG I-ORG I-ORG O O O B-PERSON O",
    "pos_seq": "PRP VBD , CC NNP NNP RB VBD , UH , DT NNP NNP NNP POS NNP NNP VBZ RB VB PRP NNS IN NN NN JJ , PRP VBP PRP MD VB TO VB PRP$ NN CC NN NN TO VB DT NNP NNP NNP CC VB NNP NNP .",
    "text": "I finished , and Hua Guofeng then said , uh , the Party Central Committee 's State Council does not hold you comrades in earthquake industry responsible , we hope you will continue to do your monitoring and forecasting work to protect the Party Central Committee and protect Chairman Mao ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORDINAL",
        "index": [
          0,
          5
        ],
        "namedEntity": "Fourth"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          201,
          208
        ],
        "namedEntity": "millions"
      }
    ],
    "id": 13,
    "label_seq": "B-ORDINAL O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O B-CARDINAL O",
    "pos_seq": "RB , VB JJ NN IN DT NNS , VB NN VBG NNS IN NNS , IN NNS , IN NNS , IN NN NNS , IN JJ NNS , CC IN DT NNS IN NNS .",
    "text": "Fourth , promote philatelic culture on all fronts , bring stamp collecting events into schools , into villages , into factories , into army bases , into residential communities , and into the homes of millions ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          62,
          76
        ],
        "namedEntity": "more than 3,000"
      }
    ],
    "id": 14,
    "label_seq": "O O O O O O O O O O O O O B-CARDINAL I-CARDINAL I-CARDINAL O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP , VBD DT `` NN IN JJ NN '' , CC IN JJR IN CD NNS IN NN , PRP VBZ DT NN RB VBN TO VB NN HYPH NN , NN , NN CC JJ NN CC NN .",
    "text": "Nickel , called the \" vitamin of modern industry \" , and with more than 3,000 varieties of alloy , it is the material specially required to develop space - flight , aviation , military and modern science and technology ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "LAW",
        "index": [
          0,
          22
        ],
        "namedEntity": "The coastal defense law"
      },
      {
        "entity_type": "LAW",
        "index": [
          28,
          69
        ],
        "namedEntity": "the organic law of the Coast Guard Command"
      },
      {
        "entity_type": "ORG",
        "index": [
          93,
          107
        ],
        "namedEntity": "the Coast Guard"
      }
    ],
    "id": 15,
    "label_seq": "B-LAW I-LAW I-LAW I-LAW O B-LAW I-LAW I-LAW I-LAW I-LAW I-LAW I-LAW I-LAW O O O O B-ORG I-ORG I-ORG O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT JJ NN NN CC DT JJ NN IN DT NNP NNP NNP : DT MD VB DT NNP NNP IN DT JJ NN NN , JJ IN JJ NN CC IN VBG NN CC JJ NN .",
    "text": "The coastal defense law and the organic law of the Coast Guard Command : This will establish the Coast Guard as a ministerial level body , responsible for coastal defense and for combating smuggling and illegal immigration ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          97,
          108
        ],
        "namedEntity": "Rick Sanchez"
      },
      {
        "entity_type": "PERSON",
        "index": [
          121,
          124
        ],
        "namedEntity": "Andy"
      }
    ],
    "id": 16,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O B-PERSON I-PERSON O O O B-PERSON O O O O O O O O O",
    "pos_seq": "IN PRP$ NN VBZ JJ WRB VBP RB PRP VBG CD IN PRP$ JJ NNS RB RB TO VB IN NNP NNP TO VB IN NNP CC VB VB , DT VBZ DT JJ ,",
    "text": "If their message is right why are n't they putting one of their big kahunas out there to talk to Rick Sanchez to talk to Andy and say look , this is all wrong /?"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          15,
          17
        ],
        "namedEntity": "two"
      },
      {
        "entity_type": "ORG",
        "index": [
          19,
          23
        ],
        "namedEntity": "Party"
      },
      {
        "entity_type": "PERSON",
        "index": [
          39,
          44
        ],
        "namedEntity": "Gao XX"
      },
      {
        "entity_type": "GPE",
        "index": [
          92,
          99
        ],
        "namedEntity": "Shandong"
      },
      {
        "entity_type": "GPE",
        "index": [
          101,
          105
        ],
        "namedEntity": "Linyi"
      },
      {
        "entity_type": "GPE",
        "index": [
          207,
          214
        ],
        "namedEntity": "Shandong"
      },
      {
        "entity_type": "ORG",
        "index": [
          280,
          318
        ],
        "namedEntity": "Shandong Luneng Stock Controlling Group"
      },
      {
        "entity_type": "ORG",
        "index": [
          349,
          354
        ],
        "namedEntity": "Luneng"
      },
      {
        "entity_type": "ORG",
        "index": [
          415,
          426
        ],
        "namedEntity": "Luneng Group"
      },
      {
        "entity_type": "PERSON",
        "index": [
          430,
          433
        ],
        "namedEntity": "Xu X"
      },
      {
        "entity_type": "GPE",
        "index": [
          490,
          494
        ],
        "namedEntity": "Linyi"
      },
      {
        "entity_type": "GPE",
        "index": [
          498,
          505
        ],
        "namedEntity": "Shandong"
      },
      {
        "entity_type": "DATE",
        "index": [
          512,
          521
        ],
        "namedEntity": "about 2003"
      },
      {
        "entity_type": "ORG",
        "index": [
          560,
          571
        ],
        "namedEntity": "Luneng Group"
      },
      {
        "entity_type": "ORG",
        "index": [
          693,
          704
        ],
        "namedEntity": "Luneng Group"
      },
      {
        "entity_type": "ORG",
        "index": [
          772,
          783
        ],
        "namedEntity": "Luneng Group"
      },
      {
        "entity_type": "ORG",
        "index": [
          830,
          834
        ],
        "namedEntity": "party"
      },
      {
        "entity_type": "ORG",
        "index": [
          946,
          948
        ],
        "namedEntity": "CPC"
      },
      {
        "entity_type": "ORG",
        "index": [
          966,
          970
        ],
        "namedEntity": "Party"
      }
    ],
    "id": 17,
    "label_seq": "O O O O B-CARDINAL B-ORG O O B-PERSON I-PERSON O O O O O O O O B-GPE B-GPE O O O O O O O O O O O O O O O O O B-GPE O O O O O O O O O O B-ORG I-ORG I-ORG I-ORG I-ORG O O O O O O B-ORG O O O O O O O O O O O B-ORG I-ORG O B-PERSON I-PERSON O O O O O O O O O O B-GPE O B-GPE O O B-DATE I-DATE O O O O O O B-ORG I-ORG O O O O O O O O O O O O O O O O O O O O B-ORG I-ORG O O O O O O O O O O O O O B-ORG I-ORG O O O O O O O O B-ORG O O O O O O O O O O O O O O O O O B-ORG O O O B-ORG O O O O",
    "pos_seq": "RB , VBD DT CD NNP NNS NNP NNP NNP RB VBD DT NNS IN NN IN DT NNP NNP JJ NN , NN NN IN DT JJ NN NN , NN IN DT NN IN DT NNP NN NN , CC JJ NN CC NN NN IN NNP NNP NNP NNP NNP . VBG VBN IN DT IN NNP POS NN NNS , PRP VBZ RB RB DT NN IN NNP NNP . NNP NNP VBZ VBN IN NN IN DT JJ NN NN IN NNP , NNP . IN IN CD PRP RB VBD DT NN IN NNP NNP IN NN NN VBN TO VB NN NNS , IN WDT PRP VBD RB RB VBN IN DT NN IN NNP NNP NNP , IN DT NN IN DT NN IN JJ NN NNS IN NNP NNP , VB RP DT JJ NNS WDT DT NN NNS MD VB VBG NN HYPH VBN NNS CC DT JJ NN IN JJ NN IN DT NNP NNP CC DT NNP POS JJ NN .",
    "text": "So , did these two Party members -LRB- Gao XX previously held the positions of chief of the Shandong Linyi administrative office , deputy head of the electrical utility bureau , assistant to the head of the Shandong electricity bureau , and general manager and party secretary of Shandong Luneng Stock Controlling Group . Having gone through all of Luneng 's stock transfers , he is still currently the chairman of Luneng Group . Xu X has served as head of the electrical utility bureau of Linyi , Shandong . In about 2003 he first entered the headquarters of Luneng Group as vice president assigned to manage property operations , after which he was very quickly promoted to the president of Luneng Group -RRB- , in the process of the series of mysterious stock deals at Luneng Group , carry out the unshirkable duties which the party members should undertake regarding state - owned assets and the public interest in strict accordance with the CPC Charter and the Party 's strict discipline ?"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          88,
          90
        ],
        "namedEntity": "one"
      },
      {
        "entity_type": "ORG",
        "index": [
          183,
          194
        ],
        "namedEntity": "Al - Jazirah"
      },
      {
        "entity_type": "ORG",
        "index": [
          255,
          264
        ],
        "namedEntity": "Al - Watan"
      },
      {
        "entity_type": "ORG",
        "index": [
          269,
          279
        ],
        "namedEntity": "Al - Riyadh"
      },
      {
        "entity_type": "ORG",
        "index": [
          520,
          530
        ],
        "namedEntity": "Al - Riyadh"
      }
    ],
    "id": 18,
    "label_seq": "O O O O O O O O O O O O O O O O B-CARDINAL O O O O O O O O O O O O O O O O O B-ORG I-ORG I-ORG O O O O O O O O O O O O B-ORG I-ORG I-ORG O B-ORG I-ORG I-ORG O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O B-ORG I-ORG I-ORG O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN PRP VBP IN VBG DT NNS VBN IN NNS , NNS , CC NNS VBZ CD NN TO VB PRP TO VB DT NN , CC IN DT NNS VBD IN DT NN NNP HYPH NNP , PRP VBP IN IN PRP VBD VBN VBN IN DT NN NNP HYPH NNP CC NNP HYPH NNP PRP MD VB VBN DT NN IN VBG VBN IN DT NN IN PRP VBP VBN IN PRP$ NN IN DT JJ CC PRP VBP RB VB NN WRB VBG CC PRP VBP RB VB DT NNS . IN PRP VBD IN DT NN NNP HYPH NNP WRB PRP VBD CC VBD DT NN IN NNS VBG IN PRP VBD DT JJ NN IN DT VBN .",
    "text": "Since I think that publishing the statements made by athletes , actors , and singers is one way to help us to serve this cause , and since these interviews came through the newspaper Al - Jazirah , I think that if they had been published by the newspaper Al - Watan or Al - Riyadh they would have stopped this question from being asked to the guest because they are known for their banning of the other and they do not know neutrality when exposing and they do not like these answers . As it happened with the newspaper Al - Riyadh when it halted and concealed the poll on women driving as it saw the overwhelming victory of those opposed ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          86,
          99
        ],
        "namedEntity": "William Thomas"
      },
      {
        "entity_type": "ORG",
        "index": [
          105,
          123
        ],
        "namedEntity": "Texas Commerce Bank"
      },
      {
        "entity_type": "GPE",
        "index": [
          137,
          143
        ],
        "namedEntity": "Houston"
      }
    ],
    "id": 19,
    "label_seq": "O O O O O O O O O O O O O O O O O B-PERSON I-PERSON O O B-ORG I-ORG I-ORG O O B-GPE O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN '' '' PRP VBZ RB JJ TO VB NN IN DT JJ NN NN , '' VBZ NNP NNP , DT NNP NNP NNP NN IN NNP , '' '' NNS VBP VBG TO VB EX VBP NNS IN DT NNS , CC DT NN VBZ VBG TO VB",
    "text": "Although `` it 's still difficult to raise money for a pure wildcat program , '' says William Thomas , a Texas Commerce Bank official in Houston , `` institutions are starting to see there are cycles to these things , and this one is beginning to turn . ''"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORDINAL",
        "index": [
          0,
          4
        ],
        "namedEntity": "First"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          89,
          91
        ],
        "namedEntity": "one"
      }
    ],
    "id": 20,
    "label_seq": "B-ORDINAL O O O O O O O O O O O O O O O O O B-CARDINAL O O O O O O O O O O O O",
    "pos_seq": "RB IN DT PRP VBP TO VB JJ EX VBP DT JJ NNS IN DT NN , IN CD NN IN DT JJ NNS IN DT NNS MD VB JJ .",
    "text": "First of all they have to make sure there are no jagged edges around this hole , because one tear of the protective suits of the divers could prove fatal ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "GPE",
        "index": [
          16,
          23
        ],
        "namedEntity": "New York"
      },
      {
        "entity_type": "ORG",
        "index": [
          61,
          70
        ],
        "namedEntity": "Bond Buyer"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          72,
          73
        ],
        "namedEntity": "20"
      },
      {
        "entity_type": "PERCENT",
        "index": [
          186,
          191
        ],
        "namedEntity": "7.19 %"
      },
      {
        "entity_type": "DATE",
        "index": [
          196,
          217
        ],
        "namedEntity": "the week ended Oct. 19"
      }
    ],
    "id": 21,
    "label_seq": "O O O O B-GPE I-GPE O O O O O O B-ORG I-ORG B-CARDINAL O O O O O O O O O O O O O O O O O O O O O B-PERCENT I-PERCENT O B-DATE I-DATE I-DATE I-DATE I-DATE O",
    "pos_seq": "IN DT NN IN NNP NNP JJ NN NNS VBD , DT NNP NNP CD HYPH NN JJ NN NN , DT RB RB VBN NN IN DT NN HYPH JJ NN , VBD JJ IN CD NN IN DT NN VBN NNP CD .",
    "text": "As the yield on New York general obligation bonds rose , the Bond Buyer 20 - bond general obligation index , the mostly widely followed gauge of the tax - exempt market , held steady at 7.19 % in the week ended Oct. 19 ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          79,
          81
        ],
        "namedEntity": "two"
      }
    ],
    "id": 22,
    "label_seq": "O O O O O O O O O O O O O B-CARDINAL O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN PRP VBP DT JJ NN WDT VBZ RB VB VBG IN DT CD NNS , NNS CC NN IN PRP VBD IN DT NN : RB DT NN IN DT NN NN : IN IN NN IN JJ JJ JJ NNS MD",
    "text": "Because we are a conservative nation that does not accept mingling between the two sexes , women and everyone like them were in another grandstand -- not the one for the cheerleader group -- so that nothing with non-praiseworthy consequences might occur !!"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          7,
          11
        ],
        "namedEntity": "Kaine"
      }
    ],
    "id": 23,
    "label_seq": "O O B-PERSON O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN DT NNP NN VBZ TO VB NN CC NN NN NN , DT JJ NN TO VB MD VB IN NNS , IN DT NN , WDT NN IN DT NN PRP .",
    "text": "If the Kaine administration wants to align transportation and land use planning , a good place to start would be with projects , like this one , that emanate from the administration itself ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "GPE",
        "index": [
          0,
          4
        ],
        "namedEntity": "Qatar"
      },
      {
        "entity_type": "PERSON",
        "index": [
          23,
          34
        ],
        "namedEntity": "Shimon Peres"
      },
      {
        "entity_type": "NORP",
        "index": [
          162,
          167
        ],
        "namedEntity": "Qatari"
      },
      {
        "entity_type": "NORP",
        "index": [
          198,
          201
        ],
        "namedEntity": "Arab"
      }
    ],
    "id": 24,
    "label_seq": "B-GPE O O O B-PERSON I-PERSON O O O O O O O O O O O O O O O O O O O O O O O B-NORP O O O O O B-NORP O O O O O O O O O O O O",
    "pos_seq": "NNP POS NN IN NNP NNP VBD IN DT NN NFP VBG DT NN CC NN TO VB DT NN IN JJ VBG NNS CC RB TO VB DT JJ NN IN JJ CC DT JJ NN IN JJ VB WP VBZ NN IN DT JJ NN .",
    "text": "Qatar 's reception for Shimon Peres came from this angle .. addressing the mind and conversing to create a solution for many pending matters and also to make the Qatari public in particular and the Arab public in general understand what takes place in a democratic atmosphere .."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          4,
          12
        ],
        "namedEntity": "Foothills"
      },
      {
        "entity_type": "GPE",
        "index": [
          153,
          158
        ],
        "namedEntity": "Alaska"
      }
    ],
    "id": 25,
    "label_seq": "O B-ORG O O O O O O O O O O O O O O O O O O O O O O B-GPE O",
    "pos_seq": "CC NNP VBD PRP VBZ TO VB JJ NN TO VB DT JJ NN , DT NNP NNP NNP NNP NNP RBR RB IN NNP .",
    "text": "But Foothills said it plans to seek regulatory approval to build an alternative line , the Alaska Natural Gas Transportation System further north toward Alaska ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          0,
          12
        ],
        "namedEntity": "Philip Morris"
      },
      {
        "entity_type": "GPE",
        "index": [
          33,
          36
        ],
        "namedEntity": "U.S."
      },
      {
        "entity_type": "DATE",
        "index": [
          62,
          70
        ],
        "namedEntity": "last year"
      },
      {
        "entity_type": "MONEY",
        "index": [
          81,
          94
        ],
        "namedEntity": "$ 12.9 billion"
      },
      {
        "entity_type": "ORG",
        "index": [
          111,
          120
        ],
        "namedEntity": "Kraft Inc."
      },
      {
        "entity_type": "ORG",
        "index": [
          171,
          178
        ],
        "namedEntity": "Marlboro"
      }
    ],
    "id": 26,
    "label_seq": "B-ORG I-ORG O O O O B-GPE O O O O B-DATE I-DATE O O B-MONEY I-MONEY I-MONEY O O B-ORG I-ORG O O O O O O O O O B-ORG O O",
    "pos_seq": "NNP NNP , WDT VBD DT NNP POS JJS NN NN JJ NN IN PRP$ $ CD CD NN IN NNP NNP , VBZ JJ TO VB IN PRP$ NNS IN NNP NN .",
    "text": "Philip Morris , which became the U.S. 's largest food company last year with its $ 12.9 billion acquisition of Kraft Inc. , seems determined to evolve beyond its roots in Marlboro country ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          10,
          19
        ],
        "namedEntity": "Zhou Enlai"
      },
      {
        "entity_type": "PERSON",
        "index": [
          79,
          88
        ],
        "namedEntity": "Mao Zedong"
      },
      {
        "entity_type": "PERSON",
        "index": [
          188,
          197
        ],
        "namedEntity": "Mao Zedong"
      }
    ],
    "id": 27,
    "label_seq": "O O O B-PERSON I-PERSON O O O O O O O O O O O B-PERSON I-PERSON O O O O O O O O O O O O O O O O O O B-PERSON I-PERSON O O O O O O O O O O O O O O O",
    "pos_seq": "IN NN , NNP NNP RB VBD CC VBD DT `` NNP IN NNPS '' IN NNP NNP NNP , CC RB VBD CC VBD DT NN IN `` DT NNP IN NNP NNP '' IN NNP NNP NNP WDT VBZ IN `` NNS , RB NNS '' IN VBG JJ NN .",
    "text": "In fact , Zhou Enlai best understood and mastered the \" Concept on People \" of Mao Zedong Thought , and best understood and mastered the concept of \" The Development of Human Society \" of Mao Zedong Thought that focuses on \" events , not people \" in transforming human society ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PRODUCT",
        "index": [
          3,
          9
        ],
        "namedEntity": "Galileo"
      },
      {
        "entity_type": "PRODUCT",
        "index": [
          105,
          112
        ],
        "namedEntity": "Atlantis"
      },
      {
        "entity_type": "PERSON",
        "index": [
          124,
          138
        ],
        "namedEntity": "Donald Williams"
      }
    ],
    "id": 28,
    "label_seq": "O B-PRODUCT O O O O O O O O O O O O O O O O O O O O B-PRODUCT O B-PERSON I-PERSON O O",
    "pos_seq": "'' '' NNP VBZ IN PRP$ NN IN DT NN IN DT NNS IN DT JJS NN NNS IN DT NN , '' NNP NNP NNP NNP VBD",
    "text": "`` Galileo is on its way to another world in the hands of the best flight controllers in this world , '' Atlantis Commander Donald Williams said ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          4,
          19
        ],
        "namedEntity": "Bogdan Gumkowski"
      },
      {
        "entity_type": "GPE",
        "index": [
          46,
          51
        ],
        "namedEntity": "Warsaw"
      },
      {
        "entity_type": "ORG",
        "index": [
          56,
          69
        ],
        "namedEntity": "Marriott Hotel"
      },
      {
        "entity_type": "GPE",
        "index": [
          102,
          107
        ],
        "namedEntity": "Poland"
      },
      {
        "entity_type": "MONEY",
        "index": [
          121,
          132
        ],
        "namedEntity": "$ 39 billion"
      },
      {
        "entity_type": "ORG",
        "index": [
          216,
          218
        ],
        "namedEntity": "LOT"
      },
      {
        "entity_type": "ORG",
        "index": [
          232,
          236
        ],
        "namedEntity": "Orbis"
      }
    ],
    "id": 29,
    "label_seq": "O B-PERSON I-PERSON O O O O O O B-GPE O B-ORG I-ORG O O O O O O B-GPE O O B-MONEY I-MONEY I-MONEY O O O O O O O O O O O O O O O B-ORG O O B-ORG O O O",
    "pos_seq": "CC NNP NNP , WP VBZ DT NN IN NNP POS NNP NNP , VBD DT NNS MD VB NNP NN PRP$ $ CD CD JJ NN IN VBG NNS IN DT NN NNS IN DT JJ NNS : DT NNP NN CC NNP NN NN .",
    "text": "But Bogdan Gumkowski , who runs the casino at Warsaw 's Marriott Hotel , said the ventures would help Poland service its $ 39 billion foreign debt by pouring dollars into the state firms in the joint ventures -- the LOT airline and Orbis tourist organization ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          87,
          94
        ],
        "namedEntity": "billions"
      }
    ],
    "id": 30,
    "label_seq": "O O O O O O O O O O O O O O O O B-CARDINAL O O O O O O O O O O O O O O",
    "pos_seq": "JJ JJR NN NNS VBP RB NN NNS , WP VBP , VBP , CC VB NNS IN NNS , VBG PRP IN JJ , JJ CC JJ NN NNS .",
    "text": "Many larger egg producers are also egg processors , who crack , inspect , and sanitize billions of eggs , turning them into powdered , liquified or frozen egg products ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "GPE",
        "index": [
          20,
          27
        ],
        "namedEntity": "Shihkang"
      },
      {
        "entity_type": "ORG",
        "index": [
          68,
          71
        ],
        "namedEntity": "TCAC"
      }
    ],
    "id": 31,
    "label_seq": "O O O O B-GPE O O O O O O O B-ORG O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN VBG RB IN NNP IN DT NN IN PRP$ NN , NNP VBD DT NN IN VBG NN NNS , VBG DT NN , CC VBG JJ NNS .",
    "text": "After zeroing in on Shihkang as the beneficiary of its assistance , TCAC wasted no time in sending relief supplies , establishing a newsletter , and building prefab shelters ."
  }
];

export const display2 = [
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "NORP",
        "index": [
          29,
          35
        ],
        "namedEntity": "Spanish"
      },
      {
        "entity_type": "ORG",
        "index": [
          47,
          55
        ],
        "namedEntity": "Rebellion"
      },
      {
        "entity_type": "NORP",
        "index": [
          97,
          98
        ],
        "namedEntity": "US"
      },
      {
        "entity_type": "ORG",
        "index": [
          100,
          115
        ],
        "namedEntity": "State Department"
      },
      {
        "entity_type": "DATE",
        "index": [
          135,
          138
        ],
        "namedEntity": "1964"
      },
      {
        "entity_type": "GPE",
        "index": [
          144,
          145
        ],
        "namedEntity": "US"
      },
      {
        "entity_type": "NORP",
        "index": [
          176,
          184
        ],
        "namedEntity": "Brazilian"
      },
      {
        "entity_type": "PERSON",
        "index": [
          265,
          271
        ],
        "namedEntity": "Goulart"
      }
    ],
    "id": 0,
    "label_seq": "O O O O O O B-NORP O B-ORG O O O O O O B-NORP B-ORG I-ORG O O O B-DATE O B-GPE O O O O B-NORP O O O O O O O O O O O B-PERSON O",
    "pos_seq": "VBG IN DT NN IN DT JJ NN NNP NN , VBN NNS IN DT NNP NNP NNP VBD IN IN CD DT NNP VBD CC VBD DT JJ NN TO VB DT JJ NN , VBG DT JJ NN NNP .",
    "text": "According to a report by the Spanish newspaper Rebellion today , declassified documents from the US State Department confirmed that in 1964 the US encouraged and supported the Brazilian military to launch a military coup , overthrowing the constitutional president Goulart ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          60,
          65
        ],
        "namedEntity": "Warner"
      },
      {
        "entity_type": "ORG",
        "index": [
          148,
          170
        ],
        "namedEntity": "the Los Angeles Dodgers"
      },
      {
        "entity_type": "ORG",
        "index": [
          215,
          238
        ],
        "namedEntity": "the San Francisco Giants"
      }
    ],
    "id": 1,
    "label_seq": "O O O O O O O O O O O O B-ORG O O O O O O O O O O O O O O O O O B-ORG I-ORG I-ORG I-ORG O O O O O O B-ORG I-ORG I-ORG I-ORG O O",
    "pos_seq": "PDT DT JJ NN MD VB '' '' JJ CC JJ , '' NNP VBD , VBG , '' '' DT NN VBZ RB JJ IN VBG IN DT NN NN IN DT NNP NNP NNP MD RB VB JJ NN IN DT NNP NNP NNPS",
    "text": "Such a dual role would be `` impractical and unethical , '' Warner said , adding , `` that concept is as silly as suggesting that the head coach of the Los Angeles Dodgers could simultaneously be general manager of the San Francisco Giants . ''"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "GPE",
        "index": [
          107,
          122
        ],
        "namedEntity": "Jiangxi province"
      },
      {
        "entity_type": "GPE",
        "index": [
          157,
          165
        ],
        "namedEntity": "Guangzhou"
      },
      {
        "entity_type": "GPE",
        "index": [
          180,
          187
        ],
        "namedEntity": "Shanghai"
      }
    ],
    "id": 2,
    "label_seq": "O O O O O O O O O O O O O O O O O O B-GPE I-GPE O O O O O O B-GPE O O O B-GPE O O O O O O O O O O O O",
    "pos_seq": "DT JJ NNS VBD IN , DT JJ NN IN JJ NNS IN NN CC NN NNS IN NNP NN VBD TO VB VBN VBN VBN IN DT NNP NN CC DT NNP NN IN DT NN IN JJ NN MD VB VBN",
    "text": "The local officials said that , the previous situation whereby large numbers of import and export goods of Jiangxi province had to be re-shipped through the Guangzhou port and the Shanghai port in the form of sparse packaging will be changed completely ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORDINAL",
        "index": [
          0,
          7
        ],
        "namedEntity": "Secondly"
      },
      {
        "entity_type": "ORG",
        "index": [
          45,
          66
        ],
        "namedEntity": "Burroughs Wellcome Co."
      },
      {
        "entity_type": "PERCENT",
        "index": [
          120,
          127
        ],
        "namedEntity": "just 1 %"
      }
    ],
    "id": 3,
    "label_seq": "B-ORDINAL O O O O O O O B-ORG I-ORG I-ORG O O O O O O O B-PERCENT I-PERCENT I-PERCENT O O O O O O O O O O O O O O O O",
    "pos_seq": "RB , NNS VBP VBN NNP POS NN NNP NNP NNP IN JJ NN IN NNS VBP IN RB CD NN IN DT JJ NN CC RB DT JJ NN IN DT JJ CC JJ NN .",
    "text": "Secondly , critics have charged AZT 's maker Burroughs Wellcome Co. with corporate inertia because children account for just 1 % of the patient population and hence a small part of the large and lucrative market ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          0,
          17
        ],
        "namedEntity": "CONTROL DATA Corp."
      },
      {
        "entity_type": "MONEY",
        "index": [
          55,
          69
        ],
        "namedEntity": "$ 154.2 million"
      },
      {
        "entity_type": "PERCENT",
        "index": [
          85,
          92
        ],
        "namedEntity": "12 3/4 %"
      },
      {
        "entity_type": "DATE",
        "index": [
          111,
          124
        ],
        "namedEntity": "June 15 , 1991"
      },
      {
        "entity_type": "DATE",
        "index": [
          166,
          171
        ],
        "namedEntity": "Dec. 8"
      }
    ],
    "id": 4,
    "label_seq": "B-ORG I-ORG I-ORG O O O O O O O B-MONEY I-MONEY I-MONEY O O O B-PERCENT I-PERCENT I-PERCENT O O O B-DATE I-DATE I-DATE I-DATE O O O O O O O O O B-DATE I-DATE O O O",
    "pos_seq": "NNP NNP NNP VBD PRP VBZ VBG TO VB DT $ CD CD NN IN PRP$ CD CD NN JJ NNS JJ NNP CD , CD , IN NN , CC VBN NN IN DT NNP CD NN NN .",
    "text": "CONTROL DATA Corp. said it is offering to purchase the $ 154.2 million amount of its 12 3/4 % senior notes due June 15 , 1991 , at par , plus accrued interest to the Dec. 8 purchase date ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          20,
          31
        ],
        "namedEntity": "Wang Ya - ke"
      },
      {
        "entity_type": "ORG",
        "index": [
          36,
          61
        ],
        "namedEntity": "National Taipei University"
      },
      {
        "entity_type": "GPE",
        "index": [
          186,
          191
        ],
        "namedEntity": "Taiwan"
      }
    ],
    "id": 5,
    "label_seq": "O O B-PERSON I-PERSON I-PERSON I-PERSON O B-ORG I-ORG I-ORG O O O O O O O O O O O O O O O O O O O O O O O B-GPE O O O O O O",
    "pos_seq": "NN NN NNP NNP HYPH NNP IN NNP NNP NNP , WP VBZ RB VBN DT JJ NN IN NN CC RB VBD DT JJ NN TO VB `` JJ NNS '' IN NNP , VBZ DT VBG NN :",
    "text": "Sociology professor Wang Ya - ke of National Taipei University , who has always been an ardent supporter of feminism and recently became the first scholar to promote \" male studies \" in Taiwan , offers the following analysis :"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          0,
          4
        ],
        "namedEntity": "Azhen"
      },
      {
        "entity_type": "GPE",
        "index": [
          24,
          35
        ],
        "namedEntity": "Asuo village"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          53,
          54
        ],
        "namedEntity": "15"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          69,
          72
        ],
        "namedEntity": "1800"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          82,
          83
        ],
        "namedEntity": "50"
      },
      {
        "entity_type": "QUANTITY",
        "index": [
          109,
          114
        ],
        "namedEntity": "750 kg"
      },
      {
        "entity_type": "QUANTITY",
        "index": [
          126,
          130
        ],
        "namedEntity": "50 kg"
      },
      {
        "entity_type": "QUANTITY",
        "index": [
          146,
          150
        ],
        "namedEntity": "25 kg"
      },
      {
        "entity_type": "MONEY",
        "index": [
          206,
          226
        ],
        "namedEntity": "more than 15,000 yuan"
      }
    ],
    "id": 6,
    "label_seq": "B-PERSON O O O O B-GPE I-GPE O O O O B-CARDINAL O O O B-CARDINAL O O B-CARDINAL O O O O O B-QUANTITY I-QUANTITY O O O B-QUANTITY I-QUANTITY O O O B-QUANTITY I-QUANTITY O O O O O O O O O O O B-MONEY I-MONEY I-MONEY I-MONEY O",
    "pos_seq": "NNP , DT NN IN NNP NN VBZ DT NN IN CD NNS , VBZ CD NNS , CD NNS , VBZ RB VBN CD NNS IN NN , CD NNS IN NN , CD NNS IN NN IN DT NN , CC RB VBZ NNS IN JJR IN CD NN .",
    "text": "Azhen , a herdsman from Asuo village has a family of 15 people , has 1800 goats , 50 yaks , has already sold 750 kg of wool , 50 kg of cashmere , 25 kg of ghee to the nation , and currently has deposits of more than 15,000 yuan ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          23,
          32
        ],
        "namedEntity": "Rothschild"
      },
      {
        "entity_type": "GPE",
        "index": [
          57,
          65
        ],
        "namedEntity": "Frankfurt"
      },
      {
        "entity_type": "NORP",
        "index": [
          134,
          139
        ],
        "namedEntity": "German"
      },
      {
        "entity_type": "PERSON",
        "index": [
          183,
          201
        ],
        "namedEntity": "David de Rothschild"
      },
      {
        "entity_type": "PERSON",
        "index": [
          205,
          208
        ],
        "namedEntity": "Elie"
      },
      {
        "entity_type": "ORG",
        "index": [
          245,
          269
        ],
        "namedEntity": "Rothschild & Cie . Banque"
      },
      {
        "entity_type": "GPE",
        "index": [
          274,
          278
        ],
        "namedEntity": "Paris"
      }
    ],
    "id": 7,
    "label_seq": "O O O O O O B-PERSON O O O O O B-GPE O O O O O O O O O O O O O O B-NORP O O O O O O O O O O B-PERSON I-PERSON I-PERSON O B-PERSON O O O O O O O B-ORG I-ORG I-ORG I-ORG I-ORG O B-GPE O",
    "pos_seq": "'' '' IN DT NN IN DT NNP NN , DT NN IN NNP VBZ DT RB JJ NN , IN PRP MD RB VB RB JJ IN JJ NN IN PRP VBZ IN PRP , '' VBZ NNP NNP FW NNP , NNP POS JJR NN CC DT NN IN NNP CC NNP . NNP IN NNP",
    "text": "`` For a member of the Rothschild family , the return to Frankfurt is a very meaningful event , although it might not mean as much to German banking as it means to us , '' says Baron David de Rothschild , Elie 's younger cousin and a partner in Rothschild & Cie . Banque in Paris ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          16,
          20
        ],
        "namedEntity": "pAsia"
      },
      {
        "entity_type": "ORDINAL",
        "index": [
          175,
          180
        ],
        "namedEntity": "second"
      }
    ],
    "id": 8,
    "label_seq": "O O O B-ORG O O O O O O O O O O O O O O O O O O O O O O O O O O O B-ORDINAL O O O O",
    "pos_seq": "DT NN IN NNP , IN NN , VBZ NNS , NN NN NNS , NN NNS , NN NN NNS , CC RB DT NN NN IN VBG NNS POS JJ HYPH NN NN .",
    "text": "The intranet at pAsia , for instance , provides chatrooms , vacation request forms , work guidelines , business travel forms , and even a bulletin board for selling workers ' second - hand stuff ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          3,
          5
        ],
        "namedEntity": "one"
      },
      {
        "entity_type": "ORG",
        "index": [
          80,
          84
        ],
        "namedEntity": "Times"
      },
      {
        "entity_type": "PERSON",
        "index": [
          91,
          95
        ],
        "namedEntity": "Baker"
      }
    ],
    "id": 9,
    "label_seq": "O B-CARDINAL O O O O O O O O O O O O B-ORG O O B-PERSON O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN CD JJ NN RB IN DT JJ NNS IN DT NN VBD DT NNP : '' '' NNP RB VBD IN EX VBD DT NNS IN DT NN WDT MD VB VBN CC VBN IN DT NN .",
    "text": "As one unidentified official clearly in the late stages of the disease told the Times : `` Baker just felt that there were some lines in the speech that could be misinterpreted and seized by the press . ''"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          122,
          126
        ],
        "namedEntity": "Negas"
      },
      {
        "entity_type": "ORG",
        "index": [
          148,
          167
        ],
        "namedEntity": "Ed Voyles Oldsmobile"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          171,
          173
        ],
        "namedEntity": "one"
      },
      {
        "entity_type": "ORDINAL",
        "index": [
          182,
          186
        ],
        "namedEntity": "first"
      }
    ],
    "id": 10,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O B-PERSON O O O O B-ORG I-ORG I-ORG O B-CARDINAL O O B-ORDINAL O O O O O O O",
    "pos_seq": "'' '' DT NN VBZ RB JJ IN DT NN POS NN IN DT NN CC DT NN VBZ RB JJ , '' VBZ NNP NNP , NN NN IN NNP NNP NNP , CD IN DT JJ NNS TO VB IN DT NN",
    "text": "`` The competition is so intense that an owner 's loyalty to a dealership or a car is virtually nonexistent , '' says Mr. Negas , vice president of Ed Voyles Oldsmobile , one of the first dealerships to locate on the strip ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          25,
          33
        ],
        "namedEntity": "6 million"
      },
      {
        "entity_type": "GPE",
        "index": [
          37,
          42
        ],
        "namedEntity": "Jordan"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          130,
          136
        ],
        "namedEntity": "million"
      },
      {
        "entity_type": "NORP",
        "index": [
          138,
          149
        ],
        "namedEntity": "Palestinians"
      },
      {
        "entity_type": "GPE",
        "index": [
          160,
          165
        ],
        "namedEntity": "Israel"
      },
      {
        "entity_type": "DATE",
        "index": [
          170,
          173
        ],
        "namedEntity": "1948"
      }
    ],
    "id": 11,
    "label_seq": "O O O O O B-CARDINAL I-CARDINAL O B-GPE O O O O O O O O O O O O O O O O B-CARDINAL B-NORP O O B-GPE O B-DATE O O O O O O O O O O O",
    "pos_seq": "LS DT NN IN RB CD CD , NNP VBZ RB VBN DT NN POS JJS NN NN IN NN , VBG JJR IN DT CD NNPS WP VBD NNP IN CD CC VBD VBN TO VB RB DT JJ NN . NNP",
    "text": "-LRB- A country of about 6 million , Jordan has long had the world 's highest refugee population per capita , hosting more than a million Palestinians who fled Israel in 1948 and were supposed to stay only a short time . -RRB-"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "LOC",
        "index": [
          15,
          18
        ],
        "namedEntity": "West"
      },
      {
        "entity_type": "NORP",
        "index": [
          89,
          94
        ],
        "namedEntity": "Soviet"
      },
      {
        "entity_type": "PERSON",
        "index": [
          103,
          119
        ],
        "namedEntity": "Mikhail Gorbachev"
      },
      {
        "entity_type": "PERSON",
        "index": [
          184,
          197
        ],
        "namedEntity": "Hubert Vedrine"
      },
      {
        "entity_type": "PERSON",
        "index": [
          225,
          234
        ],
        "namedEntity": "Mitterrand"
      }
    ],
    "id": 12,
    "label_seq": "O O O O B-LOC O O O O O O O O O O O B-NORP O B-PERSON I-PERSON O O O O O O O O O O O B-PERSON I-PERSON O O O O O B-PERSON O",
    "pos_seq": "'' '' JJS IN DT NNP POS NNS VBP RB VBN IN PRP DT VBP FW : JJ NN NNP NNP POS NN IN JJ NN : TO VB , '' VBZ NNP NNP , NN NN IN NNP NNP",
    "text": "`` Most of the West 's leaders have finally concluded that we all want perestroika -LCB- Soviet leader Mikhail Gorbachev 's policy of economic restructuring -RCB- to succeed , '' says Hubert Vedrine , security adviser to Mr. Mitterrand ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          0,
          4
        ],
        "namedEntity": "Mazda"
      },
      {
        "entity_type": "ORG",
        "index": [
          10,
          13
        ],
        "namedEntity": "Ford"
      },
      {
        "entity_type": "ORG",
        "index": [
          130,
          136
        ],
        "namedEntity": "Mercury"
      },
      {
        "entity_type": "PRODUCT",
        "index": [
          138,
          144
        ],
        "namedEntity": "Tracers"
      },
      {
        "entity_type": "ORG",
        "index": [
          150,
          154
        ],
        "namedEntity": "Mazda"
      },
      {
        "entity_type": "PRODUCT",
        "index": [
          156,
          159
        ],
        "namedEntity": "323s"
      }
    ],
    "id": 13,
    "label_seq": "B-ORG O B-ORG O O O O O O O O O O O O O O O O O O B-ORG B-PRODUCT O B-ORG B-PRODUCT O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP CC NNP VBD DT NN IN JJ NN NN CC JJ NN MD VB NN NN IN DT IN DT NNP NNPS CC NNP NNS TO VB RBR RB IN JJ , VBG VBN NN NN CC VBN NN NN .",
    "text": "Mazda and Ford said a combination of limited crankcase ventilation and improper maintenance could cause engine oil in some of the Mercury Tracers and Mazda 323s to deteriorate more rapidly than normal , causing increased engine noise or reduced engine life ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "QUANTITY",
        "index": [
          124,
          128
        ],
        "namedEntity": "three"
      }
    ],
    "id": 14,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O B-QUANTITY O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NN VBZ IN IN JJ NNS EX VBD DT NNS TO VB NNS RB , RB IN DT NN VBD VBN IN DT NN , CD JJ NNS CC CD JJ NNS MD VB VBN TO VB DT NN RP RB .",
    "text": "The story goes that in ancient times there were no nails to seal coffins firmly , so after the lid was placed on a coffin , three horizontal boards and two vertical boards would be used to tie the coffin up tightly ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          25,
          35
        ],
        "namedEntity": "Interpublic"
      },
      {
        "entity_type": "ORG",
        "index": [
          48,
          54
        ],
        "namedEntity": "Saatchi"
      },
      {
        "entity_type": "DATE",
        "index": [
          59,
          64
        ],
        "namedEntity": "August"
      },
      {
        "entity_type": "ORG",
        "index": [
          83,
          106
        ],
        "namedEntity": "Campbell - Mithun - Esty"
      },
      {
        "entity_type": "PERSON",
        "index": [
          147,
          161
        ],
        "namedEntity": "Maurice Saatchi"
      }
    ],
    "id": 15,
    "label_seq": "O O O B-ORG O B-ORG O B-DATE O O O B-ORG I-ORG I-ORG I-ORG I-ORG O O O O O O O O B-PERSON I-PERSON O",
    "pos_seq": "NN NNS VBD NNP VBD NNP IN NNP IN VBG PRP$ NNP HYPH NNP HYPH NNP NN , CC VBD VBN RP IN NNP NNP NNP .",
    "text": "Industry executives said Interpublic approached Saatchi in August about buying its Campbell - Mithun - Esty unit , but was turned down by Chairman Maurice Saatchi ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "GPE",
        "index": [
          28,
          34
        ],
        "namedEntity": "Baghdad"
      },
      {
        "entity_type": "DATE",
        "index": [
          39,
          42
        ],
        "namedEntity": "2003"
      },
      {
        "entity_type": "PERSON",
        "index": [
          97,
          104
        ],
        "namedEntity": "Rumsfeld"
      },
      {
        "entity_type": "EVENT",
        "index": [
          242,
          244
        ],
        "namedEntity": "RMA"
      },
      {
        "entity_type": "PERSON",
        "index": [
          271,
          278
        ],
        "namedEntity": "Marshall"
      },
      {
        "entity_type": "DATE",
        "index": [
          349,
          356
        ],
        "namedEntity": "40 years"
      },
      {
        "entity_type": "NORP",
        "index": [
          361,
          362
        ],
        "namedEntity": "Ba"
      },
      {
        "entity_type": "NORP",
        "index": [
          426,
          433
        ],
        "namedEntity": "American"
      }
    ],
    "id": 16,
    "label_seq": "O O O O O B-GPE O B-DATE O O O O O O O O O O B-PERSON O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O B-EVENT O O O O O B-PERSON O O O O O O O O O O O O B-DATE I-DATE O B-NORP O O O O O O O O O O O O B-NORP O O O O O O O O O O O O O O O O O O",
    "pos_seq": "IN DT VBG NN IN NNP IN CD , NN IN DT VBG NN VBD TO VB IN NNP POS '' '' JJ '' NN VBD RB DT JJ CD , '' '' VBN '' IN NN RB : CC VBD JJ VB IN DT VBN JJ , JJ NN IN NNP CC DT RB HYPH VBN NNP VBD DT NN IN WRB RB JJ VBD DT NN IN VBG CD NNS IN NNP NN : WRB RB JJ VBD DT NN TO WDT RB JJ JJ NNS , RB JJ IN DT NN POS NN CC JJ JJ NNS , MD VB",
    "text": "In the exhilarating dash to Baghdad in 2003 , none of the admiring gallery seemed to notice that Rumsfeld 's `` new '' military was largely the old one , `` reformed '' in name only ; nor did many note that the vaunted lean , mean machine of RMA and the again - lionized Marshall had no grasp of how profoundly political was the act of overthrowing 40 years of Ba rule ; how deeply political was the campaign to which so many American lives , so much of the country 's material and symbolic national treasures , would be committed ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          74,
          80
        ],
        "namedEntity": "Noriega"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          99,
          105
        ],
        "namedEntity": "some 70"
      },
      {
        "entity_type": "GPE",
        "index": [
          157,
          160
        ],
        "namedEntity": "U.S."
      },
      {
        "entity_type": "GPE",
        "index": [
          219,
          229
        ],
        "namedEntity": "Panama City"
      }
    ],
    "id": 17,
    "label_seq": "O O O O O O O O O O O O O B-PERSON O O O O B-CARDINAL I-CARDINAL O O O O O O O O O O B-GPE O O O O O O O B-GPE I-GPE O",
    "pos_seq": "VBG IN NNS , VBG IN NNS IN NN CC NN , NNP NNP VBZ VBN IN NN DT CD IN PRP$ NNS VBN IN DT NN , VBG IN NNP NNS VBG NNS CC NN NNS IN NNP NNP .",
    "text": "Leaping into rages , sinking into bouts of drunkenness and mistrust , Mr. Noriega has put to death some 70 of his troops involved in the coup , according to U.S. officials monitoring crematoriums and funeral parlors in Panama City ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          4,
          8
        ],
        "namedEntity": "Boies"
      },
      {
        "entity_type": "ORDINAL",
        "index": [
          16,
          20
        ],
        "namedEntity": "first"
      },
      {
        "entity_type": "PERSON",
        "index": [
          40,
          45
        ],
        "namedEntity": "Vinson"
      }
    ],
    "id": 18,
    "label_seq": "O B-PERSON O O B-ORDINAL O O O O B-PERSON O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "NNP NNP , DT JJ NN TO VB NNP NNP POS NNS , VBZ IN NNS POS VBG JJ NN VBG RBS VBN IN FW FW NNP CC VBG RP JJ NN IN DT NNS .",
    "text": "Mr. Boies , the first lawyer to use Mr. Vinson 's services , cautions against courts ' allowing extensive jury questioning -LRB- known as voir dire -RRB- or giving out personal information about the jurors ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "NORP",
        "index": [
          144,
          149
        ],
        "namedEntity": "French"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          151,
          154
        ],
        "namedEntity": "half"
      }
    ],
    "id": 19,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O O O O O O O O O B-NORP B-CARDINAL O O O O O O O O",
    "pos_seq": "RB PRP VBD TO VB IN DT JJ NN IN NN WRB PRP VBD DT JJ NN IN VBG IN IN DT NN IN DT NN IN DT JJ NN IN PRP$ NN NN NN VBD RP .",
    "text": "Eventually we came to rest in a soggy patch of field where we had the exquisite pleasure of scrambling out of the basket into the mud while the French half of our ballooning tag team scrambled in ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          96,
          104
        ],
        "namedEntity": "Omnimedia"
      },
      {
        "entity_type": "PERSON",
        "index": [
          113,
          126
        ],
        "namedEntity": "Martha Stewart"
      }
    ],
    "id": 20,
    "label_seq": "O O O O O O O O O O O O O O O O O O O O B-ORG O O B-PERSON I-PERSON O",
    "pos_seq": "IN NNS IN DT NN , PRP RB VBP RB JJ TO VB NNS CC NNS , PRP VBP IN NNP , JJ NNP NNP .",
    "text": "Unlike stars of the past , they really are not content to be singers or dancers , they are like Omnimedia , mini Martha Stewart ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          14,
          18
        ],
        "namedEntity": "Eagle"
      },
      {
        "entity_type": "ORG",
        "index": [
          56,
          68
        ],
        "namedEntity": "Bankers Trust"
      },
      {
        "entity_type": "ORG",
        "index": [
          79,
          98
        ],
        "namedEntity": "Bank Leumi Trust Co."
      },
      {
        "entity_type": "GPE",
        "index": [
          103,
          110
        ],
        "namedEntity": "New York"
      },
      {
        "entity_type": "MONEY",
        "index": [
          116,
          126
        ],
        "namedEntity": "$ 8 million"
      },
      {
        "entity_type": "ORG",
        "index": [
          170,
          191
        ],
        "namedEntity": "First Century Partners"
      },
      {
        "entity_type": "ORG",
        "index": [
          197,
          200
        ],
        "namedEntity": "Biny"
      },
      {
        "entity_type": "MONEY",
        "index": [
          217,
          227
        ],
        "namedEntity": "$ 2 million"
      }
    ],
    "id": 21,
    "label_seq": "O O O O B-ORG O O O O O O B-ORG I-ORG O O B-ORG I-ORG I-ORG I-ORG O B-GPE I-GPE O B-MONEY I-MONEY I-MONEY O O O O O O O O B-ORG I-ORG I-ORG O B-ORG O O B-MONEY I-MONEY I-MONEY O",
    "pos_seq": "IN DT NN , NNP VBD DT JJ NN NN IN NNPS NNP CC IN NNP NNP NNP NNP IN NNP NNP IN $ CD CD , CC DT JJ JJ NN NN IN NNP NNP NNPS CC NNP NN IN $ CD CD .",
    "text": "At the time , Eagle reached a new credit agreement with Bankers Trust and with Bank Leumi Trust Co. of New York for $ 8 million , and a new subordinated debt accord with First Century Partners and Biny management for $ 2 million ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          4,
          8
        ],
        "namedEntity": "House"
      },
      {
        "entity_type": "DATE",
        "index": [
          62,
          66
        ],
        "namedEntity": "daily"
      },
      {
        "entity_type": "CARDINAL",
        "index": [
          86,
          90
        ],
        "namedEntity": "7,000"
      }
    ],
    "id": 22,
    "label_seq": "O B-ORG O O O O O O O O O B-DATE O O O B-CARDINAL O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT NNP POS NN MD VB JJ NN IN NNS IN JJ JJ NN IN CD NNS CC JJR , VBG DT VBN RB JJ TO VB IN DT JJ NN NN .",
    "text": "The House 's bill would prohibit dual trading in markets with daily average volume of 7,000 contracts or more , comprising those considered too difficult to track without a sophisticated computer system ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          12,
          20
        ],
        "namedEntity": "two dozen"
      },
      {
        "entity_type": "DATE",
        "index": [
          181,
          190
        ],
        "namedEntity": "last March"
      },
      {
        "entity_type": "PERSON",
        "index": [
          203,
          213
        ],
        "namedEntity": "Fleischmann"
      },
      {
        "entity_type": "PERSON",
        "index": [
          219,
          222
        ],
        "namedEntity": "Pons"
      }
    ],
    "id": 23,
    "label_seq": "O O O B-CARDINAL I-CARDINAL O O O O O O O O O O O O O O O O O O O O O O O B-DATE I-DATE O O B-PERSON O B-PERSON O",
    "pos_seq": "JJS IN DT CD NN NNS VBG DT NN VBD NNS IN JJ , RBR JJ NNS IN DT RB JJ NN HYPH IN HYPH NN NNS VBN JJ NNP IN NNP NNP CC NNP .",
    "text": "Most of the two dozen scientists taking the podium reported results with new , more sophisticated variations of the seemingly simple electrolysis - of - water experiments described last March by Messrs. Fleischmann and Pons ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          39,
          78
        ],
        "namedEntity": "anywhere from one - fourth to one - half"
      },
      {
        "entity_type": "ORG",
        "index": [
          188,
          195
        ],
        "namedEntity": "Medicaid"
      }
    ],
    "id": 24,
    "label_seq": "O O O O O O B-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL O O O O O O O O O O O O O O O O O O B-ORG O O",
    "pos_seq": "JJ NN VBZ RB VBN IN RB IN CD HYPH NN IN CD HYPH NN IN DT JJ JJ HYPH NN NN NNS VBP VBN TO VB PRP IN NN IN VBG IN NNP NN .",
    "text": "Conventional wisdom has long held that anywhere from one - fourth to one - half of all elderly long - term care patients are obliged to spend themselves into poverty before qualifying for Medicaid assistance ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          37,
          57
        ],
        "namedEntity": "Goldman , Sachs & Co."
      },
      {
        "entity_type": "ORG",
        "index": [
          67,
          79
        ],
        "namedEntity": "Fischer Black"
      }
    ],
    "id": 25,
    "label_seq": "O O O O O O O B-ORG I-ORG I-ORG I-ORG I-ORG O B-ORG I-ORG O O O O O O O O O O O O O O O O O O O O O O O O O O O O O O",
    "pos_seq": "DT JJ NN , IN VBN IN NNP , NNP CC NNP NN NNP NNP , VBZ IN NNS CC '' '' NNS '' JJ IN NNS CC NNS '' '' VBP DT JJ NN , CC IN NNS VBP PRP DT RBR JJ NN",
    "text": "The conventional view , as voiced by Goldman , Sachs & Co. partner Fischer Black , is that stocks and `` derivatives '' such as futures and options `` form a single market , and that derivatives make it a more liquid market . ''"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          46,
          51
        ],
        "namedEntity": "57,000"
      }
    ],
    "id": 26,
    "label_seq": "O O O O O O O O O B-CARDINAL O O O O O",
    "pos_seq": "RB , DT NN IN DT IN DT JJ CD NNS MD VB VBG .",
    "text": "However , the resolve of some of the striking 57,000 machinists might be weakening ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          37,
          39
        ],
        "namedEntity": "you"
      }
    ],
    "id": 27,
    "label_seq": "O O O O O O O O O B-CARDINAL O O O O O O O O",
    "pos_seq": "CC PRP VBD PRP$ NN UH PRP VBD RB VBG PRP RP TO VB DT JJ NN CC",
    "text": "And I told her %um I was n't setting you up to be a spiritual director or anything"
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "ORG",
        "index": [
          0,
          15
        ],
        "namedEntity": "PS New Hampshire"
      },
      {
        "entity_type": "PERSON",
        "index": [
          64,
          82
        ],
        "namedEntity": "United Illuminating"
      },
      {
        "entity_type": "MONEY",
        "index": [
          119,
          132
        ],
        "namedEntity": "$ 2.29 billion"
      }
    ],
    "id": 28,
    "label_seq": "B-ORG I-ORG I-ORG O O O O O O O O B-PERSON I-PERSON O O O O O O O B-MONEY I-MONEY I-MONEY O O O O O O O O",
    "pos_seq": "NNP NNP NNP VBD DT VBN NN IN DT NN , NNP NNP , WDT VBD PRP$ JJ NN IN $ CD CD , RB VBG DT NNS RB RB .",
    "text": "PS New Hampshire received a sweetened bid from another suitor , United Illuminating , which valued its new proposal at $ 2.29 billion , apparently topping all others so far ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "PERSON",
        "index": [
          12,
          19
        ],
        "namedEntity": "Thatcher"
      },
      {
        "entity_type": "DATE",
        "index": [
          61,
          69
        ],
        "namedEntity": "June 1992"
      },
      {
        "entity_type": "DATE",
        "index": [
          102,
          110
        ],
        "namedEntity": "late 1991"
      }
    ],
    "id": 29,
    "label_seq": "O O B-PERSON O O O O O O O O B-DATE I-DATE O O O O O O O B-DATE I-DATE O",
    "pos_seq": "NNP NNP NNP VBZ RB VB TO VB DT NN IN NNP CD , PRP MD VB VBG RB IN JJ CD .",
    "text": "Though Mrs. Thatcher does n't need to call an election until June 1992 , she would prefer doing so in late 1991 ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "LOC",
        "index": [
          64,
          75
        ],
        "namedEntity": "Persian Gulf"
      },
      {
        "entity_type": "LOC",
        "index": [
          81,
          92
        ],
        "namedEntity": "Indian Ocean"
      }
    ],
    "id": 30,
    "label_seq": "O O O O O O O O O O O B-LOC I-LOC O B-LOC I-LOC O",
    "pos_seq": "PRP VBD DT NNS NN IN DT JJ NNS IN DT NNP NNP CC NNP NNP .",
    "text": "He gave those bureaucrats charge of all naval operations in the Persian Gulf and Indian Ocean ."
  },
  {
    "dep_seq": "",
    "entities": [
      {
        "entity_type": "CARDINAL",
        "index": [
          22,
          57
        ],
        "namedEntity": "a hundred thirty nine thousand or so"
      },
      {
        "entity_type": "GPE",
        "index": [
          59,
          60
        ],
        "namedEntity": "US"
      },
      {
        "entity_type": "GPE",
        "index": [
          72,
          75
        ],
        "namedEntity": "Iraq"
      }
    ],
    "id": 31,
    "label_seq": "O O O O O B-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL I-CARDINAL B-GPE O O B-GPE O O O",
    "pos_seq": "IN PRP VBP EX VBP DT CD CD CD CD CC RB NNP NNS IN NNP RB RB .",
    "text": "As you know there are a hundred thirty nine thousand or so US troops in Iraq right now /."
  }
]